[
  {
    "id": "breakable",
    "sector": "ab03",
    "type": "breakable",
    "texture": "mineblock",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(mineblock)",
    "availableSwatches": [
      "mineblock",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3435.550048828125,
      -5136.00048828125,
      986.20703125
    ],
    "vertices": [
      [
        -3433.5,
        -5136.00048828125,
        981.70703125
      ],
      [
        -3433.5,
        -5136.00048828125,
        981.70703125
      ],
      [
        -3433.5,
        -5136.00048828125,
        990.70703125
      ],
      [
        -3433.5,
        -5136.00048828125,
        990.70703125
      ],
      [
        -3437.60009765625,
        -5136.00048828125,
        981.70703125
      ],
      [
        -3437.60009765625,
        -5136.00048828125,
        981.70703125
      ],
      [
        -3437.60009765625,
        -5136.00048828125,
        990.70703125
      ],
      [
        -3437.60009765625,
        -5136.00048828125,
        990.70703125
      ]
    ],
    "dimensions": [
      4.10009765625,
      0,
      9
    ],
    "dimensionsMeters": [
      0.21,
      0.15,
      0.45
    ],
    "maxDimensionMeters": 0.45,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable.glb"
  },
  {
    "id": "breakable_2",
    "sector": "ab03",
    "type": "breakable",
    "texture": "mineblock",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(mineblock)",
    "availableSwatches": [
      "mineblock",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3435.550048828125,
      -5104.50048828125,
      986.20703125
    ],
    "vertices": [
      [
        -3433.5,
        -5104.50048828125,
        981.70703125
      ],
      [
        -3433.5,
        -5104.50048828125,
        981.70703125
      ],
      [
        -3433.5,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3433.5,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3437.60009765625,
        -5104.50048828125,
        981.70703125
      ],
      [
        -3437.60009765625,
        -5104.50048828125,
        981.70703125
      ],
      [
        -3437.60009765625,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3437.60009765625,
        -5104.50048828125,
        990.70703125
      ]
    ],
    "dimensions": [
      4.10009765625,
      0,
      9
    ],
    "dimensionsMeters": [
      0.21,
      0.15,
      0.45
    ],
    "maxDimensionMeters": 0.45,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_2.glb"
  },
  {
    "id": "door_fdr1",
    "sector": "ab03",
    "type": "door",
    "texture": "cbasedoor1grn",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbasedoor1grn)",
    "availableSwatches": [
      "cbasedoor1grn",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: fdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3418,
      -5151.00048828125,
      986.70703125
    ],
    "vertices": [
      [
        -3418,
        -5154.00048828125,
        981.70703125
      ],
      [
        -3418,
        -5154.00048828125,
        981.70703125
      ],
      [
        -3418,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3418,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3418,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3418,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3418,
        -5148.00048828125,
        981.70703125
      ],
      [
        -3418,
        -5148.00048828125,
        981.70703125
      ]
    ],
    "dimensions": [
      0,
      6,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.3,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_fdr1.glb"
  },
  {
    "id": "door_fdr2",
    "sector": "ab03",
    "type": "door",
    "texture": "cbasedoor1grn",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbasedoor1grn)",
    "availableSwatches": [
      "cbasedoor1grn",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: fdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3435.550048828125,
      -5166.00048828125,
      986.70703125
    ],
    "vertices": [
      [
        -3439.10009765625,
        -5166.00048828125,
        981.70703125
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        981.70703125
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        991.70703125
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        991.70703125
      ],
      [
        -3432,
        -5166.00048828125,
        991.70703125
      ],
      [
        -3432,
        -5166.00048828125,
        991.70703125
      ],
      [
        -3432,
        -5166.00048828125,
        981.70703125
      ],
      [
        -3432,
        -5166.00048828125,
        981.70703125
      ]
    ],
    "dimensions": [
      7.10009765625,
      0,
      10
    ],
    "dimensionsMeters": [
      0.36,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_fdr2.glb"
  },
  {
    "id": "door_fdr3",
    "sector": "ab03",
    "type": "door",
    "texture": "cbasedoor1grn",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbasedoor1grn)",
    "availableSwatches": [
      "cbasedoor1grn",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: fdr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3453,
      -5151.00048828125,
      986.70703125
    ],
    "vertices": [
      [
        -3453,
        -5154.00048828125,
        981.70703125
      ],
      [
        -3453,
        -5154.00048828125,
        981.70703125
      ],
      [
        -3453,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3453,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3453,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3453,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3453,
        -5148.00048828125,
        981.70703125
      ],
      [
        -3453,
        -5148.00048828125,
        981.70703125
      ]
    ],
    "dimensions": [
      0,
      6,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.3,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_fdr3.glb"
  },
  {
    "id": "door_podelev2",
    "sector": "abmov",
    "type": "door",
    "texture": "baseelev1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.6
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(baseelev1)",
    "availableSwatches": [
      "baseelev1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: podelev2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3390,
      -4984.00048828125,
      1036.45703125
    ],
    "vertices": [
      [
        -3400,
        -4974.00048828125,
        1036.70703125
      ],
      [
        -3380,
        -4974.00048828125,
        1036.70703125
      ],
      [
        -3400,
        -4994.00048828125,
        1036.70703125
      ],
      [
        -3380,
        -4994.00048828125,
        1036.70703125
      ],
      [
        -3400,
        -4974.00048828125,
        1036.20703125
      ],
      [
        -3400,
        -4994.00048828125,
        1036.20703125
      ],
      [
        -3380,
        -4994.00048828125,
        1036.20703125
      ],
      [
        -3380,
        -4974.00048828125,
        1036.20703125
      ]
    ],
    "dimensions": [
      20,
      20,
      0.5
    ],
    "dimensionsMeters": [
      1,
      1,
      0.15
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_podelev2.glb"
  },
  {
    "id": "door_podrr2",
    "sector": "abmov",
    "type": "door",
    "texture": "cbasedoor1nopad",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbasedoor1nopad)",
    "availableSwatches": [
      "cbasedoor1nopad",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: podrr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3379,
      -4982.00048828125,
      1041.70703125
    ],
    "vertices": [
      [
        -3378,
        -4980.00048828125,
        1046.70703125
      ],
      [
        -3378,
        -4984.00048828125,
        1046.70703125
      ],
      [
        -3380,
        -4980.00048828125,
        1046.70703125
      ],
      [
        -3380,
        -4984.00048828125,
        1046.70703125
      ],
      [
        -3380,
        -4980.00048828125,
        1036.70703125
      ],
      [
        -3380,
        -4984.00048828125,
        1036.70703125
      ],
      [
        -3378,
        -4984.00048828125,
        1036.70703125
      ],
      [
        -3378,
        -4980.00048828125,
        1036.70703125
      ]
    ],
    "dimensions": [
      2,
      4,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.2,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_podrr2.glb"
  },
  {
    "id": "door_podrl2",
    "sector": "abmov",
    "type": "door",
    "texture": "cbasedoor1nopad",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbasedoor1nopad)",
    "availableSwatches": [
      "cbasedoor1nopad",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: podrl2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3379,
      -4985.99951171875,
      1041.70703125
    ],
    "vertices": [
      [
        -3380,
        -4987.99951171875,
        1046.70703125
      ],
      [
        -3380,
        -4983.99951171875,
        1046.70703125
      ],
      [
        -3380,
        -4983.99951171875,
        1036.70703125
      ],
      [
        -3380,
        -4987.99951171875,
        1036.70703125
      ],
      [
        -3378,
        -4983.99951171875,
        1046.70703125
      ],
      [
        -3378,
        -4983.99951171875,
        1036.70703125
      ],
      [
        -3378,
        -4987.99951171875,
        1046.70703125
      ],
      [
        -3378,
        -4987.99951171875,
        1036.70703125
      ]
    ],
    "dimensions": [
      2,
      4,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.2,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_podrl2.glb"
  },
  {
    "id": "door_dbdr",
    "sector": "abmov",
    "type": "door",
    "texture": "cbasedoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbasedoor1)",
    "availableSwatches": [
      "cbasedoor1",
      "basegatedoor",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: dbdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3306.5,
      -4972.00048828125,
      1071.2034912109375
    ],
    "vertices": [
      [
        -3305.5,
        -4967.00048828125,
        1064.699951171875
      ],
      [
        -3305.5,
        -4967.00048828125,
        1077.70703125
      ],
      [
        -3307.5,
        -4967.00048828125,
        1077.70703125
      ],
      [
        -3307.5,
        -4967.00048828125,
        1064.699951171875
      ],
      [
        -3307.5,
        -4977.00048828125,
        1077.70703125
      ],
      [
        -3305.5,
        -4977.00048828125,
        1077.70703125
      ],
      [
        -3305.5,
        -4977.00048828125,
        1064.699951171875
      ],
      [
        -3307.5,
        -4977.00048828125,
        1064.699951171875
      ]
    ],
    "dimensions": [
      2,
      10,
      13.007080078125
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_dbdr.glb"
  },
  {
    "id": "door_exitdr",
    "sector": "boiler",
    "type": "door",
    "texture": "slidedoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor1)",
    "availableSwatches": [
      "slidedoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: exitdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      430,
      1171.5,
      127.49948501586914
    ],
    "vertices": [
      [
        429.5,
        1166.5,
        120
      ],
      [
        429.5,
        1166.5,
        135
      ],
      [
        430.5,
        1176.5,
        120
      ],
      [
        430.5,
        1166.5,
        120
      ],
      [
        430.5,
        1166.5,
        135
      ],
      [
        430.5,
        1176.5,
        134.99794006347656
      ],
      [
        429.5,
        1176.5,
        120
      ],
      [
        429.5,
        1176.5,
        134.99794006347656
      ]
    ],
    "dimensions": [
      1,
      10,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_exitdr.glb"
  },
  {
    "id": "door_ring1a",
    "sector": "bs01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: ring1a",
    "sourceVertexCount": 20,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -4097.4908203125,
      -4598.5,
      1022.623828125
    ],
    "vertices": [
      [
        -4097.5107421875,
        -4597,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4597,
        1027.6240234375
      ],
      [
        -4087.021484375,
        -4597,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -4597,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1017.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1027.623779296875
      ],
      [
        -4097.5107421875,
        -4600,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4600,
        1027.6240234375
      ],
      [
        -4087.021484375,
        -4600,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -4600,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -4600,
        1017.623779296875
      ],
      [
        -4107.9501953125,
        -4600,
        1027.623779296875
      ],
      [
        -4107.9501953125,
        -4600,
        1032.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4597,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4600,
        1032.623779296875
      ],
      [
        -4107.9501953125,
        -4600,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1012.623779296875
      ],
      [
        -4087.021484375,
        -4597,
        1012.623779296875
      ],
      [
        -4087.021484375,
        -4600,
        1012.623779296875
      ]
    ],
    "dimensions": [
      20.9287109375,
      3,
      20
    ],
    "dimensionsMeters": [
      1.05,
      0.15,
      1
    ],
    "maxDimensionMeters": 1.05,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_ring1a.glb"
  },
  {
    "id": "door_ring2a",
    "sector": "bs01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: ring2a",
    "sourceVertexCount": 20,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -4097.4908203125,
      -4595.5,
      1022.623828125
    ],
    "vertices": [
      [
        -4097.5107421875,
        -4594,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4594,
        1027.6240234375
      ],
      [
        -4087.021484375,
        -4594,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -4594,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -4594,
        1017.623779296875
      ],
      [
        -4107.9501953125,
        -4594,
        1027.623779296875
      ],
      [
        -4097.5107421875,
        -4597,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4597,
        1027.6240234375
      ],
      [
        -4087.021484375,
        -4597,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -4597,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1017.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1027.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1032.623779296875
      ],
      [
        -4107.9501953125,
        -4594,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4594,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -4597,
        1032.623779296875
      ],
      [
        -4107.9501953125,
        -4597,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -4594,
        1012.623779296875
      ],
      [
        -4087.021484375,
        -4594,
        1012.623779296875
      ],
      [
        -4087.021484375,
        -4597,
        1012.623779296875
      ]
    ],
    "dimensions": [
      20.9287109375,
      3,
      20
    ],
    "dimensionsMeters": [
      1.05,
      0.15,
      1
    ],
    "maxDimensionMeters": 1.05,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_ring2a.glb"
  },
  {
    "id": "door_ring3a",
    "sector": "bs01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: ring3a",
    "sourceVertexCount": 20,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -4097.4908203125,
      -3956.375,
      1022.623828125
    ],
    "vertices": [
      [
        -4097.5107421875,
        -3954.875,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -3954.875,
        1027.6240234375
      ],
      [
        -4087.021484375,
        -3954.875,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -3954.875,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -3954.875,
        1017.623779296875
      ],
      [
        -4107.9501953125,
        -3954.875,
        1027.623779296875
      ],
      [
        -4097.5107421875,
        -3957.875,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -3957.875,
        1027.6240234375
      ],
      [
        -4087.021484375,
        -3957.875,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -3957.875,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -3957.875,
        1017.623779296875
      ],
      [
        -4107.9501953125,
        -3957.875,
        1027.623779296875
      ],
      [
        -4107.9501953125,
        -3957.875,
        1032.623779296875
      ],
      [
        -4107.9501953125,
        -3954.875,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -3954.875,
        1032.623779296875
      ],
      [
        -4087.021484375,
        -3957.875,
        1032.623779296875
      ],
      [
        -4107.9501953125,
        -3957.875,
        1012.623779296875
      ],
      [
        -4107.9501953125,
        -3954.875,
        1012.623779296875
      ],
      [
        -4087.021484375,
        -3954.875,
        1012.623779296875
      ],
      [
        -4087.021484375,
        -3957.875,
        1012.623779296875
      ]
    ],
    "dimensions": [
      20.9287109375,
      3,
      20
    ],
    "dimensionsMeters": [
      1.05,
      0.15,
      1
    ],
    "maxDimensionMeters": 1.05,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_ring3a.glb"
  },
  {
    "id": "door_field1",
    "sector": "bs01",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field1",
    "sourceVertexCount": 6,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -4097.510660807292,
      -4598.5,
      1022.6238606770834
    ],
    "vertices": [
      [
        -4097.5107421875,
        -4598.5,
        1032.623779296875
      ],
      [
        -4087.010498046875,
        -4598.5,
        1027.6240234375
      ],
      [
        -4087.010498046875,
        -4598.5,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -4598.5,
        1012.623779296875
      ],
      [
        -4108.0107421875,
        -4598.5,
        1017.623779296875
      ],
      [
        -4108.0107421875,
        -4598.5,
        1027.623779296875
      ]
    ],
    "dimensions": [
      21.000244140625,
      0,
      20
    ],
    "dimensionsMeters": [
      1.05,
      0.15,
      1
    ],
    "maxDimensionMeters": 1.05,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": null,
    "file": "props/door_field1.glb"
  },
  {
    "id": "door_field2",
    "sector": "bs01",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field2",
    "sourceVertexCount": 6,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -4097.510660807292,
      -4594.81103515625,
      1022.6238606770834
    ],
    "vertices": [
      [
        -4097.5107421875,
        -4594.81103515625,
        1032.623779296875
      ],
      [
        -4087.010498046875,
        -4594.81103515625,
        1027.6240234375
      ],
      [
        -4087.010498046875,
        -4594.81103515625,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -4594.81103515625,
        1012.623779296875
      ],
      [
        -4108.0107421875,
        -4594.81103515625,
        1017.623779296875
      ],
      [
        -4108.0107421875,
        -4594.81103515625,
        1027.623779296875
      ]
    ],
    "dimensions": [
      21.000244140625,
      0,
      20
    ],
    "dimensionsMeters": [
      1.05,
      0.15,
      1
    ],
    "maxDimensionMeters": 1.05,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": null,
    "file": "props/door_field2.glb"
  },
  {
    "id": "door_field3",
    "sector": "bs01",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field3",
    "sourceVertexCount": 6,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -4097.510660807292,
      -3956.375,
      1022.6238606770834
    ],
    "vertices": [
      [
        -4097.5107421875,
        -3956.375,
        1032.623779296875
      ],
      [
        -4087.010498046875,
        -3956.375,
        1027.6240234375
      ],
      [
        -4087.010498046875,
        -3956.375,
        1017.6240234375
      ],
      [
        -4097.5107421875,
        -3956.375,
        1012.623779296875
      ],
      [
        -4108.0107421875,
        -3956.375,
        1017.623779296875
      ],
      [
        -4108.0107421875,
        -3956.375,
        1027.623779296875
      ]
    ],
    "dimensions": [
      21.000244140625,
      0,
      20
    ],
    "dimensionsMeters": [
      1.05,
      0.15,
      1
    ],
    "maxDimensionMeters": 1.05,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": null,
    "file": "props/door_field3.glb"
  },
  {
    "id": "door_wtcharge",
    "sector": "bs02",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: wtcharge",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3275,
      -4267.8759765625,
      1100
    ],
    "vertices": [
      [
        -3276.5,
        -4267.8759765625,
        1099
      ],
      [
        -3276.5,
        -4267.8759765625,
        1101
      ],
      [
        -3273.5,
        -4267.8759765625,
        1101
      ],
      [
        -3273.5,
        -4267.8759765625,
        1099
      ]
    ],
    "dimensions": [
      3,
      0,
      2
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_wtcharge.glb"
  },
  {
    "id": "door_door11",
    "sector": "bs0206mv",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: door11",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3097.5001831054688,
      -4411.41845703125,
      1044.3118896484375
    ],
    "vertices": [
      [
        -3092.499755859375,
        -4410.7685546875,
        1038.623779296875
      ],
      [
        -3102.499755859375,
        -4410.7685546875,
        1038.623779296875
      ],
      [
        -3092.50146484375,
        -4410.7685546875,
        1050
      ],
      [
        -3102.499755859375,
        -4410.7685546875,
        1050
      ],
      [
        -3092.50146484375,
        -4412.068359375,
        1050
      ],
      [
        -3092.499755859375,
        -4412.068359375,
        1038.623779296875
      ],
      [
        -3102.499755859375,
        -4412.068359375,
        1038.623779296875
      ],
      [
        -3102.499755859375,
        -4412.068359375,
        1050
      ]
    ],
    "dimensions": [
      10,
      1.2998046875,
      11.376220703125
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.57
    ],
    "maxDimensionMeters": 0.57,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_door11.glb"
  },
  {
    "id": "door_eledor2a",
    "sector": "bs03",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: eledor2a",
    "sourceVertexCount": 12,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3336.5,
      -4228.333333333333,
      1081.5999755859375
    ],
    "vertices": [
      [
        -3337,
        -4225,
        1076.5999755859375
      ],
      [
        -3337,
        -4225,
        1086.5999755859375
      ],
      [
        -3336,
        -4225,
        1086.5999755859375
      ],
      [
        -3336,
        -4225,
        1076.5999755859375
      ],
      [
        -3337,
        -4230,
        1076.5999755859375
      ],
      [
        -3337,
        -4230,
        1076.5999755859375
      ],
      [
        -3337,
        -4230,
        1086.5999755859375
      ],
      [
        -3337,
        -4230,
        1086.5999755859375
      ],
      [
        -3336,
        -4230,
        1086.5999755859375
      ],
      [
        -3336,
        -4230,
        1086.5999755859375
      ],
      [
        -3336,
        -4230,
        1076.5999755859375
      ],
      [
        -3336,
        -4230,
        1076.5999755859375
      ]
    ],
    "dimensions": [
      1,
      5,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_eledor2a.glb"
  },
  {
    "id": "door_eledor2b",
    "sector": "bs03",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: eledor2b",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3336.5,
      -4232.5,
      1081.5999755859375
    ],
    "vertices": [
      [
        -3337,
        -4235,
        1076.5999755859375
      ],
      [
        -3337,
        -4235,
        1086.5999755859375
      ],
      [
        -3336,
        -4235,
        1076.5999755859375
      ],
      [
        -3336,
        -4235,
        1086.5999755859375
      ],
      [
        -3337,
        -4230,
        1076.5999755859375
      ],
      [
        -3337,
        -4230,
        1086.5999755859375
      ],
      [
        -3336,
        -4230,
        1086.5999755859375
      ],
      [
        -3336,
        -4230,
        1076.5999755859375
      ]
    ],
    "dimensions": [
      1,
      5,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_eledor2b.glb"
  },
  {
    "id": "door_eledor1a",
    "sector": "bs03",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: eledor1a",
    "sourceVertexCount": 12,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3336.5,
      -4228.333333333333,
      1057.5499877929688
    ],
    "vertices": [
      [
        -3337,
        -4225,
        1052.5999755859375
      ],
      [
        -3337,
        -4225,
        1062.5
      ],
      [
        -3336,
        -4225,
        1062.5
      ],
      [
        -3336,
        -4225,
        1052.5999755859375
      ],
      [
        -3337,
        -4230,
        1052.5999755859375
      ],
      [
        -3337,
        -4230,
        1052.5999755859375
      ],
      [
        -3337,
        -4230,
        1062.5
      ],
      [
        -3337,
        -4230,
        1062.5
      ],
      [
        -3336,
        -4230,
        1062.5
      ],
      [
        -3336,
        -4230,
        1062.5
      ],
      [
        -3336,
        -4230,
        1052.5999755859375
      ],
      [
        -3336,
        -4230,
        1052.5999755859375
      ]
    ],
    "dimensions": [
      1,
      5,
      9.9000244140625
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_eledor1a.glb"
  },
  {
    "id": "door_eledor1b",
    "sector": "bs03",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: eledor1b",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3336.5,
      -4232.5,
      1057.5499877929688
    ],
    "vertices": [
      [
        -3337,
        -4235,
        1052.5999755859375
      ],
      [
        -3337,
        -4235,
        1062.5
      ],
      [
        -3336,
        -4235,
        1052.5999755859375
      ],
      [
        -3336,
        -4235,
        1062.5
      ],
      [
        -3337,
        -4230,
        1052.5999755859375
      ],
      [
        -3337,
        -4230,
        1062.5
      ],
      [
        -3336,
        -4230,
        1062.5
      ],
      [
        -3336,
        -4230,
        1052.5999755859375
      ]
    ],
    "dimensions": [
      1,
      5,
      9.9000244140625
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_eledor1b.glb"
  },
  {
    "id": "door_nmvplat1",
    "sector": "bs03",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: nmvplat1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3129.5,
      -3897.5,
      1076
    ],
    "vertices": [
      [
        -3109,
        -3887,
        1076.5
      ],
      [
        -3109,
        -3908,
        1076.5
      ],
      [
        -3150,
        -3887,
        1075.5
      ],
      [
        -3150,
        -3887,
        1076.5
      ],
      [
        -3150,
        -3908,
        1076.5
      ],
      [
        -3150,
        -3908,
        1075.5
      ],
      [
        -3109,
        -3908,
        1075.5
      ],
      [
        -3109,
        -3887,
        1075.5
      ]
    ],
    "dimensions": [
      41,
      21,
      1
    ],
    "dimensionsMeters": [
      2.05,
      1.05,
      0.15
    ],
    "maxDimensionMeters": 2.05,
    "pedestalFitScale": 0.78,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_nmvplat1.glb"
  },
  {
    "id": "breakable_bs0304mv",
    "sector": "bs0304mv",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3012,
      -3923.6031494140625,
      1060.123779296875
    ],
    "vertices": [
      [
        -3026,
        -3925.124267578125,
        1052.623779296875
      ],
      [
        -3026,
        -3925.124267578125,
        1067.623779296875
      ],
      [
        -2998,
        -3922.08203125,
        1067.623779296875
      ],
      [
        -2998,
        -3922.08203125,
        1052.623779296875
      ]
    ],
    "dimensions": [
      28,
      3.042236328125,
      15
    ],
    "dimensionsMeters": [
      1.4,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 1.4,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0.108,
      -0.9941,
      0
    ],
    "file": "props/breakable_bs0304mv.glb"
  },
  {
    "id": "breakable_2_bs0304mv",
    "sector": "bs0304mv",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3140,
      -3955,
      1089.0119018554688
    ],
    "vertices": [
      [
        -3140,
        -3951,
        1082.623779296875
      ],
      [
        -3140,
        -3959,
        1082.623779296875
      ],
      [
        -3140,
        -3951,
        1095.4000244140625
      ],
      [
        -3140,
        -3959,
        1095.4000244140625
      ]
    ],
    "dimensions": [
      0,
      8,
      12.7762451171875
    ],
    "dimensionsMeters": [
      0.15,
      0.4,
      0.64
    ],
    "maxDimensionMeters": 0.64,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/breakable_2_bs0304mv.glb"
  },
  {
    "id": "breakable_bs0405mv",
    "sector": "bs0405mv",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2902,
      -4247.66796875,
      1058.3118896484375
    ],
    "vertices": [
      [
        -2910,
        -4247.66796875,
        1052.623779296875
      ],
      [
        -2910,
        -4247.66796875,
        1064
      ],
      [
        -2894,
        -4247.66796875,
        1064
      ],
      [
        -2894,
        -4247.66796875,
        1052.623779296875
      ]
    ],
    "dimensions": [
      16,
      0,
      11.376220703125
    ],
    "dimensionsMeters": [
      0.8,
      0.15,
      0.57
    ],
    "maxDimensionMeters": 0.8,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/breakable_bs0405mv.glb"
  },
  {
    "id": "door_eledor4a",
    "sector": "bs05",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: eledor4a",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2613.1324462890625,
      -4022.4896240234375,
      1107.123779296875
    ],
    "vertices": [
      [
        -2608.55224609375,
        -4024.556640625,
        1112.623779296875
      ],
      [
        -2608.55224609375,
        -4024.556640625,
        1101.623779296875
      ],
      [
        -2617.212646484375,
        -4019.556640625,
        1101.623779296875
      ],
      [
        -2617.212646484375,
        -4019.556640625,
        1112.623779296875
      ],
      [
        -2617.712646484375,
        -4020.422607421875,
        1112.623779296875
      ],
      [
        -2609.05224609375,
        -4025.422607421875,
        1112.623779296875
      ],
      [
        -2609.05224609375,
        -4025.422607421875,
        1101.623779296875
      ],
      [
        -2617.712646484375,
        -4020.422607421875,
        1101.623779296875
      ]
    ],
    "dimensions": [
      9.160400390625,
      5.865966796875,
      11
    ],
    "dimensionsMeters": [
      0.46,
      0.29,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0.5,
      0.866,
      0
    ],
    "file": "props/door_eledor4a.glb"
  },
  {
    "id": "door_door12",
    "sector": "bs06",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: door12",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2868.999755859375,
      -4419.83251953125,
      1058.873779296875
    ],
    "vertices": [
      [
        -2869.499755859375,
        -4439.83251953125,
        1065.123779296875
      ],
      [
        -2869.499755859375,
        -4439.83251953125,
        1052.623779296875
      ],
      [
        -2869.499755859375,
        -4399.83251953125,
        1052.623779296875
      ],
      [
        -2869.499755859375,
        -4399.83251953125,
        1065.123779296875
      ],
      [
        -2868.499755859375,
        -4439.83251953125,
        1065.123779296875
      ],
      [
        -2868.499755859375,
        -4439.83251953125,
        1052.623779296875
      ],
      [
        -2868.499755859375,
        -4399.83251953125,
        1052.623779296875
      ],
      [
        -2868.499755859375,
        -4399.83251953125,
        1065.123779296875
      ]
    ],
    "dimensions": [
      1,
      40,
      12.5
    ],
    "dimensionsMeters": [
      0.15,
      2,
      0.63
    ],
    "maxDimensionMeters": 2,
    "pedestalFitScale": 0.8,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_door12.glb"
  },
  {
    "id": "breakable_bs06",
    "sector": "bs06",
    "type": "breakable",
    "texture": "warehouswin-m",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(warehouswin-m)",
    "availableSwatches": [
      "warehouswin-m",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 24,
    "exportedTriangleCount": 14,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2748.499755859375,
      -4836.7685546875,
      1087.623779296875
    ],
    "vertices": [
      [
        -2748.499755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4816.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4816.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4826.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4826.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4856.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4856.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4846.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4846.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4846.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4846.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4841.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4841.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4831.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4831.7685546875,
        1092.623779296875
      ],
      [
        -2748.499755859375,
        -4831.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4831.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4841.7685546875,
        1082.623779296875
      ],
      [
        -2748.499755859375,
        -4841.7685546875,
        1082.623779296875
      ]
    ],
    "dimensions": [
      0,
      40,
      10
    ],
    "dimensionsMeters": [
      0.15,
      2,
      0.5
    ],
    "maxDimensionMeters": 2,
    "pedestalFitScale": 0.8,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/breakable_bs06.glb"
  },
  {
    "id": "breakable_bs0607mv",
    "sector": "bs0607mv",
    "type": "breakable",
    "texture": "warehouswin-m",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(warehouswin-m)",
    "availableSwatches": [
      "warehouswin-m",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2709.999755859375,
      -4371.7685546875,
      1104.623779296875
    ],
    "vertices": [
      [
        -2699.999755859375,
        -4371.7685546875,
        1096.623779296875
      ],
      [
        -2699.999755859375,
        -4371.7685546875,
        1096.623779296875
      ],
      [
        -2719.999755859375,
        -4371.7685546875,
        1096.623779296875
      ],
      [
        -2719.999755859375,
        -4371.7685546875,
        1096.623779296875
      ],
      [
        -2719.999755859375,
        -4371.7685546875,
        1112.623779296875
      ],
      [
        -2719.999755859375,
        -4371.7685546875,
        1112.623779296875
      ],
      [
        -2699.999755859375,
        -4371.7685546875,
        1112.623779296875
      ],
      [
        -2699.999755859375,
        -4371.7685546875,
        1112.623779296875
      ]
    ],
    "dimensions": [
      20,
      0,
      16
    ],
    "dimensionsMeters": [
      1,
      0.15,
      0.8
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/breakable_bs0607mv.glb"
  },
  {
    "id": "breakable_bs07",
    "sector": "bs07",
    "type": "breakable",
    "texture": "basegrass",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(basegrass)",
    "availableSwatches": [
      "basegrass",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2289.999755859375,
      -4444.7685546875,
      1064.623779296875
    ],
    "vertices": [
      [
        -2279.999755859375,
        -4439.7685546875,
        1064.623779296875
      ],
      [
        -2279.999755859375,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2299.999755859375,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2299.999755859375,
        -4439.7685546875,
        1064.623779296875
      ]
    ],
    "dimensions": [
      20,
      10,
      0
    ],
    "dimensionsMeters": [
      1,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_bs07.glb"
  },
  {
    "id": "breakable_2_bs07",
    "sector": "bs07",
    "type": "breakable",
    "texture": "warehouswin-m",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(warehouswin-m)",
    "availableSwatches": [
      "warehouswin-m",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2709.999755859375,
      -4321.2685546875,
      1104.623779296875
    ],
    "vertices": [
      [
        -2699.999755859375,
        -4321.2685546875,
        1096.623779296875
      ],
      [
        -2699.999755859375,
        -4321.2685546875,
        1096.623779296875
      ],
      [
        -2719.999755859375,
        -4321.2685546875,
        1096.623779296875
      ],
      [
        -2719.999755859375,
        -4321.2685546875,
        1096.623779296875
      ],
      [
        -2719.999755859375,
        -4321.2685546875,
        1112.623779296875
      ],
      [
        -2719.999755859375,
        -4321.2685546875,
        1112.623779296875
      ],
      [
        -2699.999755859375,
        -4321.2685546875,
        1112.623779296875
      ],
      [
        -2699.999755859375,
        -4321.2685546875,
        1112.623779296875
      ]
    ],
    "dimensions": [
      20,
      0,
      16
    ],
    "dimensionsMeters": [
      1,
      0.15,
      0.8
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/breakable_2_bs07.glb"
  },
  {
    "id": "door_rechrg",
    "sector": "bs07",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rechrg",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2339.899658203125,
      -4310.2685546875,
      1057.623779296875
    ],
    "vertices": [
      [
        -2339.899658203125,
        -4311.7685546875,
        1055.623779296875
      ],
      [
        -2339.899658203125,
        -4308.7685546875,
        1059.623779296875
      ],
      [
        -2339.899658203125,
        -4311.7685546875,
        1059.623779296875
      ],
      [
        -2339.899658203125,
        -4308.7685546875,
        1055.623779296875
      ]
    ],
    "dimensions": [
      0,
      3,
      4
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.2
    ],
    "maxDimensionMeters": 0.2,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_rechrg.glb"
  },
  {
    "id": "door_eledor3a",
    "sector": "bs07",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: eledor3a",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2611.2998046875,
      -4504.7685546875,
      1037.6119384765625
    ],
    "vertices": [
      [
        -2610.7998046875,
        -4499.7685546875,
        1042.5999755859375
      ],
      [
        -2610.7998046875,
        -4499.7685546875,
        1032.6239013671875
      ],
      [
        -2610.7998046875,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2610.7998046875,
        -4509.7685546875,
        1032.6239013671875
      ],
      [
        -2611.7998046875,
        -4499.7685546875,
        1032.6239013671875
      ],
      [
        -2611.7998046875,
        -4499.7685546875,
        1042.5999755859375
      ],
      [
        -2611.7998046875,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2611.7998046875,
        -4509.7685546875,
        1032.6239013671875
      ]
    ],
    "dimensions": [
      1,
      10,
      9.97607421875
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_eledor3a.glb"
  },
  {
    "id": "breakable_3",
    "sector": "bs07",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2619.999755859375,
      -4497.7685546875,
      1045.0999755859375
    ],
    "vertices": [
      [
        -2614.999755859375,
        -4497.7685546875,
        1047.5999755859375
      ],
      [
        -2614.999755859375,
        -4497.7685546875,
        1047.5999755859375
      ],
      [
        -2614.999755859375,
        -4497.7685546875,
        1042.5999755859375
      ],
      [
        -2614.999755859375,
        -4497.7685546875,
        1042.5999755859375
      ],
      [
        -2624.999755859375,
        -4497.7685546875,
        1042.5999755859375
      ],
      [
        -2624.999755859375,
        -4497.7685546875,
        1042.5999755859375
      ],
      [
        -2624.999755859375,
        -4497.7685546875,
        1047.5999755859375
      ],
      [
        -2624.999755859375,
        -4497.7685546875,
        1047.5999755859375
      ]
    ],
    "dimensions": [
      10,
      0,
      5
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.25
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_3.glb"
  },
  {
    "id": "breakable_4",
    "sector": "bs07",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2667.4998168945312,
      -4367.7685546875,
      1052.623779296875
    ],
    "vertices": [
      [
        -2654.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2679.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2679.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2679.999755859375,
        -4362.7685546875,
        1052.623779296875
      ],
      [
        -2679.999755859375,
        -4362.7685546875,
        1052.623779296875
      ],
      [
        -2655,
        -4362.7685546875,
        1052.623779296875
      ],
      [
        -2655,
        -4362.7685546875,
        1052.623779296875
      ]
    ],
    "dimensions": [
      25,
      10,
      0
    ],
    "dimensionsMeters": [
      1.25,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 1.25,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/breakable_4.glb"
  },
  {
    "id": "breakable_5",
    "sector": "bs07",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2620,
      -4449.16845703125,
      1097.3118896484375
    ],
    "vertices": [
      [
        -2625,
        -4449.16845703125,
        1092.623779296875
      ],
      [
        -2625,
        -4449.16845703125,
        1102
      ],
      [
        -2615,
        -4449.16845703125,
        1102
      ],
      [
        -2615,
        -4449.16845703125,
        1092.623779296875
      ]
    ],
    "dimensions": [
      10,
      0,
      9.376220703125
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.47
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_5.glb"
  },
  {
    "id": "breakable_6",
    "sector": "bs07",
    "type": "breakable",
    "texture": "warehous2-d",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(warehous2-d)",
    "availableSwatches": [
      "warehous2-d",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2619.999755859375,
      -4504.7685546875,
      1097.623779296875
    ],
    "vertices": [
      [
        -2614.999755859375,
        -4509.7685546875,
        1097.623779296875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1097.623779296875
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1097.623779296875
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1097.623779296875
      ]
    ],
    "dimensions": [
      10,
      10,
      0
    ],
    "dimensionsMeters": [
      0.5,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_6.glb"
  },
  {
    "id": "unknown_C:\\editor\\simpleLW.lwo",
    "sector": "city1",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "C:\\editor\\simpleLW.lwo",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -350,
      -50,
      -1300
    ],
    "vertices": [
      [
        -500,
        -100,
        -1300
      ],
      [
        -200,
        0,
        -1300
      ],
      [
        -500,
        0,
        -1300
      ],
      [
        -200,
        -100,
        -1300
      ]
    ],
    "dimensions": [
      300,
      100,
      0
    ],
    "dimensionsMeters": [
      15,
      5,
      0.15
    ],
    "maxDimensionMeters": 15,
    "pedestalFitScale": 0.107,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/unknown_C:\\editor\\simpleLW.lwo.glb"
  },
  {
    "id": "door_celedor1",
    "sector": "citymov",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: celedor1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -297.5,
      531.5,
      90
    ],
    "vertices": [
      [
        -290,
        530,
        100
      ],
      [
        -305,
        530,
        100
      ],
      [
        -305,
        530,
        80
      ],
      [
        -290,
        530,
        80
      ],
      [
        -305,
        533,
        80
      ],
      [
        -290,
        533,
        80
      ],
      [
        -305,
        533,
        100
      ],
      [
        -290,
        533,
        100
      ]
    ],
    "dimensions": [
      15,
      3,
      20
    ],
    "dimensionsMeters": [
      0.75,
      0.15,
      1
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_celedor1.glb"
  },
  {
    "id": "door_celedor2",
    "sector": "citymov",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: celedor2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -297.5,
      535.75,
      155
    ],
    "vertices": [
      [
        -305,
        535,
        145
      ],
      [
        -290,
        535,
        145
      ],
      [
        -290,
        535,
        165
      ],
      [
        -305,
        535,
        165
      ],
      [
        -290,
        536.5,
        165
      ],
      [
        -290,
        536.5,
        145
      ],
      [
        -305,
        536.5,
        145
      ],
      [
        -305,
        536.5,
        165
      ]
    ],
    "dimensions": [
      15,
      1.5,
      20
    ],
    "dimensionsMeters": [
      0.75,
      0.15,
      1
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_celedor2.glb"
  },
  {
    "id": "door_puzzdr",
    "sector": "citymov",
    "type": "door",
    "texture": "slidedoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor1)",
    "availableSwatches": [
      "slidedoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: puzzdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      439.5,
      990,
      127.5
    ],
    "vertices": [
      [
        440,
        995,
        135
      ],
      [
        440,
        995,
        120
      ],
      [
        440,
        985,
        120
      ],
      [
        440,
        985,
        135
      ],
      [
        439,
        995,
        135
      ],
      [
        439,
        985,
        135
      ],
      [
        439,
        985,
        120
      ],
      [
        439,
        995,
        120
      ]
    ],
    "dimensions": [
      1,
      10,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_puzzdr.glb"
  },
  {
    "id": "door_secdr2",
    "sector": "db01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: secdr2",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3140.25,
      -5169.25,
      1095.5
    ],
    "vertices": [
      [
        -3158,
        -5184.5,
        1089.5
      ],
      [
        -3158,
        -5184.5,
        1089.5
      ],
      [
        -3082,
        -5184.5,
        1101.5
      ],
      [
        -3082,
        -5184.5,
        1101.5
      ],
      [
        -3082,
        -5184.5,
        1089.5
      ],
      [
        -3082,
        -5184.5,
        1089.5
      ],
      [
        -3158,
        -5184.5,
        1101.5
      ],
      [
        -3158,
        -5184.5,
        1101.5
      ],
      [
        -3160.5,
        -5182,
        1089.5
      ],
      [
        -3160.5,
        -5182,
        1089.5
      ],
      [
        -3160.5,
        -5126,
        1101.5
      ],
      [
        -3160.5,
        -5126,
        1101.5
      ],
      [
        -3160.5,
        -5182,
        1101.5
      ],
      [
        -3160.5,
        -5182,
        1101.5
      ],
      [
        -3160.5,
        -5126,
        1089.5
      ],
      [
        -3160.5,
        -5126,
        1089.5
      ]
    ],
    "dimensions": [
      78.5,
      58.5,
      12
    ],
    "dimensionsMeters": [
      3.93,
      2.93,
      0.6
    ],
    "maxDimensionMeters": 3.93,
    "pedestalFitScale": 0.407,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_secdr2.glb"
  },
  {
    "id": "door_elev2dr1",
    "sector": "db01",
    "type": "door",
    "texture": "cbaseelevdoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevdoor)",
    "availableSwatches": [
      "cbaseelevdoor",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2890,
      -5175,
      972.5
    ],
    "vertices": [
      [
        -2880,
        -5174,
        965
      ],
      [
        -2880,
        -5174,
        980
      ],
      [
        -2880,
        -5176,
        965
      ],
      [
        -2880,
        -5176,
        980
      ],
      [
        -2900,
        -5174,
        965
      ],
      [
        -2900,
        -5174,
        980
      ],
      [
        -2900,
        -5176,
        980
      ],
      [
        -2900,
        -5176,
        965
      ]
    ],
    "dimensions": [
      20,
      2,
      15
    ],
    "dimensionsMeters": [
      1,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_elev2dr1.glb"
  },
  {
    "id": "door_elev2dr2",
    "sector": "db01",
    "type": "door",
    "texture": "cbaseelevdoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevdoor)",
    "availableSwatches": [
      "cbaseelevdoor",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2900.5,
      -5185,
      1067.5
    ],
    "vertices": [
      [
        -2900,
        -5176,
        1060
      ],
      [
        -2900,
        -5176,
        1075
      ],
      [
        -2901,
        -5176,
        1060
      ],
      [
        -2901,
        -5176,
        1075
      ],
      [
        -2900,
        -5194,
        1075
      ],
      [
        -2900,
        -5194,
        1060
      ],
      [
        -2901,
        -5194,
        1060
      ],
      [
        -2901,
        -5194,
        1075
      ]
    ],
    "dimensions": [
      1,
      18,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.9,
      0.75
    ],
    "maxDimensionMeters": 0.9,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_elev2dr2.glb"
  },
  {
    "id": "door_secdr1",
    "sector": "db01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: secdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3306.5,
      -4893,
      1071.199951171875
    ],
    "vertices": [
      [
        -3306.5,
        -4888,
        1064.699951171875
      ],
      [
        -3306.5,
        -4888,
        1064.699951171875
      ],
      [
        -3306.5,
        -4888,
        1077.699951171875
      ],
      [
        -3306.5,
        -4888,
        1077.699951171875
      ],
      [
        -3306.5,
        -4898,
        1077.699951171875
      ],
      [
        -3306.5,
        -4898,
        1077.699951171875
      ],
      [
        -3306.5,
        -4898,
        1064.699951171875
      ],
      [
        -3306.5,
        -4898,
        1064.699951171875
      ]
    ],
    "dimensions": [
      0,
      10,
      13
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_secdr1.glb"
  },
  {
    "id": "door_elec",
    "sector": "db01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elec",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3087.5,
      -4990,
      973
    ],
    "vertices": [
      [
        -3195,
        -4976,
        973
      ],
      [
        -2980,
        -4976,
        973
      ],
      [
        -2980,
        -5004,
        973
      ],
      [
        -3195,
        -5004,
        973
      ]
    ],
    "dimensions": [
      215,
      28,
      0
    ],
    "dimensionsMeters": [
      10.75,
      1.4,
      0.15
    ],
    "maxDimensionMeters": 10.75,
    "pedestalFitScale": 0.149,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_elec.glb"
  },
  {
    "id": "elevator_elv",
    "sector": "db01",
    "type": "elevator",
    "texture": "cbaseelevpaneldown",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpaneldown)",
    "availableSwatches": [
      "cbaseelevpaneldown",
      "baseelev1",
      "cbaseelevdoor",
      "cbaseelevpanelup",
      "elevatorlight1",
      "elevatorlight1out",
      "elevatorpanel2",
      "elevatorshaft",
      "elevatorshaftout",
      "emielevstripe_h",
      "gcelevtrak_h",
      "hangelevswitch",
      "hospelevdoor",
      "hotelevbut_h",
      "hotelevout_h",
      "hotelevpaneldown",
      "hotelevpanelup",
      "hotvaselev_h",
      "mineelevpanelup",
      "minepipelev",
      "reselevshaft",
      "spkelevdoor1",
      "spkelevfloor1"
    ],
    "tag": "CElevator piece: elv",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 18,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2975,
      -5156.699951171875,
      981.4000244140625
    ],
    "vertices": [
      [
        -2979,
        -5159,
        980
      ],
      [
        -2979,
        -5150,
        980.550048828125
      ],
      [
        -2979,
        -5159,
        980.550048828125
      ],
      [
        -2979,
        -5150,
        980
      ],
      [
        -2969,
        -5159,
        980
      ],
      [
        -2969,
        -5150,
        980.550048828125
      ],
      [
        -2969,
        -5159,
        980.550048828125
      ],
      [
        -2969,
        -5150,
        980
      ],
      [
        -2977,
        -5158.89990234375,
        980.550048828125
      ],
      [
        -2976,
        -5158.89990234375,
        984.5
      ],
      [
        -2976,
        -5158.89990234375,
        980.550048828125
      ],
      [
        -2977,
        -5158.89990234375,
        984.5
      ],
      [
        -2975,
        -5158.89990234375,
        980.550048828125
      ],
      [
        -2976,
        -5158.89990234375,
        980.550048828125
      ],
      [
        -2976,
        -5158.89990234375,
        984.5
      ],
      [
        -2975,
        -5158.89990234375,
        984.5
      ]
    ],
    "dimensions": [
      10,
      9,
      4.5
    ],
    "dimensionsMeters": [
      0.5,
      0.45,
      0.23
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/elevator_elv.glb"
  },
  {
    "id": "door_secretdr",
    "sector": "db01",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: secretdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3059.5,
      -5114,
      985
    ],
    "vertices": [
      [
        -3060,
        -5119,
        980
      ],
      [
        -3060,
        -5109,
        990
      ],
      [
        -3060,
        -5119,
        990
      ],
      [
        -3060,
        -5109,
        980
      ],
      [
        -3059,
        -5119,
        980
      ],
      [
        -3059,
        -5119,
        990
      ],
      [
        -3059,
        -5109,
        990
      ],
      [
        -3059,
        -5109,
        980
      ]
    ],
    "dimensions": [
      1,
      10,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_secretdr.glb"
  },
  {
    "id": "door_rech",
    "sector": "db01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rech",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3088.900146484375,
      -5128.75,
      1106
    ],
    "vertices": [
      [
        -3088.900146484375,
        -5130,
        1105
      ],
      [
        -3088.900146484375,
        -5127.5,
        1107
      ],
      [
        -3088.900146484375,
        -5130,
        1107
      ],
      [
        -3088.900146484375,
        -5127.5,
        1105
      ]
    ],
    "dimensions": [
      0,
      2.5,
      2
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_rech.glb"
  },
  {
    "id": "door_celllift",
    "sector": "db01",
    "type": "door",
    "texture": "cbaseelevpanelup",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpanelup)",
    "availableSwatches": [
      "cbaseelevpanelup",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: celllift",
    "sourceVertexCount": 24,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3074.283243815104,
      -5114.0750732421875,
      997.25
    ],
    "vertices": [
      [
        -3080,
        -5124,
        979
      ],
      [
        -3080,
        -5104,
        980
      ],
      [
        -3080,
        -5104,
        1030
      ],
      [
        -3080,
        -5124,
        1030
      ],
      [
        -3080,
        -5124,
        980
      ],
      [
        -3080,
        -5104,
        979
      ],
      [
        -3060,
        -5124,
        979
      ],
      [
        -3060,
        -5104,
        1030
      ],
      [
        -3060,
        -5104,
        980
      ],
      [
        -3060,
        -5124,
        1030
      ],
      [
        -3060,
        -5124,
        980
      ],
      [
        -3060,
        -5104,
        979
      ],
      [
        -3079.499755859375,
        -5115.60009765625,
        980
      ],
      [
        -3079.499755859375,
        -5112.7001953125,
        1030
      ],
      [
        -3079.499755859375,
        -5115.60009765625,
        1030
      ],
      [
        -3079.499755859375,
        -5112.7001953125,
        980
      ],
      [
        -3078.099853515625,
        -5115.60009765625,
        980
      ],
      [
        -3078.099853515625,
        -5112.7001953125,
        1030
      ],
      [
        -3078.099853515625,
        -5115.60009765625,
        1030
      ],
      [
        -3078.099853515625,
        -5112.7001953125,
        980
      ],
      [
        -3078.099853515625,
        -5115.60009765625,
        983
      ],
      [
        -3078.099853515625,
        -5112.7001953125,
        986
      ],
      [
        -3078.099853515625,
        -5115.60009765625,
        986
      ],
      [
        -3078.099853515625,
        -5112.7001953125,
        983
      ]
    ],
    "dimensions": [
      20,
      20,
      51
    ],
    "dimensionsMeters": [
      1,
      1,
      2.55
    ],
    "maxDimensionMeters": 2.55,
    "pedestalFitScale": 0.627,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_celllift.glb"
  },
  {
    "id": "door_hyperpan",
    "sector": "db01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: hyperpan",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3006.8673095703125,
      -5064.06005859375,
      1064.300048828125
    ],
    "vertices": [
      [
        -3009.000244140625,
        -5060.93994140625,
        1065.050048828125
      ],
      [
        -3009.000244140625,
        -5067.18017578125,
        1065.050048828125
      ],
      [
        -3004.734375,
        -5061.357421875,
        1063.550048828125
      ],
      [
        -3004.734375,
        -5066.7626953125,
        1063.550048828125
      ]
    ],
    "dimensions": [
      4.265869140625,
      6.240234375,
      1.5
    ],
    "dimensionsMeters": [
      0.21,
      0.31,
      0.15
    ],
    "maxDimensionMeters": 0.31,
    "pedestalFitScale": 1.935,
    "slideAxis": "z",
    "slideVector": [
      0.3317,
      0,
      0.9434
    ],
    "file": "props/door_hyperpan.glb"
  },
  {
    "id": "door_elvdor1a",
    "sector": "dbmov",
    "type": "door",
    "texture": "cbaseelevdoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevdoor)",
    "availableSwatches": [
      "cbaseelevdoor",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elvdor1a",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2979.500244140625,
      -5154.5,
      1108.2999877929688
    ],
    "vertices": [
      [
        -2980.000244140625,
        -5159,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -5159,
        1115
      ],
      [
        -2980.000244140625,
        -5150,
        1115
      ],
      [
        -2980.000244140625,
        -5150,
        1101.5999755859375
      ],
      [
        -2979.000244140625,
        -5159,
        1115
      ],
      [
        -2979.000244140625,
        -5159,
        1101.5999755859375
      ],
      [
        -2979.000244140625,
        -5150,
        1101.5999755859375
      ],
      [
        -2979.000244140625,
        -5150,
        1115
      ]
    ],
    "dimensions": [
      1,
      9,
      13.4000244140625
    ],
    "dimensionsMeters": [
      0.15,
      0.45,
      0.67
    ],
    "maxDimensionMeters": 0.67,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elvdor1a.glb"
  },
  {
    "id": "door_elvdor1b",
    "sector": "dbmov",
    "type": "door",
    "texture": "cbaseelevdoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevdoor)",
    "availableSwatches": [
      "cbaseelevdoor",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elvdor1b",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2979.500244140625,
      -5154.5,
      984.9999389648438
    ],
    "vertices": [
      [
        -2980.000244140625,
        -5159,
        979.9999389648438
      ],
      [
        -2980.000244140625,
        -5159,
        989.9999389648438
      ],
      [
        -2980.000244140625,
        -5150,
        989.9999389648438
      ],
      [
        -2980.000244140625,
        -5150,
        979.9999389648438
      ],
      [
        -2979.000244140625,
        -5159,
        989.9999389648438
      ],
      [
        -2979.000244140625,
        -5159,
        979.9999389648438
      ],
      [
        -2979.000244140625,
        -5150,
        979.9999389648438
      ],
      [
        -2979.000244140625,
        -5150,
        989.9999389648438
      ]
    ],
    "dimensions": [
      1,
      9,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.45,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elvdor1b.glb"
  },
  {
    "id": "door_win1",
    "sector": "eb01",
    "type": "door",
    "texture": "airwindow1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(airwindow1-t)",
    "availableSwatches": [
      "airwindow1-t",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: win1",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 28,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1696.199951171875,
      1522.5,
      126.5
    ],
    "vertices": [
      [
        1696.199951171875,
        1517.5,
        123
      ],
      [
        1696.199951171875,
        1507.5,
        123
      ],
      [
        1696.199951171875,
        1505,
        125
      ],
      [
        1696.199951171875,
        1505,
        128
      ],
      [
        1696.199951171875,
        1507.5,
        130
      ],
      [
        1696.199951171875,
        1517.5,
        130
      ],
      [
        1696.199951171875,
        1520,
        128
      ],
      [
        1696.199951171875,
        1520,
        125
      ],
      [
        1696.199951171875,
        1527.5,
        123
      ],
      [
        1696.199951171875,
        1525,
        125
      ],
      [
        1696.199951171875,
        1525,
        128
      ],
      [
        1696.199951171875,
        1527.5,
        130
      ],
      [
        1696.199951171875,
        1537.5,
        130
      ],
      [
        1696.199951171875,
        1540,
        128
      ],
      [
        1696.199951171875,
        1540,
        125
      ],
      [
        1696.199951171875,
        1537.5,
        123
      ]
    ],
    "dimensions": [
      0,
      35,
      7
    ],
    "dimensionsMeters": [
      0.15,
      1.75,
      0.35
    ],
    "maxDimensionMeters": 1.75,
    "pedestalFitScale": 0.914,
    "slideAxis": "z",
    "slideVector": null,
    "file": "props/door_win1.glb"
  },
  {
    "id": "door_elvdr1",
    "sector": "eb03",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elvdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1768.9999389648438,
      1542.5,
      176
    ],
    "vertices": [
      [
        1769.9998779296875,
        1547.5,
        182
      ],
      [
        1769.9998779296875,
        1547.5,
        170
      ],
      [
        1768,
        1547.5,
        182
      ],
      [
        1768,
        1547.5,
        170
      ],
      [
        1769.9998779296875,
        1537.5,
        182
      ],
      [
        1769.9998779296875,
        1537.5,
        170
      ],
      [
        1768,
        1537.5,
        170
      ],
      [
        1768,
        1537.5,
        182
      ]
    ],
    "dimensions": [
      1.9998779296875,
      10,
      12
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.6
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_elvdr1.glb"
  },
  {
    "id": "door_elev2dr3",
    "sector": "eb03",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1819.0003662109375,
      1835.0000610351562,
      177.5
    ],
    "vertices": [
      [
        1820,
        1830,
        170
      ],
      [
        1820,
        1830,
        185
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        185
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        170
      ],
      [
        1820.0006103515625,
        1840,
        170
      ],
      [
        1820.0006103515625,
        1840,
        185
      ],
      [
        1818.000732421875,
        1840.0001220703125,
        185
      ],
      [
        1818.000732421875,
        1840.0001220703125,
        170
      ]
    ],
    "dimensions": [
      2.00048828125,
      10.0001220703125,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      -0.0001,
      0
    ],
    "file": "props/door_elev2dr3.glb"
  },
  {
    "id": "door_elev2dr1_eb03",
    "sector": "eb03",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1819.0003662109375,
      1835.0000610351562,
      127.5
    ],
    "vertices": [
      [
        1820,
        1830,
        120
      ],
      [
        1820,
        1830,
        135
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        135
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        120
      ],
      [
        1820.0006103515625,
        1840,
        120
      ],
      [
        1820.0006103515625,
        1840,
        135
      ],
      [
        1818.000732421875,
        1840.0001220703125,
        135
      ],
      [
        1818.000732421875,
        1840.0001220703125,
        120
      ]
    ],
    "dimensions": [
      2.00048828125,
      10.0001220703125,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      -0.0001,
      0
    ],
    "file": "props/door_elev2dr1_eb03.glb"
  },
  {
    "id": "door_elev2dr2_eb03",
    "sector": "eb03",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1819.0003662109375,
      1835.0000610351562,
      152.5
    ],
    "vertices": [
      [
        1820,
        1830,
        145
      ],
      [
        1820,
        1830,
        160
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        160
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        145
      ],
      [
        1820.0006103515625,
        1840,
        145
      ],
      [
        1820.0006103515625,
        1840,
        160
      ],
      [
        1818.000732421875,
        1840.0001220703125,
        160
      ],
      [
        1818.000732421875,
        1840.0001220703125,
        145
      ]
    ],
    "dimensions": [
      2.00048828125,
      10.0001220703125,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      -0.0001,
      0
    ],
    "file": "props/door_elev2dr2_eb03.glb"
  },
  {
    "id": "door_elev1dr2",
    "sector": "eb04",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev1dr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1759,
      1531.5,
      376
    ],
    "vertices": [
      [
        1764,
        1532.5,
        382
      ],
      [
        1764,
        1532.5,
        370
      ],
      [
        1764,
        1530.5,
        382
      ],
      [
        1764,
        1530.5,
        370
      ],
      [
        1754,
        1532.5,
        370
      ],
      [
        1754,
        1532.5,
        382
      ],
      [
        1754,
        1530.5,
        382
      ],
      [
        1754,
        1530.5,
        370
      ]
    ],
    "dimensions": [
      10,
      2,
      12
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.6
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_elev1dr2.glb"
  },
  {
    "id": "door_backdr",
    "sector": "eb07",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: backdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      2036.1139526367188,
      1880.5504760742188,
      700.5
    ],
    "vertices": [
      [
        2032.9320068359375,
        1884.4395751953125,
        695
      ],
      [
        2032.9320068359375,
        1884.4395751953125,
        706
      ],
      [
        2032.224853515625,
        1883.732421875,
        706
      ],
      [
        2032.224853515625,
        1883.732421875,
        695
      ],
      [
        2040.0030517578125,
        1877.3685302734375,
        706
      ],
      [
        2040.0030517578125,
        1877.3685302734375,
        695
      ],
      [
        2039.2958984375,
        1876.661376953125,
        695
      ],
      [
        2039.2958984375,
        1876.661376953125,
        706
      ]
    ],
    "dimensions": [
      7.7781982421875,
      7.7781982421875,
      11
    ],
    "dimensionsMeters": [
      0.39,
      0.39,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_backdr.glb"
  },
  {
    "id": "door_watertnk",
    "sector": "ep01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: watertnk",
    "sourceVertexCount": 14,
    "exportedTriangleCount": 40,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3902,
      -5065.483328683035,
      1015.6255231584821
    ],
    "vertices": [
      [
        -3909.725341796875,
        -5029.76904296875,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5029.76904296875,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5094.76904296875,
        1015.6239013671875
      ],
      [
        -3909.725341796875,
        -5094.76904296875,
        1015.6239013671875
      ],
      [
        -3877,
        -5066.76904296875,
        1015.6257934570312
      ],
      [
        -3881.774658203125,
        -5080.2880859375,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5088.6435546875,
        1015.6257934570312
      ],
      [
        -3909.725341796875,
        -5088.6435546875,
        1015.6257934570312
      ],
      [
        -3922.225341796875,
        -5080.2880859375,
        1015.6257934570312
      ],
      [
        -3927,
        -5066.76904296875,
        1015.6257934570312
      ],
      [
        -3922.225341796875,
        -5053.25,
        1015.6257934570312
      ],
      [
        -3909.725341796875,
        -5044.89453125,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5044.89453125,
        1015.6257934570312
      ],
      [
        -3881.774658203125,
        -5053.25,
        1015.6257934570312
      ]
    ],
    "dimensions": [
      50,
      65,
      0.00189208984375
    ],
    "dimensionsMeters": [
      2.5,
      3.25,
      0.15
    ],
    "maxDimensionMeters": 3.25,
    "pedestalFitScale": 0.492,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_watertnk.glb"
  },
  {
    "id": "door_field1_field1",
    "sector": "field1",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field1",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1005,
      1690,
      87.5
    ],
    "vertices": [
      [
        1030,
        1690,
        80
      ],
      [
        980,
        1690,
        80
      ],
      [
        1030,
        1690,
        95
      ],
      [
        980,
        1690,
        95
      ]
    ],
    "dimensions": [
      50,
      0,
      15
    ],
    "dimensionsMeters": [
      2.5,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 2.5,
    "pedestalFitScale": 0.64,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_field1_field1.glb"
  },
  {
    "id": "door_field2_field2",
    "sector": "field2",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field2",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1505,
      1690,
      127.5
    ],
    "vertices": [
      [
        1530,
        1690,
        120
      ],
      [
        1480,
        1690,
        120
      ],
      [
        1480,
        1690,
        135
      ],
      [
        1530,
        1690,
        135
      ]
    ],
    "dimensions": [
      50,
      0,
      15
    ],
    "dimensionsMeters": [
      2.5,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 2.5,
    "pedestalFitScale": 0.64,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_field2_field2.glb"
  },
  {
    "id": "door_field3_field3",
    "sector": "field3",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1120,
      1600,
      135.29410934448242
    ],
    "vertices": [
      [
        1120,
        1570,
        180
      ],
      [
        1120,
        1570,
        180
      ],
      [
        1120,
        1570,
        90.5882339477539
      ],
      [
        1120,
        1570,
        90.5882339477539
      ],
      [
        1120,
        1630,
        180
      ],
      [
        1120,
        1630,
        180
      ],
      [
        1120,
        1630,
        90.58820343017578
      ],
      [
        1120,
        1630,
        90.58820343017578
      ]
    ],
    "dimensions": [
      0,
      60,
      89.41179656982422
    ],
    "dimensionsMeters": [
      0.15,
      3,
      4.47
    ],
    "maxDimensionMeters": 4.47,
    "pedestalFitScale": 0.358,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_field3_field3.glb"
  },
  {
    "id": "door_field5",
    "sector": "field5",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field5",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1160,
      1137.7000122070312,
      127.77089881896973
    ],
    "vertices": [
      [
        1160,
        1170,
        160
      ],
      [
        1160,
        1170,
        160
      ],
      [
        1160,
        1105.4000244140625,
        95.78947448730469
      ],
      [
        1160,
        1105.4000244140625,
        95.78947448730469
      ],
      [
        1160,
        1170,
        95.29412078857422
      ],
      [
        1160,
        1170,
        95.29412078857422
      ],
      [
        1160,
        1105.4000244140625,
        160
      ],
      [
        1160,
        1105.4000244140625,
        160
      ]
    ],
    "dimensions": [
      0,
      64.5999755859375,
      64.70587921142578
    ],
    "dimensionsMeters": [
      0.15,
      3.23,
      3.24
    ],
    "maxDimensionMeters": 3.24,
    "pedestalFitScale": 0.494,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_field5.glb"
  },
  {
    "id": "door_field6",
    "sector": "field6",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field6",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1596.25,
      1070,
      134.8333339691162
    ],
    "vertices": [
      [
        1380,
        1070,
        180
      ],
      [
        1690,
        1070,
        180
      ],
      [
        1690,
        1070,
        112
      ],
      [
        1680,
        1070,
        93.33333587646484
      ],
      [
        1630,
        1070,
        93.33333587646484
      ],
      [
        1630,
        1070,
        140
      ],
      [
        1380,
        1070,
        140
      ],
      [
        1690,
        1070,
        140
      ]
    ],
    "dimensions": [
      310,
      0,
      86.66666412353516
    ],
    "dimensionsMeters": [
      15.5,
      0.15,
      4.33
    ],
    "maxDimensionMeters": 15.5,
    "pedestalFitScale": 0.103,
    "slideAxis": "x",
    "slideVector": null,
    "file": "props/door_field6.glb"
  },
  {
    "id": "door_field7",
    "sector": "field7",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field7",
    "sourceVertexCount": 9,
    "exportedTriangleCount": 22,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      600,
      964.4151068793403,
      111.11111111111111
    ],
    "vertices": [
      [
        600,
        980,
        80
      ],
      [
        600,
        980,
        120
      ],
      [
        600,
        980,
        160
      ],
      [
        600,
        1000,
        160
      ],
      [
        600,
        1000,
        120
      ],
      [
        600,
        970,
        60
      ],
      [
        600,
        930,
        60
      ],
      [
        600,
        919.8679809570312,
        160
      ],
      [
        600,
        919.8679809570312,
        80
      ]
    ],
    "dimensions": [
      0,
      80.13201904296875,
      100
    ],
    "dimensionsMeters": [
      0.15,
      4.01,
      5
    ],
    "maxDimensionMeters": 5,
    "pedestalFitScale": 0.32,
    "slideAxis": "z",
    "slideVector": null,
    "file": "props/door_field7.glb"
  },
  {
    "id": "door_field8",
    "sector": "field8",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field8",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      985,
      930,
      110
    ],
    "vertices": [
      [
        1010,
        930,
        80
      ],
      [
        1010,
        930,
        140
      ],
      [
        1010,
        930,
        80
      ],
      [
        1010,
        930,
        140
      ],
      [
        960,
        930,
        140
      ],
      [
        960,
        930,
        140
      ],
      [
        960,
        930,
        80
      ],
      [
        960,
        930,
        80
      ]
    ],
    "dimensions": [
      50,
      0,
      60
    ],
    "dimensionsMeters": [
      2.5,
      0.15,
      3
    ],
    "maxDimensionMeters": 3,
    "pedestalFitScale": 0.533,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_field8.glb"
  },
  {
    "id": "door_field9",
    "sector": "field9",
    "type": "door",
    "texture": "elecfield1",
    "materialDescriptor": {
      "alphaMode": "additive",
      "transparent": true,
      "doubleSided": true,
      "emissive": true,
      "uvAnimation": {
        "type": "scroll",
        "speedX": 0.0003,
        "speedY": 0.00015
      }
    },
    "resolutionTier": 1,
    "resolutionRule": "forcefield_plasma_invariant",
    "availableSwatches": [
      "elecfield1",
      "refinefield"
    ],
    "tag": "CSlidingDoor piece: field9",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 14,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      909.5740203857422,
      738.3384017944336,
      94.96791362762451
    ],
    "vertices": [
      [
        970,
        707.730224609375,
        120
      ],
      [
        898.6452026367188,
        752.337646484375,
        140
      ],
      [
        898.6452026367188,
        752.337646484375,
        140
      ],
      [
        839.476318359375,
        809.476318359375,
        140
      ],
      [
        839.476318359375,
        809.476318359375,
        140
      ],
      [
        839.476318359375,
        809.476318359375,
        66.60848236083984
      ],
      [
        839.476318359375,
        809.476318359375,
        66.60848236083984
      ],
      [
        898.6452026367188,
        752.337646484375,
        85.9383773803711
      ],
      [
        898.6452026367188,
        752.337646484375,
        85.9383773803711
      ],
      [
        890.34912109375,
        760.3490600585938,
        66.70545196533203
      ],
      [
        890.34912109375,
        760.3490600585938,
        66.70545196533203
      ],
      [
        970,
        650,
        60
      ],
      [
        970,
        700,
        60
      ],
      [
        970,
        640,
        120
      ],
      [
        970,
        640,
        80
      ],
      [
        970,
        707.730224609375,
        80.98199462890625
      ]
    ],
    "dimensions": [
      130.523681640625,
      169.476318359375,
      80
    ],
    "dimensionsMeters": [
      6.53,
      8.47,
      4
    ],
    "maxDimensionMeters": 8.47,
    "pedestalFitScale": 0.189,
    "slideAxis": "z",
    "slideVector": null,
    "file": "props/door_field9.glb"
  },
  {
    "id": "breakable_ho03",
    "sector": "ho03",
    "type": "breakable",
    "texture": "hotmarbwallwh-t_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(hotmarbwallwh-t_h)",
    "availableSwatches": [
      "hotmarbwallwh-t_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -325,
      1143.5,
      402
    ],
    "vertices": [
      [
        -329.5,
        1140,
        402
      ],
      [
        -320.5,
        1147,
        402
      ],
      [
        -329.5,
        1147,
        402
      ],
      [
        -320.5,
        1140,
        402
      ]
    ],
    "dimensions": [
      9,
      7,
      0
    ],
    "dimensionsMeters": [
      0.45,
      0.35,
      0.15
    ],
    "maxDimensionMeters": 0.45,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/breakable_ho03.glb"
  },
  {
    "id": "breakable_hp01",
    "sector": "hp01",
    "type": "breakable",
    "texture": "metalgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metalgrate1-t)",
    "availableSwatches": [
      "metalgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1419,
      615,
      99.62076568603516
    ],
    "vertices": [
      [
        1416,
        612,
        99.62076568603516
      ],
      [
        1422,
        618,
        99.62076568603516
      ],
      [
        1416,
        618,
        99.62076568603516
      ],
      [
        1422,
        612,
        99.62076568603516
      ]
    ],
    "dimensions": [
      6,
      6,
      0
    ],
    "dimensionsMeters": [
      0.3,
      0.3,
      0.15
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/breakable_hp01.glb"
  },
  {
    "id": "breakable_2_hp01",
    "sector": "hp01",
    "type": "breakable",
    "texture": "metalgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metalgrate1-t)",
    "availableSwatches": [
      "metalgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1409.800048828125,
      615.5,
      93.5
    ],
    "vertices": [
      [
        1409.800048828125,
        612.5,
        91
      ],
      [
        1409.800048828125,
        618.5,
        96
      ],
      [
        1409.800048828125,
        612.5,
        96
      ],
      [
        1409.800048828125,
        618.5,
        91
      ]
    ],
    "dimensions": [
      0,
      6,
      5
    ],
    "dimensionsMeters": [
      0.15,
      0.3,
      0.25
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/breakable_2_hp01.glb"
  },
  {
    "id": "breakable_3_hp01",
    "sector": "hp01",
    "type": "breakable",
    "texture": "metalgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metalgrate1-t)",
    "availableSwatches": [
      "metalgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1480.199951171875,
      615.5,
      93.5
    ],
    "vertices": [
      [
        1480.199951171875,
        612.5,
        91
      ],
      [
        1480.199951171875,
        618.5,
        96
      ],
      [
        1480.199951171875,
        612.5,
        96
      ],
      [
        1480.199951171875,
        618.5,
        91
      ]
    ],
    "dimensions": [
      0,
      6,
      5
    ],
    "dimensionsMeters": [
      0.15,
      0.3,
      0.25
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/breakable_3_hp01.glb"
  },
  {
    "id": "door_22door",
    "sector": "hp01",
    "type": "door",
    "texture": "airgums",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(airgums)",
    "availableSwatches": [
      "airgums",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: 22door",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1445,
      636,
      324
    ],
    "vertices": [
      [
        1440,
        635.5,
        317
      ],
      [
        1440,
        636.5,
        331
      ],
      [
        1440,
        635.5,
        331
      ],
      [
        1440,
        636.5,
        317
      ],
      [
        1450,
        635.5,
        317
      ],
      [
        1450,
        636.5,
        331
      ],
      [
        1450,
        635.5,
        331
      ],
      [
        1450,
        636.5,
        317
      ]
    ],
    "dimensions": [
      10,
      1,
      14
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.7
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_22door.glb"
  },
  {
    "id": "door_06door",
    "sector": "hp01",
    "type": "door",
    "texture": "airgums",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(airgums)",
    "availableSwatches": [
      "airgums",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: 06door",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1631.5,
      595,
      125
    ],
    "vertices": [
      [
        1631,
        590,
        118
      ],
      [
        1631,
        590,
        132
      ],
      [
        1632,
        590,
        118
      ],
      [
        1632,
        590,
        132
      ],
      [
        1631,
        600,
        132
      ],
      [
        1631,
        600,
        118
      ],
      [
        1632,
        600,
        132
      ],
      [
        1632,
        600,
        118
      ]
    ],
    "dimensions": [
      1,
      10,
      14
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.7
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_06door.glb"
  },
  {
    "id": "breakable_4_hp01",
    "sector": "hp01",
    "type": "breakable",
    "texture": "metalgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metalgrate1-t)",
    "availableSwatches": [
      "metalgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1612.5,
      645,
      117.80000305175781
    ],
    "vertices": [
      [
        1608,
        650,
        117.80000305175781
      ],
      [
        1608,
        640,
        117.80000305175781
      ],
      [
        1617,
        640,
        117.80000305175781
      ],
      [
        1617,
        650,
        117.80000305175781
      ]
    ],
    "dimensions": [
      9,
      10,
      0
    ],
    "dimensionsMeters": [
      0.45,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_4_hp01.glb"
  },
  {
    "id": "elevator_03elv",
    "sector": "hp01",
    "type": "elevator",
    "texture": "cbaseelevpaneldown",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpaneldown)",
    "availableSwatches": [
      "cbaseelevpaneldown",
      "baseelev1",
      "cbaseelevdoor",
      "cbaseelevpanelup",
      "elevatorlight1",
      "elevatorlight1out",
      "elevatorpanel2",
      "elevatorshaft",
      "elevatorshaftout",
      "emielevstripe_h",
      "gcelevtrak_h",
      "hangelevswitch",
      "hospelevdoor",
      "hotelevbut_h",
      "hotelevout_h",
      "hotelevpaneldown",
      "hotelevpanelup",
      "hotvaselev_h",
      "mineelevpanelup",
      "minepipelev",
      "reselevshaft",
      "spkelevdoor1",
      "spkelevfloor1"
    ],
    "tag": "CElevator piece: 03elv",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1589,
      648.7449951171875,
      317.7249755859375
    ],
    "vertices": [
      [
        1590.5,
        652.489990234375,
        317.3499755859375
      ],
      [
        1592.5,
        652.489990234375,
        321.8499755859375
      ],
      [
        1592.5,
        652.489990234375,
        317.3499755859375
      ],
      [
        1590.5,
        652.489990234375,
        321.8499755859375
      ],
      [
        1590.5,
        652.489990234375,
        317.3499755859375
      ],
      [
        1588.5,
        652.489990234375,
        317.3499755859375
      ],
      [
        1588.5,
        652.489990234375,
        321.8499755859375
      ],
      [
        1590.5,
        652.489990234375,
        321.8499755859375
      ],
      [
        1580,
        652.5,
        314.3499755859375
      ],
      [
        1580,
        637.5,
        314.3499755859375
      ],
      [
        1580,
        637.5,
        317.3499755859375
      ],
      [
        1580,
        652.5,
        317.3499755859375
      ],
      [
        1595,
        652.5,
        314.3499755859375
      ],
      [
        1595,
        652.5,
        317.3499755859375
      ],
      [
        1595,
        637.5,
        317.3499755859375
      ],
      [
        1595,
        637.5,
        314.3499755859375
      ]
    ],
    "dimensions": [
      15,
      15,
      7.5
    ],
    "dimensionsMeters": [
      0.75,
      0.75,
      0.38
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/elevator_03elv.glb"
  },
  {
    "id": "breakable_5_hp01",
    "sector": "hp01",
    "type": "breakable",
    "texture": "metalgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metalgrate1-t)",
    "availableSwatches": [
      "metalgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1612.5,
      660,
      117.80000305175781
    ],
    "vertices": [
      [
        1617,
        665,
        117.80000305175781
      ],
      [
        1608,
        665,
        117.80000305175781
      ],
      [
        1608,
        655,
        117.80000305175781
      ],
      [
        1617,
        655,
        117.80000305175781
      ]
    ],
    "dimensions": [
      9,
      10,
      0
    ],
    "dimensionsMeters": [
      0.45,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_5_hp01.glb"
  },
  {
    "id": "door_garage",
    "sector": "hpmv",
    "type": "door",
    "texture": "chkdiarrhea",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkdiarrhea)",
    "availableSwatches": [
      "chkdiarrhea",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: garage",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1525,
      481.875,
      90.875
    ],
    "vertices": [
      [
        1508.6666259765625,
        480,
        98
      ],
      [
        1508.6666259765625,
        480,
        98
      ],
      [
        1541.3333740234375,
        480,
        98
      ],
      [
        1541.3333740234375,
        480,
        98
      ],
      [
        1548,
        480,
        91
      ],
      [
        1548,
        480,
        91
      ],
      [
        1548,
        480,
        80
      ],
      [
        1502,
        480,
        80
      ],
      [
        1502,
        480,
        91
      ],
      [
        1502,
        480,
        91
      ],
      [
        1541.3333740234375,
        485,
        98
      ],
      [
        1508.6666259765625,
        485,
        98
      ],
      [
        1502,
        485,
        91
      ],
      [
        1502,
        485,
        80
      ],
      [
        1548,
        485,
        80
      ],
      [
        1548,
        485,
        91
      ]
    ],
    "dimensions": [
      46,
      5,
      18
    ],
    "dimensionsMeters": [
      2.3,
      0.25,
      0.9
    ],
    "maxDimensionMeters": 2.3,
    "pedestalFitScale": 0.696,
    "slideAxis": "x",
    "slideVector": [
      0.7241,
      0,
      0.6897
    ],
    "file": "props/door_garage.glb"
  },
  {
    "id": "breakable_in01",
    "sector": "in01",
    "type": "breakable",
    "texture": "metalgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metalgrate1-t)",
    "availableSwatches": [
      "metalgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3770.00048828125,
      -3119.7843017578125,
      1059.800048828125
    ],
    "vertices": [
      [
        -3776.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3776.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3764.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3764.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3776.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      [
        -3776.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      [
        -3764.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      [
        -3764.00048828125,
        -3139.7685546875,
        1059.800048828125
      ]
    ],
    "dimensions": [
      12,
      39.968505859375,
      0
    ],
    "dimensionsMeters": [
      0.6,
      2,
      0.15
    ],
    "maxDimensionMeters": 2,
    "pedestalFitScale": 0.8,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_in01.glb"
  },
  {
    "id": "door_tldr",
    "sector": "in01",
    "type": "door",
    "texture": "slidedoor3",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor3)",
    "availableSwatches": [
      "slidedoor3",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: tldr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3860.50048828125,
      -3094.7685546875,
      1027.373779296875
    ],
    "vertices": [
      [
        -3861.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      [
        -3861.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      [
        -3861.00048828125,
        -3099.7685546875,
        1032.623779296875
      ],
      [
        -3861.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      [
        -3860.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      [
        -3860.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      [
        -3860.00048828125,
        -3099.7685546875,
        1032.623779296875
      ],
      [
        -3860.00048828125,
        -3099.7685546875,
        1022.123779296875
      ]
    ],
    "dimensions": [
      1,
      10,
      10.5
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.53
    ],
    "maxDimensionMeters": 0.53,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_tldr.glb"
  },
  {
    "id": "door_trdr",
    "sector": "in01",
    "type": "door",
    "texture": "slidedoor3",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor3)",
    "availableSwatches": [
      "slidedoor3",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: trdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3839.50048828125,
      -3094.7685546875,
      1027.373779296875
    ],
    "vertices": [
      [
        -3840.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      [
        -3840.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      [
        -3840.00048828125,
        -3099.7685546875,
        1032.623779296875
      ],
      [
        -3840.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      [
        -3839.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      [
        -3839.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      [
        -3839.00048828125,
        -3099.7685546875,
        1032.623779296875
      ],
      [
        -3839.00048828125,
        -3099.7685546875,
        1022.123779296875
      ]
    ],
    "dimensions": [
      1,
      10,
      10.5
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.53
    ],
    "maxDimensionMeters": 0.53,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_trdr.glb"
  },
  {
    "id": "door_watdrl",
    "sector": "in01",
    "type": "door",
    "texture": "slidedoor3",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor3)",
    "availableSwatches": [
      "slidedoor3",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: watdrl",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3847.5,
      -3085.75,
      1026.3499755859375
    ],
    "vertices": [
      [
        -3845,
        -3086.699951171875,
        1020.0999755859375
      ],
      [
        -3845,
        -3084.800048828125,
        1032.5999755859375
      ],
      [
        -3845,
        -3086.699951171875,
        1032.5999755859375
      ],
      [
        -3845,
        -3084.800048828125,
        1020.0999755859375
      ],
      [
        -3850,
        -3086.699951171875,
        1020.0999755859375
      ],
      [
        -3850,
        -3086.699951171875,
        1032.5999755859375
      ],
      [
        -3850,
        -3084.800048828125,
        1032.5999755859375
      ],
      [
        -3850,
        -3084.800048828125,
        1020.0999755859375
      ]
    ],
    "dimensions": [
      5,
      1.89990234375,
      12.5
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.63
    ],
    "maxDimensionMeters": 0.63,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_watdrl.glb"
  },
  {
    "id": "door_watdrr",
    "sector": "in01",
    "type": "door",
    "texture": "slidedoor3",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor3)",
    "availableSwatches": [
      "slidedoor3",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: watdrr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3852.5,
      -3085.75,
      1026.3499755859375
    ],
    "vertices": [
      [
        -3855,
        -3086.699951171875,
        1020.0999755859375
      ],
      [
        -3855,
        -3084.800048828125,
        1032.5999755859375
      ],
      [
        -3855,
        -3086.699951171875,
        1032.5999755859375
      ],
      [
        -3855,
        -3084.800048828125,
        1020.0999755859375
      ],
      [
        -3850,
        -3086.699951171875,
        1020.0999755859375
      ],
      [
        -3850,
        -3086.699951171875,
        1032.5999755859375
      ],
      [
        -3850,
        -3084.800048828125,
        1032.5999755859375
      ],
      [
        -3850,
        -3084.800048828125,
        1020.0999755859375
      ]
    ],
    "dimensions": [
      5,
      1.89990234375,
      12.5
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.63
    ],
    "maxDimensionMeters": 0.63,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_watdrr.glb"
  },
  {
    "id": "door_in1srmdr",
    "sector": "in01",
    "type": "door",
    "texture": "slidedoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor1)",
    "availableSwatches": [
      "slidedoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: in1srmdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3955.75,
      -3090,
      1022.5000305175781
    ],
    "vertices": [
      [
        -3956.5,
        -3100,
        1029.800048828125
      ],
      [
        -3956.5,
        -3100,
        1015.2000122070312
      ],
      [
        -3956.5,
        -3080,
        1029.800048828125
      ],
      [
        -3956.5,
        -3080,
        1015.2000122070312
      ],
      [
        -3955,
        -3100,
        1029.800048828125
      ],
      [
        -3955,
        -3100,
        1015.2000122070312
      ],
      [
        -3955,
        -3080,
        1029.800048828125
      ],
      [
        -3955,
        -3080,
        1015.2000122070312
      ]
    ],
    "dimensions": [
      1.5,
      20,
      14.60003662109375
    ],
    "dimensionsMeters": [
      0.15,
      1,
      0.73
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_in1srmdr.glb"
  },
  {
    "id": "door_rech_in01",
    "sector": "in01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rech",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3730.5,
      -3088.699951171875,
      1016
    ],
    "vertices": [
      [
        -3732,
        -3088.699951171875,
        1015
      ],
      [
        -3729,
        -3088.699951171875,
        1017
      ],
      [
        -3729,
        -3088.699951171875,
        1015
      ],
      [
        -3732,
        -3088.699951171875,
        1017
      ]
    ],
    "dimensions": [
      3,
      0,
      2
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_rech_in01.glb"
  },
  {
    "id": "door_secmsgdr",
    "sector": "in01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: secmsgdr",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3789.5,
      -3231.909912109375,
      1059.880126953125
    ],
    "vertices": [
      [
        -3792,
        -3233.35986328125,
        1059.880126953125
      ],
      [
        -3787,
        -3230.4599609375,
        1059.880126953125
      ],
      [
        -3792,
        -3230.4599609375,
        1059.880126953125
      ],
      [
        -3787,
        -3233.35986328125,
        1059.880126953125
      ]
    ],
    "dimensions": [
      5,
      2.89990234375,
      0
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.25,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_secmsgdr.glb"
  },
  {
    "id": "door_platform",
    "sector": "in02",
    "type": "door",
    "texture": "airgums",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(airgums)",
    "availableSwatches": [
      "airgums",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: platform",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3900.625,
      -3295.2000732421875,
      1004.4502563476562
    ],
    "vertices": [
      [
        -3905.25,
        -3300.60009765625,
        1003.8999633789062
      ],
      [
        -3905.25,
        -3289.800048828125,
        1005.0005493164062
      ],
      [
        -3905.25,
        -3300.60009765625,
        1005.0005493164062
      ],
      [
        -3905.25,
        -3289.800048828125,
        1003.8999633789062
      ],
      [
        -3896,
        -3300.60009765625,
        1003.8999633789062
      ],
      [
        -3896,
        -3289.800048828125,
        1005.0005493164062
      ],
      [
        -3896,
        -3300.60009765625,
        1005.0005493164062
      ],
      [
        -3896,
        -3289.800048828125,
        1003.8999633789062
      ]
    ],
    "dimensions": [
      9.25,
      10.800048828125,
      1.1005859375
    ],
    "dimensionsMeters": [
      0.46,
      0.54,
      0.15
    ],
    "maxDimensionMeters": 0.54,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_platform.glb"
  },
  {
    "id": "unknown_jct01",
    "sector": "jct01",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: jct01",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2535.6392822265625,
      -4043.8383178710938,
      1108.5619201660156
    ],
    "vertices": [
      [
        -2534.8115234375,
        -4028.199951171875,
        1115.623779296875
      ],
      [
        -2534.8115234375,
        -4028.199951171875,
        1104.6239013671875
      ],
      [
        -2538.173828125,
        -4034,
        1104.6239013671875
      ],
      [
        -2538.173828125,
        -4034,
        1115.623779296875
      ],
      [
        -2542.147216796875,
        -4052.32666015625,
        1100
      ],
      [
        -2527.424560546875,
        -4060.82666015625,
        1100
      ],
      [
        -2527.424560546875,
        -4060.82666015625,
        1114
      ],
      [
        -2542.147216796875,
        -4052.32666015625,
        1114
      ]
    ],
    "dimensions": [
      14.72265625,
      32.626708984375,
      15.623779296875
    ],
    "dimensionsMeters": [
      0.74,
      1.63,
      0.78
    ],
    "maxDimensionMeters": 1.63,
    "pedestalFitScale": 0.982,
    "slideAxis": "z",
    "slideVector": [
      0.8651,
      -0.5015,
      0
    ],
    "file": "props/unknown_jct01.glb"
  },
  {
    "id": "unknown_jct02",
    "sector": "jct02",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: jct02",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3278.3662109375,
      -4830.14306640625,
      1089.8118896484375
    ],
    "vertices": [
      [
        -3316,
        -4859.5,
        1086
      ],
      [
        -3274,
        -4859.5,
        1086
      ],
      [
        -3274,
        -4859.5,
        1098
      ],
      [
        -3316,
        -4859.5,
        1098
      ],
      [
        -3264.205810546875,
        -4799.6845703125,
        1082.623779296875
      ],
      [
        -3264.205810546875,
        -4799.6845703125,
        1092.623779296875
      ],
      [
        -3259.259033203125,
        -4801.8876953125,
        1092.623779296875
      ],
      [
        -3259.259033203125,
        -4801.8876953125,
        1082.623779296875
      ]
    ],
    "dimensions": [
      56.740966796875,
      59.8154296875,
      15.376220703125
    ],
    "dimensionsMeters": [
      2.84,
      2.99,
      0.77
    ],
    "maxDimensionMeters": 2.99,
    "pedestalFitScale": 0.535,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/unknown_jct02.glb"
  },
  {
    "id": "door_elevjct2",
    "sector": "jctmov",
    "type": "door",
    "texture": "basewalllight1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(basewalllight1)",
    "availableSwatches": [
      "basewalllight1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elevjct2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2513.807861328125,
      -4050.25,
      1100.8499755859375
    ],
    "vertices": [
      [
        -2508.815673828125,
        -4044.300048828125,
        1100.5999755859375
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1100.5999755859375
      ],
      [
        -2518.800048828125,
        -4056.199951171875,
        1100.5999755859375
      ],
      [
        -2508.800048828125,
        -4056.199951171875,
        1100.5999755859375
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1101.0999755859375
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1101.0999755859375
      ],
      [
        -2518.800048828125,
        -4056.199951171875,
        1101.0999755859375
      ],
      [
        -2508.800048828125,
        -4056.199951171875,
        1101.0999755859375
      ]
    ],
    "dimensions": [
      10.015625,
      11.89990234375,
      0.5
    ],
    "dimensionsMeters": [
      0.5,
      0.59,
      0.15
    ],
    "maxDimensionMeters": 0.59,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      1,
      0.0013,
      0
    ],
    "file": "props/door_elevjct2.glb"
  },
  {
    "id": "door_platjct1",
    "sector": "jctmov",
    "type": "door",
    "texture": "cbaseelevpanelup",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpanelup)",
    "availableSwatches": [
      "cbaseelevpanelup",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: platjct1",
    "sourceVertexCount": 20,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2420.5,
      -3981.200048828125,
      1033.8
    ],
    "vertices": [
      [
        -2423.300048828125,
        -3979.800048828125,
        1032
      ],
      [
        -2417.699951171875,
        -3979.800048828125,
        1032
      ],
      [
        -2417.699951171875,
        -3985.800048828125,
        1032
      ],
      [
        -2423.300048828125,
        -3985.800048828125,
        1032
      ],
      [
        -2423.300048828125,
        -3979.800048828125,
        1032.5
      ],
      [
        -2417.699951171875,
        -3979.800048828125,
        1032.5
      ],
      [
        -2417.699951171875,
        -3985.800048828125,
        1032.5
      ],
      [
        -2423.300048828125,
        -3985.800048828125,
        1032.5
      ],
      [
        -2422,
        -3979.800048828125,
        1032.5
      ],
      [
        -2422,
        -3979.800048828125,
        1032.5
      ],
      [
        -2419,
        -3979.800048828125,
        1038
      ],
      [
        -2419,
        -3979.800048828125,
        1038
      ],
      [
        -2419,
        -3979.800048828125,
        1032.5
      ],
      [
        -2419,
        -3979.800048828125,
        1032.5
      ],
      [
        -2422,
        -3979.800048828125,
        1038
      ],
      [
        -2422,
        -3979.800048828125,
        1038
      ],
      [
        -2422,
        -3980.800048828125,
        1032.5
      ],
      [
        -2422,
        -3980.800048828125,
        1035.5
      ],
      [
        -2419,
        -3980.800048828125,
        1035.5
      ],
      [
        -2419,
        -3980.800048828125,
        1032.5
      ]
    ],
    "dimensions": [
      5.60009765625,
      6,
      6
    ],
    "dimensionsMeters": [
      0.28,
      0.3,
      0.3
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_platjct1.glb"
  },
  {
    "id": "door_platjct3",
    "sector": "jctmov",
    "type": "door",
    "texture": "cbaseelevpanelup",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpanelup)",
    "availableSwatches": [
      "cbaseelevpanelup",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: platjct3",
    "sourceVertexCount": 20,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2511.93994140625,
      -4031.200048828125,
      1033.8
    ],
    "vertices": [
      [
        -2514.800048828125,
        -4029.800048828125,
        1032
      ],
      [
        -2509.199951171875,
        -4029.800048828125,
        1032
      ],
      [
        -2509.199951171875,
        -4035.800048828125,
        1032
      ],
      [
        -2514.800048828125,
        -4035.800048828125,
        1032
      ],
      [
        -2514.800048828125,
        -4029.800048828125,
        1032.5
      ],
      [
        -2509.199951171875,
        -4029.800048828125,
        1032.5
      ],
      [
        -2509.199951171875,
        -4035.800048828125,
        1032.5
      ],
      [
        -2514.800048828125,
        -4035.800048828125,
        1032.5
      ],
      [
        -2513.39990234375,
        -4029.800048828125,
        1032.5
      ],
      [
        -2513.39990234375,
        -4029.800048828125,
        1032.5
      ],
      [
        -2510.39990234375,
        -4029.800048828125,
        1038
      ],
      [
        -2510.39990234375,
        -4029.800048828125,
        1038
      ],
      [
        -2510.39990234375,
        -4029.800048828125,
        1032.5
      ],
      [
        -2510.39990234375,
        -4029.800048828125,
        1032.5
      ],
      [
        -2513.39990234375,
        -4029.800048828125,
        1038
      ],
      [
        -2513.39990234375,
        -4029.800048828125,
        1038
      ],
      [
        -2513.39990234375,
        -4030.800048828125,
        1032.5
      ],
      [
        -2513.39990234375,
        -4030.800048828125,
        1035.5
      ],
      [
        -2510.39990234375,
        -4030.800048828125,
        1035.5
      ],
      [
        -2510.39990234375,
        -4030.800048828125,
        1032.5
      ]
    ],
    "dimensions": [
      5.60009765625,
      6,
      6
    ],
    "dimensionsMeters": [
      0.28,
      0.3,
      0.3
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_platjct3.glb"
  },
  {
    "id": "door_libshelf",
    "sector": "jctq1q3",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: libshelf",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      960,
      1627.5,
      82
    ],
    "vertices": [
      [
        950,
        1625,
        77
      ],
      [
        950,
        1630,
        77
      ],
      [
        950,
        1630,
        87
      ],
      [
        950,
        1625,
        87
      ],
      [
        970,
        1625,
        77
      ],
      [
        970,
        1625,
        87
      ],
      [
        970,
        1630,
        87
      ],
      [
        970,
        1630,
        77
      ]
    ],
    "dimensions": [
      20,
      5,
      10
    ],
    "dimensionsMeters": [
      1,
      0.25,
      0.5
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_libshelf.glb"
  },
  {
    "id": "unknown_C:\\EDITOR\\simpleLW.lwo",
    "sector": "melev",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "C:\\EDITOR\\simpleLW.lwo",
    "sourceVertexCount": 6,
    "exportedTriangleCount": 8,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3.3333333333333335,
      0,
      6.666666666666667
    ],
    "vertices": [
      [
        -10,
        -10,
        0
      ],
      [
        -10,
        10,
        20
      ],
      [
        -10,
        -10,
        20
      ],
      [
        -10,
        10,
        0
      ],
      [
        10,
        -10,
        0
      ],
      [
        10,
        10,
        0
      ]
    ],
    "dimensions": [
      20,
      20,
      20
    ],
    "dimensionsMeters": [
      1,
      1,
      1
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/unknown_C:\\EDITOR\\simpleLW.lwo.glb"
  },
  {
    "id": "door_melevdr3",
    "sector": "melev",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: melevdr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3468,
      -4909.50048828125,
      1086.70703125
    ],
    "vertices": [
      [
        -3471,
        -4910.00048828125,
        1081.70703125
      ],
      [
        -3465,
        -4910.00048828125,
        1081.70703125
      ],
      [
        -3471,
        -4909.00048828125,
        1081.70703125
      ],
      [
        -3465,
        -4909.00048828125,
        1081.70703125
      ],
      [
        -3471,
        -4910.00048828125,
        1091.70703125
      ],
      [
        -3465,
        -4910.00048828125,
        1091.70703125
      ],
      [
        -3465,
        -4909.00048828125,
        1091.70703125
      ],
      [
        -3471,
        -4909.00048828125,
        1091.70703125
      ]
    ],
    "dimensions": [
      6,
      1,
      10
    ],
    "dimensionsMeters": [
      0.3,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_melevdr3.glb"
  },
  {
    "id": "door_melevdr1",
    "sector": "melev",
    "type": "door",
    "texture": "cbaseelevdoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevdoor)",
    "availableSwatches": [
      "cbaseelevdoor",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: melevdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3468,
      -4909.50048828125,
      1036.70703125
    ],
    "vertices": [
      [
        -3465,
        -4910.00048828125,
        1031.70703125
      ],
      [
        -3465,
        -4909.00048828125,
        1031.70703125
      ],
      [
        -3465,
        -4910.00048828125,
        1041.70703125
      ],
      [
        -3465,
        -4909.00048828125,
        1041.70703125
      ],
      [
        -3471,
        -4910.00048828125,
        1041.70703125
      ],
      [
        -3471,
        -4910.00048828125,
        1031.70703125
      ],
      [
        -3471,
        -4909.00048828125,
        1031.70703125
      ],
      [
        -3471,
        -4909.00048828125,
        1041.70703125
      ]
    ],
    "dimensions": [
      6,
      1,
      10
    ],
    "dimensionsMeters": [
      0.3,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_melevdr1.glb"
  },
  {
    "id": "door_melevdr2",
    "sector": "melev",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: melevdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3468,
      -4909.50048828125,
      1062.70703125
    ],
    "vertices": [
      [
        -3471,
        -4910.00048828125,
        1057.70703125
      ],
      [
        -3465,
        -4910.00048828125,
        1057.70703125
      ],
      [
        -3465,
        -4909.00048828125,
        1057.70703125
      ],
      [
        -3471,
        -4909.00048828125,
        1057.70703125
      ],
      [
        -3465,
        -4910.00048828125,
        1067.70703125
      ],
      [
        -3471,
        -4910.00048828125,
        1067.70703125
      ],
      [
        -3465,
        -4909.00048828125,
        1067.70703125
      ],
      [
        -3471,
        -4909.00048828125,
        1067.70703125
      ]
    ],
    "dimensions": [
      6,
      1,
      10
    ],
    "dimensionsMeters": [
      0.3,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_melevdr2.glb"
  },
  {
    "id": "unknown_C:\\EDITOR\\simpleLW.lwo_2",
    "sector": "melev",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "C:\\EDITOR\\simpleLW.lwo",
    "sourceVertexCount": 6,
    "exportedTriangleCount": 8,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3.3333333333333335,
      0,
      6.666666666666667
    ],
    "vertices": [
      [
        -10,
        -10,
        0
      ],
      [
        -10,
        10,
        20
      ],
      [
        -10,
        -10,
        20
      ],
      [
        -10,
        10,
        0
      ],
      [
        10,
        -10,
        0
      ],
      [
        10,
        10,
        0
      ]
    ],
    "dimensions": [
      20,
      20,
      20
    ],
    "dimensionsMeters": [
      1,
      1,
      1
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/unknown_C:\\EDITOR\\simpleLW.lwo_2.glb"
  },
  {
    "id": "breakable_mt01",
    "sector": "mt01",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3066.9437255859375,
      -3870.349853515625,
      1060.5999755859375
    ],
    "vertices": [
      [
        -3070.238037109375,
        -3870.11962890625,
        1054.5999755859375
      ],
      [
        -3070.238037109375,
        -3870.11962890625,
        1054.5999755859375
      ],
      [
        -3070.238037109375,
        -3870.11962890625,
        1066.5999755859375
      ],
      [
        -3070.238037109375,
        -3870.11962890625,
        1066.5999755859375
      ],
      [
        -3063.6494140625,
        -3870.580078125,
        1066.5999755859375
      ],
      [
        -3063.6494140625,
        -3870.580078125,
        1066.5999755859375
      ],
      [
        -3063.6494140625,
        -3870.580078125,
        1054.5999755859375
      ],
      [
        -3063.6494140625,
        -3870.580078125,
        1054.5999755859375
      ]
    ],
    "dimensions": [
      6.588623046875,
      0.46044921875,
      12
    ],
    "dimensionsMeters": [
      0.33,
      0.15,
      0.6
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -0.0697,
      -0.9976,
      0
    ],
    "file": "props/breakable_mt01.glb"
  },
  {
    "id": "breakable_2_mt01",
    "sector": "mt01",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2161.75,
      -4385.751220703125,
      1060.5999755859375
    ],
    "vertices": [
      [
        -2163.5,
        -4382.95068359375,
        1054.5999755859375
      ],
      [
        -2163.5,
        -4382.95068359375,
        1054.5999755859375
      ],
      [
        -2163.5,
        -4382.95068359375,
        1066.5999755859375
      ],
      [
        -2163.5,
        -4382.95068359375,
        1066.5999755859375
      ],
      [
        -2160,
        -4388.5517578125,
        1066.5999755859375
      ],
      [
        -2160,
        -4388.5517578125,
        1066.5999755859375
      ],
      [
        -2160,
        -4388.5517578125,
        1054.5999755859375
      ],
      [
        -2160,
        -4388.5517578125,
        1054.5999755859375
      ]
    ],
    "dimensions": [
      3.5,
      5.60107421875,
      12
    ],
    "dimensionsMeters": [
      0.18,
      0.28,
      0.6
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -0.848,
      -0.5299,
      0
    ],
    "file": "props/breakable_2_mt01.glb"
  },
  {
    "id": "door_gate",
    "sector": "mt01",
    "type": "door",
    "texture": "basegatedoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(basegatedoor)",
    "availableSwatches": [
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: gate",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2092.5,
      -3447.5,
      1057.2870635986328
    ],
    "vertices": [
      [
        -2105,
        -3430,
        1086
      ],
      [
        -2095,
        -3425,
        1086
      ],
      [
        -2080,
        -3465,
        1086
      ],
      [
        -2090,
        -3470,
        1086
      ],
      [
        -2080,
        -3465,
        1028.187255859375
      ],
      [
        -2095,
        -3425,
        1027.6832275390625
      ],
      [
        -2090,
        -3470,
        1029.570556640625
      ],
      [
        -2105,
        -3430,
        1028.85546875
      ]
    ],
    "dimensions": [
      25,
      45,
      58.3167724609375
    ],
    "dimensionsMeters": [
      1.25,
      2.25,
      2.92
    ],
    "maxDimensionMeters": 2.92,
    "pedestalFitScale": 0.548,
    "slideAxis": "z",
    "slideVector": [
      0.9363,
      0.3511,
      0
    ],
    "file": "props/door_gate.glb"
  },
  {
    "id": "door_recsta",
    "sector": "mt01",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: recsta",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2524.4053955078125,
      -3963.2918701171875,
      1056.8250122070312
    ],
    "vertices": [
      [
        -2525.805419921875,
        -3962.41455078125,
        1055.4000244140625
      ],
      [
        -2525.805419921875,
        -3962.41455078125,
        1058.25
      ],
      [
        -2523.00537109375,
        -3964.169189453125,
        1058.25
      ],
      [
        -2523.00537109375,
        -3964.169189453125,
        1055.4000244140625
      ]
    ],
    "dimensions": [
      2.800048828125,
      1.754638671875,
      2.8499755859375
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      -0.531,
      -0.8474,
      0
    ],
    "file": "props/door_recsta.glb"
  },
  {
    "id": "door_endr",
    "sector": "mt02",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: endr",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1360.5191040039062,
      -3090.66943359375,
      784.9983520507812
    ],
    "vertices": [
      [
        -1364.5157470703125,
        -3092.713623046875,
        789.9967041015625
      ],
      [
        -1364.5357666015625,
        -3092.723876953125,
        780
      ],
      [
        -1356.5123291015625,
        -3088.6201171875,
        789.9967041015625
      ],
      [
        -1356.5125732421875,
        -3088.6201171875,
        780
      ]
    ],
    "dimensions": [
      8.0234375,
      4.103759765625,
      9.9967041015625
    ],
    "dimensionsMeters": [
      0.4,
      0.21,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0.4554,
      -0.8903,
      0
    ],
    "file": "props/door_endr.glb"
  },
  {
    "id": "unknown_mt02a",
    "sector": "mt02a",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt02a",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1341.5,
      -3972.875,
      708.25
    ],
    "vertices": [
      [
        -1494,
        -3930.60009765625,
        691.2000122070312
      ],
      [
        -1494,
        -3930.60009765625,
        701.7999877929688
      ],
      [
        -1494,
        -3918.39990234375,
        701.7999877929688
      ],
      [
        -1494,
        -3918.39990234375,
        691.2000122070312
      ],
      [
        -1189,
        -4033,
        700.5
      ],
      [
        -1189,
        -4009.5,
        700.5
      ],
      [
        -1189,
        -4009.5,
        739.5
      ],
      [
        -1189,
        -4033,
        739.5
      ]
    ],
    "dimensions": [
      305,
      114.60009765625,
      48.29998779296875
    ],
    "dimensionsMeters": [
      15.25,
      5.73,
      2.41
    ],
    "maxDimensionMeters": 15.25,
    "pedestalFitScale": 0.105,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/unknown_mt02a.glb"
  },
  {
    "id": "unknown_mt02b",
    "sector": "mt02b",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt02b",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1580,
      -3932.25,
      867.125
    ],
    "vertices": [
      [
        -1666,
        -3944.5,
        1035.5
      ],
      [
        -1666,
        -3944.5,
        1040
      ],
      [
        -1666,
        -3935.5,
        1040
      ],
      [
        -1666,
        -3935.5,
        1035.5
      ],
      [
        -1494,
        -3930.60009765625,
        691.2000122070312
      ],
      [
        -1494,
        -3918.39990234375,
        691.2000122070312
      ],
      [
        -1494,
        -3918.39990234375,
        701.7999877929688
      ],
      [
        -1494,
        -3930.60009765625,
        701.7999877929688
      ]
    ],
    "dimensions": [
      172,
      26.10009765625,
      348.79998779296875
    ],
    "dimensionsMeters": [
      8.6,
      1.31,
      17.44
    ],
    "maxDimensionMeters": 17.44,
    "pedestalFitScale": 0.092,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/unknown_mt02b.glb"
  },
  {
    "id": "breakable_mt02b",
    "sector": "mt02b",
    "type": "breakable",
    "texture": "chkptroofgrate1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptroofgrate1)",
    "availableSwatches": [
      "chkptroofgrate1",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1338.5,
      -3994.5,
      1038
    ],
    "vertices": [
      [
        -1333.9647216796875,
        -4003,
        1039.2369384765625
      ],
      [
        -1343.0352783203125,
        -4003,
        1036.7630615234375
      ],
      [
        -1343.0352783203125,
        -3986,
        1036.7630615234375
      ],
      [
        -1333.9647216796875,
        -3986,
        1039.2369384765625
      ]
    ],
    "dimensions": [
      9.070556640625,
      17,
      2.473876953125
    ],
    "dimensionsMeters": [
      0.45,
      0.85,
      0.15
    ],
    "maxDimensionMeters": 0.85,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -0.2631,
      0,
      0.9648
    ],
    "file": "props/breakable_mt02b.glb"
  },
  {
    "id": "breakable_2_mt02b",
    "sector": "mt02b",
    "type": "breakable",
    "texture": "chkptroofgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptroofgrate1-t)",
    "availableSwatches": [
      "chkptroofgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1301.5,
      -3930.75,
      1004.5
    ],
    "vertices": [
      [
        -1311.5,
        -3931.5,
        1001
      ],
      [
        -1311.5,
        -3930,
        1001
      ],
      [
        -1291.5,
        -3931.5,
        1008
      ],
      [
        -1291.5,
        -3930,
        1008
      ],
      [
        -1291.5,
        -3931.5,
        1001
      ],
      [
        -1291.5,
        -3930,
        1001
      ],
      [
        -1311.5,
        -3931.5,
        1008
      ],
      [
        -1311.5,
        -3930,
        1008
      ]
    ],
    "dimensions": [
      20,
      1.5,
      7
    ],
    "dimensionsMeters": [
      1,
      0.15,
      0.35
    ],
    "maxDimensionMeters": 1,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/breakable_2_mt02b.glb"
  },
  {
    "id": "breakable_3_mt02b",
    "sector": "mt02b",
    "type": "breakable",
    "texture": "chkptroofgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptroofgrate1-t)",
    "availableSwatches": [
      "chkptroofgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1344.5,
      -3935.75,
      1014
    ],
    "vertices": [
      [
        -1349.5,
        -3940,
        1013.5
      ],
      [
        -1349.5,
        -3931.5,
        1014.5
      ],
      [
        -1349.5,
        -3940,
        1014.5
      ],
      [
        -1349.5,
        -3931.5,
        1013.5
      ],
      [
        -1339.5,
        -3940,
        1013.5
      ],
      [
        -1339.5,
        -3931.5,
        1014.5
      ],
      [
        -1339.5,
        -3940,
        1014.5
      ],
      [
        -1339.5,
        -3931.5,
        1013.5
      ]
    ],
    "dimensions": [
      10,
      8.5,
      1
    ],
    "dimensionsMeters": [
      0.5,
      0.43,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_3_mt02b.glb"
  },
  {
    "id": "door_recharge",
    "sector": "mt02b",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: recharge",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1303.5,
      -3957.89990234375,
      1018.5499877929688
    ],
    "vertices": [
      [
        -1305,
        -3957.89990234375,
        1017.5999755859375
      ],
      [
        -1302,
        -3957.89990234375,
        1019.5
      ],
      [
        -1302,
        -3957.89990234375,
        1017.5999755859375
      ],
      [
        -1305,
        -3957.89990234375,
        1019.5
      ]
    ],
    "dimensions": [
      3,
      0,
      1.9000244140625
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_recharge.glb"
  },
  {
    "id": "unknown_mt02c",
    "sector": "mt02c",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt02c",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1607.2750244140625,
      -3809.6500244140625,
      1001.0250091552734
    ],
    "vertices": [
      [
        -1666,
        -3944.5,
        1035.5
      ],
      [
        -1666,
        -3935.5,
        1035.5
      ],
      [
        -1666,
        -3935.5,
        1040
      ],
      [
        -1666,
        -3944.5,
        1040
      ],
      [
        -1555.800048828125,
        -3679.300048828125,
        958.2000122070312
      ],
      [
        -1555.800048828125,
        -3679.300048828125,
        970.4000244140625
      ],
      [
        -1541.300048828125,
        -3679.300048828125,
        970.4000244140625
      ],
      [
        -1541.300048828125,
        -3679.300048828125,
        958.2000122070312
      ]
    ],
    "dimensions": [
      124.699951171875,
      265.199951171875,
      81.79998779296875
    ],
    "dimensionsMeters": [
      6.23,
      13.26,
      4.09
    ],
    "maxDimensionMeters": 13.26,
    "pedestalFitScale": 0.121,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/unknown_mt02c.glb"
  },
  {
    "id": "breakable_mt02c",
    "sector": "mt02c",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 28,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1679,
      -3940,
      1035.5
    ],
    "vertices": [
      [
        -1679,
        -3944,
        1035.5
      ],
      [
        -1674,
        -3940,
        1035.5
      ],
      [
        -1675.25,
        -3943,
        1035.5
      ],
      [
        -1684,
        -3940,
        1035.5
      ],
      [
        -1682.75,
        -3943,
        1035.5
      ],
      [
        -1679,
        -3936,
        1035.5
      ],
      [
        -1675.25,
        -3937,
        1035.5
      ],
      [
        -1682.75,
        -3937,
        1035.5
      ]
    ],
    "dimensions": [
      10,
      8,
      0
    ],
    "dimensionsMeters": [
      0.5,
      0.4,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": null,
    "file": "props/breakable_mt02c.glb"
  },
  {
    "id": "unknown_mt02d",
    "sector": "mt02d",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt02d",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1551.1278381347656,
      -3777.541748046875,
      1173.1500091552734
    ],
    "vertices": [
      [
        -1555.800048828125,
        -3679.300048828125,
        958.2000122070312
      ],
      [
        -1541.300048828125,
        -3679.300048828125,
        958.2000122070312
      ],
      [
        -1541.300048828125,
        -3679.300048828125,
        970.4000244140625
      ],
      [
        -1555.800048828125,
        -3679.300048828125,
        970.4000244140625
      ],
      [
        -1567.888427734375,
        -3880.6669921875,
        1372
      ],
      [
        -1567.888427734375,
        -3880.6669921875,
        1392
      ],
      [
        -1539.5228271484375,
        -3870.89990234375,
        1392
      ],
      [
        -1539.5228271484375,
        -3870.89990234375,
        1372
      ]
    ],
    "dimensions": [
      28.3656005859375,
      201.366943359375,
      433.79998779296875
    ],
    "dimensionsMeters": [
      1.42,
      10.07,
      21.69
    ],
    "maxDimensionMeters": 21.69,
    "pedestalFitScale": 0.074,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/unknown_mt02d.glb"
  },
  {
    "id": "breakable_mt02d",
    "sector": "mt02d",
    "type": "breakable",
    "texture": "chkcrate-s_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkcrate-s_h)",
    "availableSwatches": [
      "chkcrate-s_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 28,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1572.800048828125,
      -3641.5,
      972.5
    ],
    "vertices": [
      [
        -1572.800048828125,
        -3639.414306640625,
        968.5
      ],
      [
        -1572.800048828125,
        -3643.585693359375,
        968.5
      ],
      [
        -1572.800048828125,
        -3646,
        970.9141845703125
      ],
      [
        -1572.800048828125,
        -3646,
        974.0858154296875
      ],
      [
        -1572.800048828125,
        -3643.585693359375,
        976.5
      ],
      [
        -1572.800048828125,
        -3639.414306640625,
        976.5
      ],
      [
        -1572.800048828125,
        -3637,
        974.0858154296875
      ],
      [
        -1572.800048828125,
        -3637,
        970.9141845703125
      ]
    ],
    "dimensions": [
      0,
      9,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.45,
      0.4
    ],
    "maxDimensionMeters": 0.45,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": null,
    "file": "props/breakable_mt02d.glb"
  },
  {
    "id": "unknown_mt02e",
    "sector": "mt02e",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt02e",
    "sourceVertexCount": 12,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1587.1018676757812,
      -3728.9278157552085,
      1368.3333333333333
    ],
    "vertices": [
      [
        -1627,
        -3785.5,
        1230.5
      ],
      [
        -1627,
        -3772.5,
        1230.5
      ],
      [
        -1612.5,
        -3772.5,
        1230.5
      ],
      [
        -1612.5,
        -3785.5,
        1230.5
      ],
      [
        -1567.888427734375,
        -3880.6669921875,
        1372
      ],
      [
        -1539.5228271484375,
        -3870.89990234375,
        1372
      ],
      [
        -1539.5228271484375,
        -3870.89990234375,
        1392
      ],
      [
        -1567.888427734375,
        -3880.6669921875,
        1392
      ],
      [
        -1590.0999755859375,
        -3532,
        1490
      ],
      [
        -1590.0999755859375,
        -3532,
        1495
      ],
      [
        -1585.5999755859375,
        -3532,
        1495
      ],
      [
        -1585.5999755859375,
        -3532,
        1490
      ]
    ],
    "dimensions": [
      87.4771728515625,
      348.6669921875,
      264.5
    ],
    "dimensionsMeters": [
      4.37,
      17.43,
      13.23
    ],
    "maxDimensionMeters": 17.43,
    "pedestalFitScale": 0.092,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/unknown_mt02e.glb"
  },
  {
    "id": "unknown_mt02f",
    "sector": "mt02f",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt02f",
    "sourceVertexCount": 30,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1624.9752197265625,
      -3404.5833333333335,
      1018.0792154947917
    ],
    "vertices": [
      [
        -1590.0999755859375,
        -3532,
        1490
      ],
      [
        -1585.5999755859375,
        -3532,
        1490
      ],
      [
        -1585.5999755859375,
        -3532,
        1495
      ],
      [
        -1590.0999755859375,
        -3532,
        1495
      ],
      [
        -1606,
        -3426.5,
        892
      ],
      [
        -1606,
        -3411.5,
        892
      ],
      [
        -1606,
        -3411.5,
        915
      ],
      [
        -1606,
        -3426.5,
        915
      ],
      [
        -1475,
        -3730,
        904.5354614257812
      ],
      [
        -2218.0556640625,
        -3730,
        1089.800048828125
      ],
      [
        -1624.5,
        -3441.5,
        941.8099975585938
      ],
      [
        -1624.5,
        -3441.5,
        941.8099975585938
      ],
      [
        -1610,
        -3441.5,
        938.1947631835938
      ],
      [
        -1475,
        -3730,
        904.5354614257812
      ],
      [
        -2218.0556640625,
        -3730,
        1089.800048828125
      ],
      [
        -2218.0556640625,
        -2885,
        1089.800048828125
      ],
      [
        -1624.5,
        -3426.5,
        941.8099975585938
      ],
      [
        -1624.5,
        -3441.5,
        941.8099975585938
      ],
      [
        -2218.0556640625,
        -2885,
        1089.800048828125
      ],
      [
        -1475,
        -2885,
        904.5354614257812
      ],
      [
        -1610,
        -3426.5,
        938.1947631835938
      ],
      [
        -1624.5,
        -3426.5,
        941.8099975585938
      ],
      [
        -1475,
        -2885,
        904.5354614257812
      ],
      [
        -1475,
        -3730,
        904.5354614257812
      ],
      [
        -1610,
        -3441.5,
        938.1947631835938
      ],
      [
        -1610,
        -3426.5,
        938.1947631835938
      ],
      [
        -1107.0670166015625,
        -2885,
        902.7994995117188
      ],
      [
        -1107.0670166015625,
        -3730,
        902.7994995117188
      ],
      [
        -1475,
        -3730,
        904.5354614257812
      ],
      [
        -1475,
        -2885,
        904.5354614257812
      ]
    ],
    "dimensions": [
      1110.9886474609375,
      845,
      603
    ],
    "dimensionsMeters": [
      55.55,
      42.25,
      30.15
    ],
    "maxDimensionMeters": 55.55,
    "pedestalFitScale": 0.029,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/unknown_mt02f.glb"
  },
  {
    "id": "breakable_mt02f",
    "sector": "mt02f",
    "type": "breakable",
    "texture": "chkcopperpipe1grn",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkcopperpipe1grn)",
    "availableSwatches": [
      "chkcopperpipe1grn",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 17,
    "exportedTriangleCount": 30,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1588,
      -3521.9005485983457,
      1486.3389389935662
    ],
    "vertices": [
      [
        -1586.2779541015625,
        -3521.842529296875,
        1488.2188720703125
      ],
      [
        -1585.9000244140625,
        -3522.094970703125,
        1487.4000244140625
      ],
      [
        -1585.699951171875,
        -3522.228759765625,
        1486.199951171875
      ],
      [
        -1585.9000244140625,
        -3522.094970703125,
        1484.5
      ],
      [
        -1586.2779541015625,
        -3521.842529296875,
        1483.9803466796875
      ],
      [
        -1588,
        -3521.5,
        1489.1285400390625
      ],
      [
        -1587.5999755859375,
        -3521.57958984375,
        1489.0999755859375
      ],
      [
        -1586.5,
        -3521.79833984375,
        1488.699951171875
      ],
      [
        -1586.699951171875,
        -3521.758544921875,
        1483.4000244140625
      ],
      [
        -1588,
        -3521.5,
        1483
      ],
      [
        -1589,
        -3521.698974609375,
        1489.199951171875
      ],
      [
        -1589.5,
        -3521.79833984375,
        1483.300048828125
      ],
      [
        -1589.7220458984375,
        -3521.842529296875,
        1483.6453857421875
      ],
      [
        -1589.7220458984375,
        -3521.842529296875,
        1488.5889892578125
      ],
      [
        -1590.4000244140625,
        -3522.295654296875,
        1484.699951171875
      ],
      [
        -1590.5,
        -3522.3623046875,
        1486.5999755859375
      ],
      [
        -1590.300048828125,
        -3522.228759765625,
        1488.0999755859375
      ]
    ],
    "dimensions": [
      4.800048828125,
      0.8623046875,
      6.199951171875
    ],
    "dimensionsMeters": [
      0.24,
      0.15,
      0.31
    ],
    "maxDimensionMeters": 0.31,
    "pedestalFitScale": 1.935,
    "slideAxis": "x",
    "slideVector": null,
    "file": "props/breakable_mt02f.glb"
  },
  {
    "id": "breakable_2_mt02f",
    "sector": "mt02f",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1606.25,
      -3509.25,
      1485.25
    ],
    "vertices": [
      [
        -1609,
        -3512,
        1482.5
      ],
      [
        -1609,
        -3506.5,
        1488
      ],
      [
        -1609,
        -3512,
        1488
      ],
      [
        -1609,
        -3506.5,
        1482.5
      ],
      [
        -1603.5,
        -3512,
        1482.5
      ],
      [
        -1603.5,
        -3506.5,
        1488
      ],
      [
        -1603.5,
        -3512,
        1488
      ],
      [
        -1603.5,
        -3506.5,
        1482.5
      ]
    ],
    "dimensions": [
      5.5,
      5.5,
      5.5
    ],
    "dimensionsMeters": [
      0.28,
      0.28,
      0.28
    ],
    "maxDimensionMeters": 0.28,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/breakable_2_mt02f.glb"
  },
  {
    "id": "breakable_3_mt02f",
    "sector": "mt02f",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1606.25,
      -3502.25,
      1485.25
    ],
    "vertices": [
      [
        -1609,
        -3505,
        1482.5
      ],
      [
        -1609,
        -3499.5,
        1488
      ],
      [
        -1609,
        -3505,
        1488
      ],
      [
        -1609,
        -3499.5,
        1482.5
      ],
      [
        -1603.5,
        -3505,
        1482.5
      ],
      [
        -1603.5,
        -3499.5,
        1488
      ],
      [
        -1603.5,
        -3505,
        1488
      ],
      [
        -1603.5,
        -3499.5,
        1482.5
      ]
    ],
    "dimensions": [
      5.5,
      5.5,
      5.5
    ],
    "dimensionsMeters": [
      0.28,
      0.28,
      0.28
    ],
    "maxDimensionMeters": 0.28,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/breakable_3_mt02f.glb"
  },
  {
    "id": "door_bridelev",
    "sector": "mt02gmv",
    "type": "door",
    "texture": "spkelevfloor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevfloor1)",
    "availableSwatches": [
      "spkelevfloor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: bridelev",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -1617.25,
      -3434,
      1438.75
    ],
    "vertices": [
      [
        -1624.5,
        -3441.5,
        1438.5
      ],
      [
        -1624.5,
        -3426.5,
        1439
      ],
      [
        -1624.5,
        -3441.5,
        1439
      ],
      [
        -1624.5,
        -3426.5,
        1438.5
      ],
      [
        -1610,
        -3441.5,
        1438.5
      ],
      [
        -1610,
        -3426.5,
        1439
      ],
      [
        -1610,
        -3441.5,
        1439
      ],
      [
        -1610,
        -3426.5,
        1438.5
      ]
    ],
    "dimensions": [
      14.5,
      15,
      0.5
    ],
    "dimensionsMeters": [
      0.73,
      0.75,
      0.15
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_bridelev.glb"
  },
  {
    "id": "unknown_mt03a",
    "sector": "mt03a",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt03a",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -957.25,
      -2795.625,
      784
    ],
    "vertices": [
      [
        -991.5,
        -2763,
        720
      ],
      [
        -991.5,
        -2723,
        720
      ],
      [
        -991.5,
        -2723,
        760
      ],
      [
        -991.5,
        -2763,
        760
      ],
      [
        -928.5,
        -2854.5,
        828
      ],
      [
        -928.5,
        -2842,
        828
      ],
      [
        -917.5,
        -2842,
        828
      ],
      [
        -917.5,
        -2854.5,
        828
      ]
    ],
    "dimensions": [
      74,
      131.5,
      108
    ],
    "dimensionsMeters": [
      3.7,
      6.58,
      5.4
    ],
    "maxDimensionMeters": 6.58,
    "pedestalFitScale": 0.243,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/unknown_mt03a.glb"
  },
  {
    "id": "unknown_mt03b",
    "sector": "mt03b",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt03b",
    "sourceVertexCount": 12,
    "exportedTriangleCount": 14,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -829.5,
      -2745,
      754.5
    ],
    "vertices": [
      [
        -872.5,
        -2748.5,
        721
      ],
      [
        -872.5,
        -2748.5,
        730
      ],
      [
        -872.5,
        -2741.5,
        730
      ],
      [
        -872.5,
        -2741.5,
        721
      ],
      [
        -808,
        -2782,
        762
      ],
      [
        -808,
        -2768,
        762
      ],
      [
        -808,
        -2768,
        776
      ],
      [
        -808,
        -2782,
        776
      ],
      [
        -808,
        -2722,
        762
      ],
      [
        -808,
        -2708,
        762
      ],
      [
        -808,
        -2708,
        776
      ],
      [
        -808,
        -2722,
        776
      ]
    ],
    "dimensions": [
      64.5,
      74,
      55
    ],
    "dimensionsMeters": [
      3.23,
      3.7,
      2.75
    ],
    "maxDimensionMeters": 3.7,
    "pedestalFitScale": 0.432,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/unknown_mt03b.glb"
  },
  {
    "id": "door_m3bd1t",
    "sector": "mt03b",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m3bd1t",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -824.5,
      -2715,
      771.75
    ],
    "vertices": [
      [
        -824.9000244140625,
        -2710.89990234375,
        774
      ],
      [
        -824.9000244140625,
        -2719.10009765625,
        774
      ],
      [
        -824.0999755859375,
        -2710.89990234375,
        774
      ],
      [
        -824.0999755859375,
        -2719.10009765625,
        774
      ],
      [
        -824.9000244140625,
        -2709.5,
        769.5
      ],
      [
        -824.9000244140625,
        -2720.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2720.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2709.5,
        769.5
      ]
    ],
    "dimensions": [
      0.800048828125,
      11,
      4.5
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.23
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_m3bd1t.glb"
  },
  {
    "id": "door_m3bd1b",
    "sector": "mt03b",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m3bd1b",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -824.5,
      -2715,
      767.25
    ],
    "vertices": [
      [
        -824.9000244140625,
        -2719.10009765625,
        765
      ],
      [
        -824.9000244140625,
        -2710.89990234375,
        765
      ],
      [
        -824.0999755859375,
        -2719.10009765625,
        765
      ],
      [
        -824.0999755859375,
        -2710.89990234375,
        765
      ],
      [
        -824.9000244140625,
        -2709.5,
        769.5
      ],
      [
        -824.9000244140625,
        -2720.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2720.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2709.5,
        769.5
      ]
    ],
    "dimensions": [
      0.800048828125,
      11,
      4.5
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.23
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_m3bd1b.glb"
  },
  {
    "id": "door_m3bd2l",
    "sector": "mt03b",
    "type": "door",
    "texture": "chksecdoorshut_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chksecdoorshut_h)",
    "availableSwatches": [
      "chksecdoorshut_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m3bd2l",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -809,
      -2718.499969482422,
      770.5
    ],
    "vertices": [
      [
        -809.7999877929688,
        -2722,
        766
      ],
      [
        -809.7999877929688,
        -2710.89990234375,
        775
      ],
      [
        -809.7999877929688,
        -2722,
        775
      ],
      [
        -809.7999877929688,
        -2719.10009765625,
        766
      ],
      [
        -809,
        -2722,
        766
      ],
      [
        -809,
        -2710.89990234375,
        775
      ],
      [
        -809,
        -2722,
        775
      ],
      [
        -809,
        -2719.10009765625,
        766
      ],
      [
        -809,
        -2710.89990234375,
        766
      ],
      [
        -809,
        -2722,
        766
      ],
      [
        -809,
        -2722,
        775
      ],
      [
        -809,
        -2719.099853515625,
        775
      ],
      [
        -808.2000122070312,
        -2710.89990234375,
        766
      ],
      [
        -808.2000122070312,
        -2719.099853515625,
        775
      ],
      [
        -808.2000122070312,
        -2722,
        775
      ],
      [
        -808.2000122070312,
        -2722,
        766
      ]
    ],
    "dimensions": [
      1.5999755859375,
      11.10009765625,
      9
    ],
    "dimensionsMeters": [
      0.15,
      0.56,
      0.45
    ],
    "maxDimensionMeters": 0.56,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m3bd2l.glb"
  },
  {
    "id": "door_m3bd2r",
    "sector": "mt03b",
    "type": "door",
    "texture": "chksecdoorshut_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chksecdoorshut_h)",
    "availableSwatches": [
      "chksecdoorshut_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m3bd2r",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 18,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -809,
      -2711.500030517578,
      770.5
    ],
    "vertices": [
      [
        -809,
        -2708,
        766
      ],
      [
        -809,
        -2710.89990234375,
        766
      ],
      [
        -809,
        -2719.10009765625,
        775
      ],
      [
        -809,
        -2708,
        775
      ],
      [
        -808.2000122070312,
        -2708,
        766
      ],
      [
        -808.2000122070312,
        -2708,
        775
      ],
      [
        -808.2000122070312,
        -2719.10009765625,
        775
      ],
      [
        -808.2000122070312,
        -2710.89990234375,
        766
      ],
      [
        -809.7999877929688,
        -2719.10009765625,
        766
      ],
      [
        -809.7999877929688,
        -2708,
        775
      ],
      [
        -809.7999877929688,
        -2710.900146484375,
        775
      ],
      [
        -809.7999877929688,
        -2708,
        766
      ],
      [
        -809,
        -2719.10009765625,
        766
      ],
      [
        -809,
        -2708,
        775
      ],
      [
        -809,
        -2710.900146484375,
        775
      ],
      [
        -809,
        -2708,
        766
      ]
    ],
    "dimensions": [
      1.5999755859375,
      11.10009765625,
      9
    ],
    "dimensionsMeters": [
      0.15,
      0.56,
      0.45
    ],
    "maxDimensionMeters": 0.56,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m3bd2r.glb"
  },
  {
    "id": "door_m3bd3top",
    "sector": "mt03b",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m3bd3top",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -824.5,
      -2775,
      771.75
    ],
    "vertices": [
      [
        -824.9000244140625,
        -2770.89990234375,
        774
      ],
      [
        -824.9000244140625,
        -2779.10009765625,
        774
      ],
      [
        -824.0999755859375,
        -2770.89990234375,
        774
      ],
      [
        -824.0999755859375,
        -2779.10009765625,
        774
      ],
      [
        -824.9000244140625,
        -2769.5,
        769.5
      ],
      [
        -824.9000244140625,
        -2780.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2780.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2769.5,
        769.5
      ]
    ],
    "dimensions": [
      0.800048828125,
      11,
      4.5
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.23
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_m3bd3top.glb"
  },
  {
    "id": "door_m3bd3bot",
    "sector": "mt03b",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m3bd3bot",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -824.5,
      -2775,
      767.25
    ],
    "vertices": [
      [
        -824.9000244140625,
        -2779.10009765625,
        765
      ],
      [
        -824.9000244140625,
        -2770.89990234375,
        765
      ],
      [
        -824.0999755859375,
        -2779.10009765625,
        765
      ],
      [
        -824.0999755859375,
        -2770.89990234375,
        765
      ],
      [
        -824.9000244140625,
        -2769.5,
        769.5
      ],
      [
        -824.9000244140625,
        -2780.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2780.5,
        769.5
      ],
      [
        -824.0999755859375,
        -2769.5,
        769.5
      ]
    ],
    "dimensions": [
      0.800048828125,
      11,
      4.5
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.23
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_m3bd3bot.glb"
  },
  {
    "id": "door_scan1l",
    "sector": "mt03b",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: scan1l",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -816.75,
      -2735.200048828125,
      769.7
    ],
    "vertices": [
      [
        -819.5,
        -2741.800048828125,
        765
      ],
      [
        -814,
        -2741.800048828125,
        765
      ],
      [
        -819.5,
        -2741.800048828125,
        777.5
      ],
      [
        -814,
        -2741.800048828125,
        777.5
      ],
      [
        -818,
        -2730.800048828125,
        765
      ],
      [
        -818,
        -2730.800048828125,
        772
      ],
      [
        -818,
        -2730.800048828125,
        769
      ],
      [
        -815.5,
        -2730.800048828125,
        772
      ],
      [
        -815.5,
        -2730.800048828125,
        765
      ],
      [
        -815.5,
        -2730.800048828125,
        769
      ]
    ],
    "dimensions": [
      5.5,
      11,
      12.5
    ],
    "dimensionsMeters": [
      0.28,
      0.55,
      0.63
    ],
    "maxDimensionMeters": 0.63,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_scan1l.glb"
  },
  {
    "id": "door_scan1r",
    "sector": "mt03b",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: scan1r",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -816.75,
      -2694.799951171875,
      769.7
    ],
    "vertices": [
      [
        -819.5,
        -2688.199951171875,
        765
      ],
      [
        -814,
        -2688.199951171875,
        765
      ],
      [
        -819.5,
        -2688.199951171875,
        777.5
      ],
      [
        -814,
        -2688.199951171875,
        777.5
      ],
      [
        -818,
        -2699.199951171875,
        769
      ],
      [
        -818,
        -2699.199951171875,
        772
      ],
      [
        -818,
        -2699.199951171875,
        765
      ],
      [
        -815.5,
        -2699.199951171875,
        772
      ],
      [
        -815.5,
        -2699.199951171875,
        765
      ],
      [
        -815.5,
        -2699.199951171875,
        769
      ]
    ],
    "dimensions": [
      5.5,
      11,
      12.5
    ],
    "dimensionsMeters": [
      0.28,
      0.55,
      0.63
    ],
    "maxDimensionMeters": 0.63,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_scan1r.glb"
  },
  {
    "id": "breakable_mt03b",
    "sector": "mt03b",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -816.75,
      -2729.97998046875,
      783.5
    ],
    "vertices": [
      [
        -815.5,
        -2729.97998046875,
        785
      ],
      [
        -818,
        -2729.97998046875,
        785
      ],
      [
        -815.5,
        -2729.97998046875,
        782
      ],
      [
        -818,
        -2729.97998046875,
        782
      ]
    ],
    "dimensions": [
      2.5,
      0,
      3
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/breakable_mt03b.glb"
  },
  {
    "id": "door_mt3mvd3l",
    "sector": "mt03mv3",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: mt3mvd3l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -872,
      -2746.75,
      725.5
    ],
    "vertices": [
      [
        -872.4000244140625,
        -2748.5,
        721
      ],
      [
        -872.4000244140625,
        -2745,
        730
      ],
      [
        -872.4000244140625,
        -2748.5,
        730
      ],
      [
        -872.4000244140625,
        -2745,
        721
      ],
      [
        -871.5999755859375,
        -2748.5,
        721
      ],
      [
        -871.5999755859375,
        -2745,
        730
      ],
      [
        -871.5999755859375,
        -2748.5,
        730
      ],
      [
        -871.5999755859375,
        -2745,
        721
      ]
    ],
    "dimensions": [
      0.800048828125,
      3.5,
      9
    ],
    "dimensionsMeters": [
      0.15,
      0.18,
      0.45
    ],
    "maxDimensionMeters": 0.45,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_mt3mvd3l.glb"
  },
  {
    "id": "door_mt3mvd3r",
    "sector": "mt03mv3",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: mt3mvd3r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -872,
      -2743.25,
      725.5
    ],
    "vertices": [
      [
        -872.4000244140625,
        -2745,
        721
      ],
      [
        -872.4000244140625,
        -2741.5,
        730
      ],
      [
        -872.4000244140625,
        -2745,
        730
      ],
      [
        -872.4000244140625,
        -2741.5,
        721
      ],
      [
        -871.5999755859375,
        -2745,
        721
      ],
      [
        -871.5999755859375,
        -2741.5,
        730
      ],
      [
        -871.5999755859375,
        -2745,
        730
      ],
      [
        -871.5999755859375,
        -2741.5,
        721
      ]
    ],
    "dimensions": [
      0.800048828125,
      3.5,
      9
    ],
    "dimensionsMeters": [
      0.15,
      0.18,
      0.45
    ],
    "maxDimensionMeters": 0.45,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_mt3mvd3r.glb"
  },
  {
    "id": "door_mt3mvd4b",
    "sector": "mt03mv4",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: mt3mvd4b",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -991.5,
      -2743,
      728.75
    ],
    "vertices": [
      [
        -992.5,
        -2762,
        720
      ],
      [
        -992.5,
        -2724,
        737.5
      ],
      [
        -992.5,
        -2762,
        737.5
      ],
      [
        -992.5,
        -2724,
        720
      ],
      [
        -990.5,
        -2762,
        720
      ],
      [
        -990.5,
        -2724,
        737.5
      ],
      [
        -990.5,
        -2762,
        737.5
      ],
      [
        -990.5,
        -2724,
        720
      ]
    ],
    "dimensions": [
      2,
      38,
      17.5
    ],
    "dimensionsMeters": [
      0.15,
      1.9,
      0.88
    ],
    "maxDimensionMeters": 1.9,
    "pedestalFitScale": 0.842,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_mt3mvd4b.glb"
  },
  {
    "id": "door_mt3mvd4t",
    "sector": "mt03mv4",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: mt3mvd4t",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -991.5,
      -2743,
      746.75
    ],
    "vertices": [
      [
        -992.5,
        -2762,
        737.5
      ],
      [
        -992.5,
        -2724,
        756
      ],
      [
        -992.5,
        -2762,
        756
      ],
      [
        -992.5,
        -2724,
        737.5
      ],
      [
        -990.5,
        -2762,
        737.5
      ],
      [
        -990.5,
        -2724,
        756
      ],
      [
        -990.5,
        -2762,
        756
      ],
      [
        -990.5,
        -2724,
        737.5
      ]
    ],
    "dimensions": [
      2,
      38,
      18.5
    ],
    "dimensionsMeters": [
      0.15,
      1.9,
      0.93
    ],
    "maxDimensionMeters": 1.9,
    "pedestalFitScale": 0.842,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_mt3mvd4t.glb"
  },
  {
    "id": "unknown_mt04a",
    "sector": "mt04a",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt04a",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -672.0997314453125,
      -2697.375,
      803
    ],
    "vertices": [
      [
        -640,
        -2628,
        790
      ],
      [
        -640,
        -2628,
        760
      ],
      [
        -640,
        -2671,
        760
      ],
      [
        -640,
        -2671,
        790
      ],
      [
        -700,
        -2675,
        810
      ],
      [
        -700,
        -2675,
        826
      ],
      [
        -700,
        -2625,
        826
      ],
      [
        -700,
        -2625,
        810
      ],
      [
        -661.6666870117188,
        -2802,
        782.6233520507812
      ],
      [
        -674.89892578125,
        -2802,
        811
      ],
      [
        -674.89892578125,
        -2688,
        811
      ],
      [
        -661.6666870117188,
        -2688,
        782.6233520507812
      ],
      [
        -685.3333129882812,
        -2688,
        833.3766479492188
      ],
      [
        -674.89892578125,
        -2688,
        811
      ],
      [
        -674.89892578125,
        -2802,
        811
      ],
      [
        -685.3333129882812,
        -2802,
        833.3766479492188
      ]
    ],
    "dimensions": [
      60,
      177,
      73.37664794921875
    ],
    "dimensionsMeters": [
      3,
      8.85,
      3.67
    ],
    "maxDimensionMeters": 8.85,
    "pedestalFitScale": 0.181,
    "slideAxis": "z",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/unknown_mt04a.glb"
  },
  {
    "id": "door_m4ad3l",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad3l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -582.1000061035156,
      -2675.5,
      800
    ],
    "vertices": [
      [
        -585,
        -2675.800048828125,
        795
      ],
      [
        -585,
        -2675.199951171875,
        805
      ],
      [
        -585,
        -2675.800048828125,
        805
      ],
      [
        -585,
        -2675.199951171875,
        795
      ],
      [
        -579.2000122070312,
        -2675.800048828125,
        795
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        805
      ],
      [
        -579.2000122070312,
        -2675.800048828125,
        805
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        795
      ]
    ],
    "dimensions": [
      5.79998779296875,
      0.60009765625,
      10
    ],
    "dimensionsMeters": [
      0.29,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_m4ad3l.glb"
  },
  {
    "id": "door_m4ad3r",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad3r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -576.3500061035156,
      -2675.5,
      800
    ],
    "vertices": [
      [
        -579.2000122070312,
        -2675.800048828125,
        795
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        805
      ],
      [
        -579.2000122070312,
        -2675.800048828125,
        805
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        795
      ],
      [
        -573.5,
        -2675.800048828125,
        795
      ],
      [
        -573.5,
        -2675.199951171875,
        805
      ],
      [
        -573.5,
        -2675.800048828125,
        805
      ],
      [
        -573.5,
        -2675.199951171875,
        795
      ]
    ],
    "dimensions": [
      5.70001220703125,
      0.60009765625,
      10
    ],
    "dimensionsMeters": [
      0.29,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad3r.glb"
  },
  {
    "id": "door_m4ad4l",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad4l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2701.5,
      799
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2704,
        795
      ],
      [
        -596.5999755859375,
        -2699,
        803
      ],
      [
        -596.5999755859375,
        -2704,
        803
      ],
      [
        -596.5999755859375,
        -2699,
        795
      ],
      [
        -595.4000244140625,
        -2704,
        795
      ],
      [
        -595.4000244140625,
        -2699,
        803
      ],
      [
        -595.4000244140625,
        -2704,
        803
      ],
      [
        -595.4000244140625,
        -2699,
        795
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad4l.glb"
  },
  {
    "id": "door_m4ad4r",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad4r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2696.5,
      799
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2699,
        795
      ],
      [
        -596.5999755859375,
        -2694,
        803
      ],
      [
        -596.5999755859375,
        -2699,
        803
      ],
      [
        -596.5999755859375,
        -2694,
        795
      ],
      [
        -595.4000244140625,
        -2699,
        795
      ],
      [
        -595.4000244140625,
        -2694,
        803
      ],
      [
        -595.4000244140625,
        -2699,
        803
      ],
      [
        -595.4000244140625,
        -2694,
        795
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad4r.glb"
  },
  {
    "id": "door_m4ad5l",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad5l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2767.5,
      799
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2770,
        795
      ],
      [
        -596.5999755859375,
        -2765,
        803
      ],
      [
        -596.5999755859375,
        -2770,
        803
      ],
      [
        -596.5999755859375,
        -2765,
        795
      ],
      [
        -595.4000244140625,
        -2770,
        795
      ],
      [
        -595.4000244140625,
        -2765,
        803
      ],
      [
        -595.4000244140625,
        -2770,
        803
      ],
      [
        -595.4000244140625,
        -2765,
        795
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad5l.glb"
  },
  {
    "id": "door_m4ad5r",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad5r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2762.5,
      799
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2765,
        795
      ],
      [
        -596.5999755859375,
        -2760,
        803
      ],
      [
        -596.5999755859375,
        -2765,
        803
      ],
      [
        -596.5999755859375,
        -2760,
        795
      ],
      [
        -595.4000244140625,
        -2765,
        795
      ],
      [
        -595.4000244140625,
        -2760,
        803
      ],
      [
        -595.4000244140625,
        -2765,
        803
      ],
      [
        -595.4000244140625,
        -2760,
        795
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad5r.glb"
  },
  {
    "id": "door_m4ad6l",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad6l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -582.1000061035156,
      -2675.5,
      815.5
    ],
    "vertices": [
      [
        -585,
        -2675.800048828125,
        810.5
      ],
      [
        -585,
        -2675.199951171875,
        820.5
      ],
      [
        -585,
        -2675.800048828125,
        820.5
      ],
      [
        -585,
        -2675.199951171875,
        810.5
      ],
      [
        -579.2000122070312,
        -2675.800048828125,
        810.5
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        820.5
      ],
      [
        -579.2000122070312,
        -2675.800048828125,
        820.5
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        810.5
      ]
    ],
    "dimensions": [
      5.79998779296875,
      0.60009765625,
      10
    ],
    "dimensionsMeters": [
      0.29,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_m4ad6l.glb"
  },
  {
    "id": "door_m4ad6r",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad6r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -576.3500061035156,
      -2675.5,
      815.5
    ],
    "vertices": [
      [
        -579.2000122070312,
        -2675.800048828125,
        810.5
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        820.5
      ],
      [
        -579.2000122070312,
        -2675.800048828125,
        820.5
      ],
      [
        -579.2000122070312,
        -2675.199951171875,
        810.5
      ],
      [
        -573.5,
        -2675.800048828125,
        810.5
      ],
      [
        -573.5,
        -2675.199951171875,
        820.5
      ],
      [
        -573.5,
        -2675.800048828125,
        820.5
      ],
      [
        -573.5,
        -2675.199951171875,
        810.5
      ]
    ],
    "dimensions": [
      5.70001220703125,
      0.60009765625,
      10
    ],
    "dimensionsMeters": [
      0.29,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad6r.glb"
  },
  {
    "id": "door_m4ad7l",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad7l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2701.5,
      816
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2704,
        812
      ],
      [
        -596.5999755859375,
        -2699,
        820
      ],
      [
        -596.5999755859375,
        -2704,
        820
      ],
      [
        -596.5999755859375,
        -2699,
        812
      ],
      [
        -595.4000244140625,
        -2704,
        812
      ],
      [
        -595.4000244140625,
        -2699,
        820
      ],
      [
        -595.4000244140625,
        -2704,
        820
      ],
      [
        -595.4000244140625,
        -2699,
        812
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad7l.glb"
  },
  {
    "id": "door_m4ad7r",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad7r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2696.5,
      816
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2699,
        812
      ],
      [
        -596.5999755859375,
        -2694,
        820
      ],
      [
        -596.5999755859375,
        -2699,
        820
      ],
      [
        -596.5999755859375,
        -2694,
        812
      ],
      [
        -595.4000244140625,
        -2699,
        812
      ],
      [
        -595.4000244140625,
        -2694,
        820
      ],
      [
        -595.4000244140625,
        -2699,
        820
      ],
      [
        -595.4000244140625,
        -2694,
        812
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad7r.glb"
  },
  {
    "id": "door_m4ad8l",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad8l",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2767.5,
      816
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2770,
        812
      ],
      [
        -596.5999755859375,
        -2765,
        820
      ],
      [
        -596.5999755859375,
        -2770,
        820
      ],
      [
        -596.5999755859375,
        -2765,
        812
      ],
      [
        -595.4000244140625,
        -2770,
        812
      ],
      [
        -595.4000244140625,
        -2765,
        820
      ],
      [
        -595.4000244140625,
        -2770,
        820
      ],
      [
        -595.4000244140625,
        -2765,
        812
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad8l.glb"
  },
  {
    "id": "door_m4ad8r",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad8r",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -596,
      -2762.5,
      816
    ],
    "vertices": [
      [
        -596.5999755859375,
        -2765,
        812
      ],
      [
        -596.5999755859375,
        -2760,
        820
      ],
      [
        -596.5999755859375,
        -2765,
        820
      ],
      [
        -596.5999755859375,
        -2760,
        812
      ],
      [
        -595.4000244140625,
        -2765,
        812
      ],
      [
        -595.4000244140625,
        -2760,
        820
      ],
      [
        -595.4000244140625,
        -2765,
        820
      ],
      [
        -595.4000244140625,
        -2760,
        812
      ]
    ],
    "dimensions": [
      1.199951171875,
      5,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad8r.glb"
  },
  {
    "id": "door_m4ad10",
    "sector": "mt04a",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4ad10",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -608.5,
      -2650,
      815.25
    ],
    "vertices": [
      [
        -609.3499755859375,
        -2665,
        810.5
      ],
      [
        -609.3499755859375,
        -2635,
        820
      ],
      [
        -609.3499755859375,
        -2665,
        820
      ],
      [
        -609.3499755859375,
        -2635,
        810.5
      ],
      [
        -607.6500244140625,
        -2665,
        810.5
      ],
      [
        -607.6500244140625,
        -2635,
        820
      ],
      [
        -607.6500244140625,
        -2665,
        820
      ],
      [
        -607.6500244140625,
        -2635,
        810.5
      ]
    ],
    "dimensions": [
      1.699951171875,
      30,
      9.5
    ],
    "dimensionsMeters": [
      0.15,
      1.5,
      0.48
    ],
    "maxDimensionMeters": 1.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4ad10.glb"
  },
  {
    "id": "unknown_mt04b",
    "sector": "mt04b",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt04b",
    "sourceVertexCount": 48,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -714.9583333333334,
      -2745.0416666666665,
      802.75
    ],
    "vertices": [
      [
        -685.5,
        -2745,
        804
      ],
      [
        -685.5,
        -2675,
        804
      ],
      [
        -550,
        -2675,
        804
      ],
      [
        -550,
        -2745,
        804
      ],
      [
        -550,
        -2815,
        804
      ],
      [
        -685.5,
        -2815,
        804
      ],
      [
        -685.5,
        -2745,
        804
      ],
      [
        -550,
        -2745,
        804
      ],
      [
        -716.5,
        -2745,
        804
      ],
      [
        -685.5,
        -2745,
        804
      ],
      [
        -685.5,
        -2815,
        804
      ],
      [
        -716.5,
        -2815,
        804
      ],
      [
        -716.5,
        -2675,
        804
      ],
      [
        -685.5,
        -2675,
        804
      ],
      [
        -685.5,
        -2745,
        804
      ],
      [
        -716.5,
        -2745,
        804
      ],
      [
        -716.5,
        -2745,
        804
      ],
      [
        -747.5,
        -2745,
        804
      ],
      [
        -747.5,
        -2675,
        804
      ],
      [
        -716.5,
        -2675,
        804
      ],
      [
        -716.5,
        -2815,
        804
      ],
      [
        -747.5,
        -2815,
        804
      ],
      [
        -747.5,
        -2745,
        804
      ],
      [
        -716.5,
        -2745,
        804
      ],
      [
        -747.5,
        -2745,
        804
      ],
      [
        -747.5,
        -2815,
        804
      ],
      [
        -778.5,
        -2815,
        804
      ],
      [
        -778.5,
        -2745,
        804
      ],
      [
        -778.5,
        -2675,
        804
      ],
      [
        -747.5,
        -2675,
        804
      ],
      [
        -747.5,
        -2745,
        804
      ],
      [
        -778.5,
        -2745,
        804
      ],
      [
        -833.5,
        -2675,
        804
      ],
      [
        -778.5,
        -2675,
        804
      ],
      [
        -778.5,
        -2745,
        804
      ],
      [
        -833.5,
        -2745,
        804
      ],
      [
        -833.5,
        -2745,
        804
      ],
      [
        -778.5,
        -2745,
        804
      ],
      [
        -778.5,
        -2815,
        804
      ],
      [
        -833.5,
        -2815,
        804
      ],
      [
        -700,
        -2675,
        810
      ],
      [
        -700,
        -2625,
        810
      ],
      [
        -700,
        -2625,
        826
      ],
      [
        -700,
        -2675,
        826
      ],
      [
        -640,
        -2862,
        760
      ],
      [
        -640,
        -2862,
        790
      ],
      [
        -640,
        -2819,
        790
      ],
      [
        -640,
        -2819,
        760
      ]
    ],
    "dimensions": [
      283.5,
      237,
      66
    ],
    "dimensionsMeters": [
      14.18,
      11.85,
      3.3
    ],
    "maxDimensionMeters": 14.18,
    "pedestalFitScale": 0.113,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/unknown_mt04b.glb"
  },
  {
    "id": "door_m4bbelev",
    "sector": "mt04b",
    "type": "door",
    "texture": "chkrooftrak_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkrooftrak_h)",
    "availableSwatches": [
      "chkrooftrak_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m4bbelev",
    "sourceVertexCount": 16,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -625,
      -2840,
      797.125
    ],
    "vertices": [
      [
        -636,
        -2854,
        809
      ],
      [
        -636,
        -2826,
        810.5
      ],
      [
        -636,
        -2854,
        810.5
      ],
      [
        -636,
        -2826,
        809
      ],
      [
        -614,
        -2854,
        809
      ],
      [
        -614,
        -2826,
        810.5
      ],
      [
        -614,
        -2854,
        810.5
      ],
      [
        -614,
        -2826,
        809
      ],
      [
        -626,
        -2841,
        760
      ],
      [
        -626,
        -2839,
        809
      ],
      [
        -626,
        -2841,
        809
      ],
      [
        -626,
        -2839,
        760
      ],
      [
        -624,
        -2841,
        760
      ],
      [
        -624,
        -2839,
        809
      ],
      [
        -624,
        -2841,
        809
      ],
      [
        -624,
        -2839,
        760
      ]
    ],
    "dimensions": [
      22,
      28,
      50.5
    ],
    "dimensionsMeters": [
      1.1,
      1.4,
      2.53
    ],
    "maxDimensionMeters": 2.53,
    "pedestalFitScale": 0.632,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_m4bbelev.glb"
  },
  {
    "id": "door_fdrt",
    "sector": "mt05mov",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: fdrt",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -383.8232421875,
      -2114.438232421875,
      652.0499877929688
    ],
    "vertices": [
      [
        -375.970947265625,
        -2109.038818359375,
        648
      ],
      [
        -392.425537109375,
        -2118.538818359375,
        648
      ],
      [
        -375.970947265625,
        -2109.038818359375,
        656.0999755859375
      ],
      [
        -392.425537109375,
        -2118.538818359375,
        656.0999755859375
      ],
      [
        -391.675537109375,
        -2119.837646484375,
        648
      ],
      [
        -375.220947265625,
        -2110.337646484375,
        648
      ],
      [
        -391.675537109375,
        -2119.837646484375,
        656.0999755859375
      ],
      [
        -375.220947265625,
        -2110.337646484375,
        656.0999755859375
      ]
    ],
    "dimensions": [
      17.20458984375,
      10.798828125,
      8.0999755859375
    ],
    "dimensionsMeters": [
      0.86,
      0.54,
      0.4
    ],
    "maxDimensionMeters": 0.86,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_fdrt.glb"
  },
  {
    "id": "door_fdrb",
    "sector": "mt05mov",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: fdrb",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -383.8232421875,
      -2114.438232421875,
      644
    ],
    "vertices": [
      [
        -375.970947265625,
        -2109.038818359375,
        648
      ],
      [
        -392.425537109375,
        -2118.538818359375,
        648
      ],
      [
        -392.425537109375,
        -2118.538818359375,
        640
      ],
      [
        -375.970947265625,
        -2109.038818359375,
        640
      ],
      [
        -391.675537109375,
        -2119.837646484375,
        648
      ],
      [
        -375.220947265625,
        -2110.337646484375,
        648
      ],
      [
        -375.220947265625,
        -2110.337646484375,
        640
      ],
      [
        -391.675537109375,
        -2119.837646484375,
        640
      ]
    ],
    "dimensions": [
      17.20458984375,
      10.798828125,
      8
    ],
    "dimensionsMeters": [
      0.86,
      0.54,
      0.4
    ],
    "maxDimensionMeters": 0.86,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_fdrb.glb"
  },
  {
    "id": "unknown_mt06a",
    "sector": "mt06a",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: mt06a",
    "sourceVertexCount": 40,
    "exportedTriangleCount": 54,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -312.35228118896487,
      -2304.538623046875,
      641.8
    ],
    "vertices": [
      [
        -327.6000061035156,
        -2238,
        637
      ],
      [
        -327.6000061035156,
        -2238,
        653
      ],
      [
        -308.6000061035156,
        -2238,
        653
      ],
      [
        -308.6000061035156,
        -2238,
        637
      ],
      [
        -259.02667236328125,
        -2314.781005859375,
        652
      ],
      [
        -263.61895751953125,
        -2325.867431640625,
        652
      ],
      [
        -263.61895751953125,
        -2325.867431640625,
        638
      ],
      [
        -259.02667236328125,
        -2314.781005859375,
        638
      ],
      [
        -376.84716796875,
        -2285.141845703125,
        630
      ],
      [
        -376.84716796875,
        -2285.141845703125,
        660
      ],
      [
        -367.88818359375,
        -2263.512939453125,
        660
      ],
      [
        -367.88818359375,
        -2263.512939453125,
        630
      ],
      [
        -367.88818359375,
        -2263.512939453125,
        630
      ],
      [
        -367.88818359375,
        -2263.512939453125,
        660
      ],
      [
        -351.334228515625,
        -2246.958984375,
        660
      ],
      [
        -351.334228515625,
        -2246.958984375,
        630
      ],
      [
        -284.665771484375,
        -2246.958984375,
        630
      ],
      [
        -284.665771484375,
        -2246.958984375,
        660
      ],
      [
        -268.11181640625,
        -2263.512939453125,
        660
      ],
      [
        -268.11181640625,
        -2263.512939453125,
        630
      ],
      [
        -268.11181640625,
        -2263.512939453125,
        630
      ],
      [
        -268.11181640625,
        -2263.512939453125,
        660
      ],
      [
        -259.15283203125,
        -2285.141845703125,
        660
      ],
      [
        -259.15283203125,
        -2285.141845703125,
        630
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        630
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        660
      ],
      [
        -306.300048828125,
        -2355.699951171875,
        660
      ],
      [
        -306.300048828125,
        -2355.699951171875,
        630
      ],
      [
        -306.300048828125,
        -2355.699951171875,
        630
      ],
      [
        -306.300048828125,
        -2355.699951171875,
        660
      ],
      [
        -329.699951171875,
        -2355.699951171875,
        660
      ],
      [
        -329.699951171875,
        -2355.699951171875,
        630
      ],
      [
        -329.699951171875,
        -2355.699951171875,
        630
      ],
      [
        -329.699951171875,
        -2355.699951171875,
        660
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        660
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        630
      ],
      [
        -329.79998779296875,
        -2369.800048828125,
        608
      ],
      [
        -306.3999938964844,
        -2369.800048828125,
        608
      ],
      [
        -306.3999938964844,
        -2369.800048828125,
        618
      ],
      [
        -329.79998779296875,
        -2369.800048828125,
        618
      ]
    ],
    "dimensions": [
      117.82049560546875,
      131.800048828125,
      52
    ],
    "dimensionsMeters": [
      5.89,
      6.59,
      2.6
    ],
    "maxDimensionMeters": 6.59,
    "pedestalFitScale": 0.243,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/unknown_mt06a.glb"
  },
  {
    "id": "door_cdr5",
    "sector": "mt06a",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cdr5",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -401.5,
      -2326,
      641.75
    ],
    "vertices": [
      [
        -402.20001220703125,
        -2333.5,
        637
      ],
      [
        -400.79998779296875,
        -2333.5,
        646.5
      ],
      [
        -400.79998779296875,
        -2333.5,
        637
      ],
      [
        -402.20001220703125,
        -2333.5,
        646.5
      ],
      [
        -402.20001220703125,
        -2318.5,
        637
      ],
      [
        -400.79998779296875,
        -2318.5,
        646.5
      ],
      [
        -400.79998779296875,
        -2318.5,
        637
      ],
      [
        -402.20001220703125,
        -2318.5,
        646.5
      ]
    ],
    "dimensions": [
      1.4000244140625,
      15,
      9.5
    ],
    "dimensionsMeters": [
      0.15,
      0.75,
      0.48
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_cdr5.glb"
  },
  {
    "id": "door_elev1dr1",
    "sector": "mt06a",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev1dr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -436,
      -2296.800048828125,
      652.2000122070312
    ],
    "vertices": [
      [
        -436.6000061035156,
        -2302.60009765625,
        648
      ],
      [
        -436.6000061035156,
        -2302.60009765625,
        656.4000244140625
      ],
      [
        -435.3999938964844,
        -2302.60009765625,
        648
      ],
      [
        -435.3999938964844,
        -2302.60009765625,
        656.4000244140625
      ],
      [
        -436.6000061035156,
        -2291,
        648
      ],
      [
        -436.6000061035156,
        -2291,
        656.4000244140625
      ],
      [
        -435.3999938964844,
        -2291,
        648
      ],
      [
        -435.3999938964844,
        -2291,
        656.4000244140625
      ]
    ],
    "dimensions": [
      1.20001220703125,
      11.60009765625,
      8.4000244140625
    ],
    "dimensionsMeters": [
      0.15,
      0.58,
      0.42
    ],
    "maxDimensionMeters": 0.58,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elev1dr1.glb"
  },
  {
    "id": "door_elev1dr2_mt06a",
    "sector": "mt06a",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev1dr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -436,
      -2296.800048828125,
      716.4000244140625
    ],
    "vertices": [
      [
        -436.6000061035156,
        -2302.60009765625,
        712.2000122070312
      ],
      [
        -436.6000061035156,
        -2302.60009765625,
        720.6000366210938
      ],
      [
        -435.3999938964844,
        -2302.60009765625,
        712.2000122070312
      ],
      [
        -435.3999938964844,
        -2302.60009765625,
        720.6000366210938
      ],
      [
        -436.6000061035156,
        -2291,
        712.2000122070312
      ],
      [
        -436.6000061035156,
        -2291,
        720.6000366210938
      ],
      [
        -435.3999938964844,
        -2291,
        712.2000122070312
      ],
      [
        -435.3999938964844,
        -2291,
        720.6000366210938
      ]
    ],
    "dimensions": [
      1.20001220703125,
      11.60009765625,
      8.4000244140625
    ],
    "dimensionsMeters": [
      0.15,
      0.58,
      0.42
    ],
    "maxDimensionMeters": 0.58,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elev1dr2_mt06a.glb"
  },
  {
    "id": "door_cdr6",
    "sector": "mt06a",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cdr6",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -397.29998779296875,
      -2296.92724609375,
      717
    ],
    "vertices": [
      [
        -397.79998779296875,
        -2299.8544921875,
        713
      ],
      [
        -397.79998779296875,
        -2294,
        721
      ],
      [
        -397.79998779296875,
        -2299.8544921875,
        721
      ],
      [
        -397.79998779296875,
        -2294,
        713
      ],
      [
        -396.79998779296875,
        -2299.8544921875,
        713
      ],
      [
        -396.79998779296875,
        -2294,
        721
      ],
      [
        -396.79998779296875,
        -2299.8544921875,
        721
      ],
      [
        -396.79998779296875,
        -2294,
        713
      ]
    ],
    "dimensions": [
      1,
      5.8544921875,
      8
    ],
    "dimensionsMeters": [
      0.15,
      0.29,
      0.4
    ],
    "maxDimensionMeters": 0.4,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_cdr6.glb"
  },
  {
    "id": "door_cdr1",
    "sector": "mt06mov",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -318,
      -2235.5,
      645
    ],
    "vertices": [
      [
        -324,
        -2236.5,
        638
      ],
      [
        -324,
        -2234.5,
        652
      ],
      [
        -324,
        -2236.5,
        652
      ],
      [
        -324,
        -2234.5,
        638
      ],
      [
        -312,
        -2236.5,
        638
      ],
      [
        -312,
        -2234.5,
        652
      ],
      [
        -312,
        -2236.5,
        652
      ],
      [
        -312,
        -2234.5,
        638
      ]
    ],
    "dimensions": [
      12,
      2,
      14
    ],
    "dimensionsMeters": [
      0.6,
      0.15,
      0.7
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_cdr1.glb"
  },
  {
    "id": "door_cdr2",
    "sector": "mt06mov",
    "type": "door",
    "texture": "slidedoor3",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(slidedoor3)",
    "availableSwatches": [
      "slidedoor3",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -374.67718505859375,
      -2320.3241577148438,
      645.0010986328125
    ],
    "vertices": [
      [
        -378.128173828125,
        -2315.25927734375,
        638.002197265625
      ],
      [
        -378.128173828125,
        -2315.25927734375,
        652
      ],
      [
        -373.535888671875,
        -2326.345703125,
        652
      ],
      [
        -373.535888671875,
        -2326.345703125,
        638.002197265625
      ],
      [
        -375.818359375,
        -2314.302490234375,
        652
      ],
      [
        -375.818359375,
        -2314.302490234375,
        638.002197265625
      ],
      [
        -371.226318359375,
        -2325.38916015625,
        638.002197265625
      ],
      [
        -371.226318359375,
        -2325.38916015625,
        652
      ]
    ],
    "dimensions": [
      6.90185546875,
      12.043212890625,
      13.997802734375
    ],
    "dimensionsMeters": [
      0.35,
      0.6,
      0.7
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_cdr2.glb"
  },
  {
    "id": "door_cdr3",
    "sector": "mt06mov",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cdr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -261.32281494140625,
      -2320.3241577148438,
      645.0010986328125
    ],
    "vertices": [
      [
        -262.464111328125,
        -2326.345703125,
        652
      ],
      [
        -257.871826171875,
        -2315.25927734375,
        652
      ],
      [
        -257.871826171875,
        -2315.25927734375,
        638
      ],
      [
        -262.464111328125,
        -2326.345703125,
        638
      ],
      [
        -260.181640625,
        -2314.302490234375,
        652.002197265625
      ],
      [
        -264.773681640625,
        -2325.38916015625,
        652.002197265625
      ],
      [
        -264.773681640625,
        -2325.38916015625,
        638.002197265625
      ],
      [
        -260.181640625,
        -2314.302490234375,
        638.002197265625
      ]
    ],
    "dimensions": [
      6.90185546875,
      12.043212890625,
      14.002197265625
    ],
    "dimensionsMeters": [
      0.35,
      0.6,
      0.7
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -0.0008,
      0.0003,
      -1
    ],
    "file": "props/door_cdr3.glb"
  },
  {
    "id": "door_elev2dr1_mt07",
    "sector": "mt07",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -317.5,
      -2412.25,
      612.7000122070312
    ],
    "vertices": [
      [
        -311.5,
        -2411.5,
        608.4500122070312
      ],
      [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      [
        -311.5,
        -2413,
        616.9500122070312
      ],
      [
        -311.5,
        -2413,
        608.4500122070312
      ],
      [
        -323.5,
        -2413,
        616.9500122070312
      ],
      [
        -323.5,
        -2413,
        608.4500122070312
      ],
      [
        -323.5,
        -2411.5,
        608.4500122070312
      ],
      [
        -323.5,
        -2411.5,
        616.9500122070312
      ]
    ],
    "dimensions": [
      12,
      1.5,
      8.5
    ],
    "dimensionsMeters": [
      0.6,
      0.15,
      0.43
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_elev2dr1_mt07.glb"
  },
  {
    "id": "door_elev2dr2_mt07",
    "sector": "mt07",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev2dr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -317.5,
      -2412.25,
      631.4500122070312
    ],
    "vertices": [
      [
        -311.5,
        -2413,
        635.9500122070312
      ],
      [
        -311.5,
        -2413,
        626.9500122070312
      ],
      [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      [
        -311.5,
        -2411.5,
        626.9500122070312
      ],
      [
        -323.5,
        -2413,
        635.9500122070312
      ],
      [
        -323.5,
        -2413,
        626.9500122070312
      ],
      [
        -323.5,
        -2411.5,
        626.9500122070312
      ],
      [
        -323.5,
        -2411.5,
        635.9500122070312
      ]
    ],
    "dimensions": [
      12,
      1.5,
      9
    ],
    "dimensionsMeters": [
      0.6,
      0.15,
      0.45
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_elev2dr2_mt07.glb"
  },
  {
    "id": "door_rdr1",
    "sector": "mt07",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -280,
      -2399,
      630.75
    ],
    "vertices": [
      [
        -280.6000061035156,
        -2392,
        635.5
      ],
      [
        -280.6000061035156,
        -2406,
        635.5
      ],
      [
        -279.3999938964844,
        -2392,
        635.5
      ],
      [
        -279.3999938964844,
        -2406,
        635.5
      ],
      [
        -280.6000061035156,
        -2392,
        626
      ],
      [
        -280.6000061035156,
        -2406,
        626
      ],
      [
        -279.3999938964844,
        -2406,
        626
      ],
      [
        -279.3999938964844,
        -2392,
        626
      ]
    ],
    "dimensions": [
      1.20001220703125,
      14,
      9.5
    ],
    "dimensionsMeters": [
      0.15,
      0.7,
      0.48
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_rdr1.glb"
  },
  {
    "id": "door_rdr2",
    "sector": "mt07",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -356,
      -2399,
      630.75
    ],
    "vertices": [
      [
        -356.6000061035156,
        -2392,
        635.5
      ],
      [
        -356.6000061035156,
        -2406,
        635.5
      ],
      [
        -355.3999938964844,
        -2392,
        635.5
      ],
      [
        -355.3999938964844,
        -2406,
        635.5
      ],
      [
        -356.6000061035156,
        -2392,
        626
      ],
      [
        -356.6000061035156,
        -2406,
        626
      ],
      [
        -355.3999938964844,
        -2406,
        626
      ],
      [
        -355.3999938964844,
        -2392,
        626
      ]
    ],
    "dimensions": [
      1.20001220703125,
      14,
      9.5
    ],
    "dimensionsMeters": [
      0.15,
      0.7,
      0.48
    ],
    "maxDimensionMeters": 0.7,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_rdr2.glb"
  },
  {
    "id": "door_odr1",
    "sector": "mt08",
    "type": "door",
    "texture": "spkgums1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkgums1)",
    "availableSwatches": [
      "spkgums1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: odr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -168.5,
      -2313.0001220703125,
      643
    ],
    "vertices": [
      [
        -171,
        -2313.400146484375,
        638
      ],
      [
        -171,
        -2312.60009765625,
        648
      ],
      [
        -171,
        -2313.400146484375,
        648
      ],
      [
        -171,
        -2312.60009765625,
        638
      ],
      [
        -166,
        -2313.400146484375,
        638
      ],
      [
        -166,
        -2312.60009765625,
        648
      ],
      [
        -166,
        -2313.400146484375,
        648
      ],
      [
        -166,
        -2312.60009765625,
        638
      ]
    ],
    "dimensions": [
      5,
      0.800048828125,
      10
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_odr1.glb"
  },
  {
    "id": "door_odr2",
    "sector": "mt08",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: odr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -179.5,
      -2313.0001220703125,
      643
    ],
    "vertices": [
      [
        -182,
        -2313.400146484375,
        638
      ],
      [
        -182,
        -2312.60009765625,
        648
      ],
      [
        -182,
        -2313.400146484375,
        648
      ],
      [
        -182,
        -2312.60009765625,
        638
      ],
      [
        -177,
        -2313.400146484375,
        638
      ],
      [
        -177,
        -2312.60009765625,
        648
      ],
      [
        -177,
        -2313.400146484375,
        648
      ],
      [
        -177,
        -2312.60009765625,
        638
      ]
    ],
    "dimensions": [
      5,
      0.800048828125,
      10
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_odr2.glb"
  },
  {
    "id": "door_odr3",
    "sector": "mt08",
    "type": "door",
    "texture": "spkgums1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkgums1)",
    "availableSwatches": [
      "spkgums1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: odr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -168.5,
      -2332.4000244140625,
      643
    ],
    "vertices": [
      [
        -171,
        -2332.800048828125,
        638
      ],
      [
        -171,
        -2332,
        648
      ],
      [
        -171,
        -2332.800048828125,
        648
      ],
      [
        -171,
        -2332,
        638
      ],
      [
        -166,
        -2332.800048828125,
        638
      ],
      [
        -166,
        -2332,
        648
      ],
      [
        -166,
        -2332.800048828125,
        648
      ],
      [
        -166,
        -2332,
        638
      ]
    ],
    "dimensions": [
      5,
      0.800048828125,
      10
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_odr3.glb"
  },
  {
    "id": "door_odr4",
    "sector": "mt08",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: odr4",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -179.5,
      -2332.4000244140625,
      643
    ],
    "vertices": [
      [
        -182,
        -2332.800048828125,
        638
      ],
      [
        -182,
        -2332,
        648
      ],
      [
        -182,
        -2332.800048828125,
        648
      ],
      [
        -182,
        -2332,
        638
      ],
      [
        -177,
        -2332.800048828125,
        638
      ],
      [
        -177,
        -2332,
        648
      ],
      [
        -177,
        -2332.800048828125,
        648
      ],
      [
        -177,
        -2332,
        638
      ]
    ],
    "dimensions": [
      5,
      0.800048828125,
      10
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_odr4.glb"
  },
  {
    "id": "door_elev3dr1",
    "sector": "mt08",
    "type": "door",
    "texture": "spkgums1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkgums1)",
    "availableSwatches": [
      "spkgums1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev3dr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -203,
      -2359.699951171875,
      643.5
    ],
    "vertices": [
      [
        -207,
        -2360,
        638
      ],
      [
        -207,
        -2359.39990234375,
        649
      ],
      [
        -207,
        -2360,
        649
      ],
      [
        -207,
        -2359.39990234375,
        638
      ],
      [
        -199,
        -2360,
        638
      ],
      [
        -199,
        -2359.39990234375,
        649
      ],
      [
        -199,
        -2360,
        649
      ],
      [
        -199,
        -2359.39990234375,
        638
      ]
    ],
    "dimensions": [
      8,
      0.60009765625,
      11
    ],
    "dimensionsMeters": [
      0.4,
      0.15,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elev3dr1.glb"
  },
  {
    "id": "door_elev3dr2",
    "sector": "mt08",
    "type": "door",
    "texture": "spkgums1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkgums1)",
    "availableSwatches": [
      "spkgums1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev3dr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -203,
      -2372.300048828125,
      789.5
    ],
    "vertices": [
      [
        -207,
        -2372.60009765625,
        784
      ],
      [
        -207,
        -2372,
        795
      ],
      [
        -207,
        -2372.60009765625,
        795
      ],
      [
        -207,
        -2372,
        784
      ],
      [
        -199,
        -2372.60009765625,
        784
      ],
      [
        -199,
        -2372,
        795
      ],
      [
        -199,
        -2372.60009765625,
        795
      ],
      [
        -199,
        -2372,
        784
      ]
    ],
    "dimensions": [
      8,
      0.60009765625,
      11
    ],
    "dimensionsMeters": [
      0.4,
      0.15,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elev3dr2.glb"
  },
  {
    "id": "door_elev3dr3",
    "sector": "mt08",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev3dr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -203,
      -2359.699951171875,
      830.5
    ],
    "vertices": [
      [
        -207,
        -2360,
        825
      ],
      [
        -207,
        -2359.39990234375,
        836
      ],
      [
        -207,
        -2360,
        836
      ],
      [
        -207,
        -2359.39990234375,
        825
      ],
      [
        -199,
        -2360,
        825
      ],
      [
        -199,
        -2359.39990234375,
        836
      ],
      [
        -199,
        -2360,
        836
      ],
      [
        -199,
        -2359.39990234375,
        825
      ]
    ],
    "dimensions": [
      8,
      0.60009765625,
      11
    ],
    "dimensionsMeters": [
      0.4,
      0.15,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_elev3dr3.glb"
  },
  {
    "id": "breakable_mt08",
    "sector": "mt08",
    "type": "breakable",
    "texture": "chkptroofgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptroofgrate1-t)",
    "availableSwatches": [
      "chkptroofgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -90,
      -2170,
      648
    ],
    "vertices": [
      [
        -95,
        -2170,
        646
      ],
      [
        -85,
        -2170,
        650
      ],
      [
        -85,
        -2170,
        646
      ],
      [
        -95,
        -2170,
        650
      ]
    ],
    "dimensions": [
      10,
      0,
      4
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.2
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_mt08.glb"
  },
  {
    "id": "door_screen",
    "sector": "mt08",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: screen",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -155.20994567871094,
      -2351.0001220703125,
      643.1000061035156
    ],
    "vertices": [
      [
        -155.20994567871094,
        -2350.2001953125,
        642.2999877929688
      ],
      [
        -155.20994567871094,
        -2350.2001953125,
        643.9000244140625
      ],
      [
        -155.20994567871094,
        -2351.800048828125,
        642.2999877929688
      ],
      [
        -155.20994567871094,
        -2351.800048828125,
        643.9000244140625
      ]
    ],
    "dimensions": [
      0,
      1.599853515625,
      1.60003662109375
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_screen.glb"
  },
  {
    "id": "door_cabdr1",
    "sector": "mt09",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cabdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -204.49999237060547,
      -2452.7999267578125,
      786
    ],
    "vertices": [
      [
        -209,
        -2453.199951171875,
        780
      ],
      [
        -209,
        -2452.39990234375,
        792
      ],
      [
        -209,
        -2453.199951171875,
        792
      ],
      [
        -209,
        -2452.39990234375,
        780
      ],
      [
        -199.99998474121094,
        -2453.199951171875,
        780
      ],
      [
        -199.99998474121094,
        -2452.39990234375,
        792
      ],
      [
        -199.99998474121094,
        -2453.199951171875,
        792
      ],
      [
        -199.99998474121094,
        -2452.39990234375,
        780
      ]
    ],
    "dimensions": [
      9.000015258789062,
      0.800048828125,
      12
    ],
    "dimensionsMeters": [
      0.45,
      0.15,
      0.6
    ],
    "maxDimensionMeters": 0.6,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_cabdr1.glb"
  },
  {
    "id": "door_2dr3",
    "sector": "mt09",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: 2dr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      924.75,
      -3797.5,
      1303.5
    ],
    "vertices": [
      [
        924.5,
        -3802.5,
        1298
      ],
      [
        924.5,
        -3792.5,
        1309
      ],
      [
        924.5,
        -3802.5,
        1309
      ],
      [
        924.5,
        -3792.5,
        1298
      ],
      [
        925,
        -3802.5,
        1298
      ],
      [
        925,
        -3792.5,
        1309
      ],
      [
        925,
        -3802.5,
        1309
      ],
      [
        925,
        -3792.5,
        1298
      ]
    ],
    "dimensions": [
      0.5,
      10,
      11
    ],
    "dimensionsMeters": [
      0.15,
      0.5,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_2dr3.glb"
  },
  {
    "id": "door_2dr4",
    "sector": "mt09",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: 2dr4",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      972.5,
      -3827.25,
      1299.25
    ],
    "vertices": [
      [
        971.5,
        -3832,
        1295
      ],
      [
        971.5,
        -3822.5,
        1303.5
      ],
      [
        971.5,
        -3832,
        1303.5
      ],
      [
        971.5,
        -3822.5,
        1295
      ],
      [
        973.5,
        -3832,
        1295
      ],
      [
        973.5,
        -3822.5,
        1303.5
      ],
      [
        973.5,
        -3832,
        1303.5
      ],
      [
        973.5,
        -3822.5,
        1295
      ]
    ],
    "dimensions": [
      2,
      9.5,
      8.5
    ],
    "dimensionsMeters": [
      0.15,
      0.48,
      0.43
    ],
    "maxDimensionMeters": 0.48,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_2dr4.glb"
  },
  {
    "id": "breakable_mt09",
    "sector": "mt09",
    "type": "breakable",
    "texture": "chkptroofgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptroofgrate1-t)",
    "availableSwatches": [
      "chkptroofgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      958.75,
      -3827,
      1325
    ],
    "vertices": [
      [
        954.5,
        -3832,
        1325
      ],
      [
        963,
        -3832,
        1325
      ],
      [
        954.5,
        -3822,
        1325
      ],
      [
        963,
        -3822,
        1325
      ]
    ],
    "dimensions": [
      8.5,
      10,
      0
    ],
    "dimensionsMeters": [
      0.43,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_mt09.glb"
  },
  {
    "id": "breakable_2_mt09",
    "sector": "mt09",
    "type": "breakable",
    "texture": "chkptroofgrate1-t",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptroofgrate1-t)",
    "availableSwatches": [
      "chkptroofgrate1-t",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -217.5,
      -2442.5,
      795.5
    ],
    "vertices": [
      [
        -220,
        -2445,
        795.5
      ],
      [
        -220,
        -2440,
        795.5
      ],
      [
        -215,
        -2445,
        795.5
      ],
      [
        -215,
        -2440,
        795.5
      ]
    ],
    "dimensions": [
      5,
      5,
      0
    ],
    "dimensionsMeters": [
      0.25,
      0.25,
      0.15
    ],
    "maxDimensionMeters": 0.25,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/breakable_2_mt09.glb"
  },
  {
    "id": "door_m9gate",
    "sector": "mt09",
    "type": "door",
    "texture": "spkwaffle1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkwaffle1)",
    "availableSwatches": [
      "spkwaffle1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: m9gate",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      953.75,
      -3730,
      1277.5
    ],
    "vertices": [
      [
        947.5,
        -3732,
        1270
      ],
      [
        947.5,
        -3728,
        1285
      ],
      [
        947.5,
        -3732,
        1285
      ],
      [
        947.5,
        -3728,
        1270
      ],
      [
        960,
        -3732,
        1270
      ],
      [
        960,
        -3728,
        1285
      ],
      [
        960,
        -3732,
        1285
      ],
      [
        960,
        -3728,
        1270
      ]
    ],
    "dimensions": [
      12.5,
      4,
      15
    ],
    "dimensionsMeters": [
      0.63,
      0.2,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_m9gate.glb"
  },
  {
    "id": "door_hdr2",
    "sector": "mt10",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: hdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -306.5,
      -2254.75,
      845.25
    ],
    "vertices": [
      [
        -309,
        -2255.300048828125,
        841.5
      ],
      [
        -309,
        -2254.199951171875,
        849
      ],
      [
        -309,
        -2255.300048828125,
        849
      ],
      [
        -309,
        -2254.199951171875,
        841.5
      ],
      [
        -304,
        -2255.300048828125,
        841.5
      ],
      [
        -304,
        -2254.199951171875,
        849
      ],
      [
        -304,
        -2255.300048828125,
        849
      ],
      [
        -304,
        -2254.199951171875,
        841.5
      ]
    ],
    "dimensions": [
      5,
      1.10009765625,
      7.5
    ],
    "dimensionsMeters": [
      0.25,
      0.15,
      0.38
    ],
    "maxDimensionMeters": 0.38,
    "pedestalFitScale": 1.579,
    "slideAxis": "x",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_hdr2.glb"
  },
  {
    "id": "door_hangdr",
    "sector": "mt10mv",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: hangdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -215.9000244140625,
      -2312.25,
      829.7999877929688
    ],
    "vertices": [
      [
        -223.199951171875,
        -2311.300048828125,
        834.7999877929688
      ],
      [
        -223.199951171875,
        -2313.199951171875,
        834.7999877929688
      ],
      [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      [
        -208.60009765625,
        -2313.199951171875,
        834.7999877929688
      ],
      [
        -208.60009765625,
        -2313.199951171875,
        824.7999877929688
      ],
      [
        -208.60009765625,
        -2311.300048828125,
        824.7999877929688
      ],
      [
        -223.199951171875,
        -2311.300048828125,
        824.7999877929688
      ],
      [
        -223.199951171875,
        -2313.199951171875,
        824.7999877929688
      ]
    ],
    "dimensions": [
      14.599853515625,
      1.89990234375,
      10
    ],
    "dimensionsMeters": [
      0.73,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.73,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_hangdr.glb"
  },
  {
    "id": "door_satdr2",
    "sector": "mt12",
    "type": "door",
    "texture": "chkptdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkptdoor1)",
    "availableSwatches": [
      "chkptdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: satdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -404.75,
      -1933,
      896.25
    ],
    "vertices": [
      [
        -409.5,
        -1934,
        892
      ],
      [
        -409.5,
        -1932,
        892
      ],
      [
        -400,
        -1934,
        892
      ],
      [
        -400,
        -1932,
        892
      ],
      [
        -400,
        -1934,
        900.5
      ],
      [
        -400,
        -1932,
        900.5
      ],
      [
        -409.5,
        -1934,
        900.5
      ],
      [
        -409.5,
        -1932,
        900.5
      ]
    ],
    "dimensions": [
      9.5,
      2,
      8.5
    ],
    "dimensionsMeters": [
      0.48,
      0.15,
      0.43
    ],
    "maxDimensionMeters": 0.48,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_satdr2.glb"
  },
  {
    "id": "breakable_nbbmov",
    "sector": "nbbmov",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 24,
    "exportedTriangleCount": 20,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2538.226318359375,
      -4080.748046875,
      1098.373779296875
    ],
    "vertices": [
      [
        -2540.34228515625,
        -4082.4130859375,
        1098.123779296875
      ],
      [
        -2538.6103515625,
        -4083.4130859375,
        1097.123779296875
      ],
      [
        -2542.07421875,
        -4081.4130859375,
        1099.123779296875
      ],
      [
        -2536.1103515625,
        -4079.0830078125,
        1097.623779296875
      ],
      [
        -2539.57421875,
        -4077.0830078125,
        1099.623779296875
      ],
      [
        -2537.84228515625,
        -4078.0830078125,
        1098.623779296875
      ],
      [
        -2542.07421875,
        -4081.4130859375,
        1099.623779296875
      ],
      [
        -2540.34228515625,
        -4082.4130859375,
        1098.623779296875
      ],
      [
        -2538.6103515625,
        -4083.4130859375,
        1097.623779296875
      ],
      [
        -2537.84228515625,
        -4078.0830078125,
        1098.123779296875
      ],
      [
        -2536.1103515625,
        -4079.0830078125,
        1097.123779296875
      ],
      [
        -2539.57421875,
        -4077.0830078125,
        1099.123779296875
      ],
      [
        -2538.6103515625,
        -4083.4130859375,
        1098.123779296875
      ],
      [
        -2540.34228515625,
        -4082.4130859375,
        1099.123779296875
      ],
      [
        -2536.87841796875,
        -4084.4130859375,
        1097.123779296875
      ],
      [
        -2537.84228515625,
        -4078.0830078125,
        1099.623779296875
      ],
      [
        -2536.1103515625,
        -4079.0830078125,
        1098.623779296875
      ],
      [
        -2534.37841796875,
        -4080.0830078125,
        1097.623779296875
      ],
      [
        -2536.87841796875,
        -4084.4130859375,
        1097.623779296875
      ],
      [
        -2540.34228515625,
        -4082.4130859375,
        1099.623779296875
      ],
      [
        -2538.6103515625,
        -4083.4130859375,
        1098.623779296875
      ],
      [
        -2534.37841796875,
        -4080.0830078125,
        1097.123779296875
      ],
      [
        -2536.1103515625,
        -4079.0830078125,
        1098.123779296875
      ],
      [
        -2537.84228515625,
        -4078.0830078125,
        1099.123779296875
      ]
    ],
    "dimensions": [
      7.69580078125,
      7.330078125,
      2.5
    ],
    "dimensionsMeters": [
      0.38,
      0.37,
      0.15
    ],
    "maxDimensionMeters": 0.38,
    "pedestalFitScale": 1.579,
    "slideAxis": "x",
    "slideVector": [
      -0.866,
      0.5,
      0
    ],
    "file": "props/breakable_nbbmov.glb"
  },
  {
    "id": "door_mainexit",
    "sector": "nbbmov",
    "type": "door",
    "texture": "basegatedoor",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(basegatedoor)",
    "availableSwatches": [
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: mainexit",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -2534.1372802734377,
      -4056.666064453125,
      1106.023779296875
    ],
    "vertices": [
      [
        -2537.368408203125,
        -4055.262451171875,
        1101.623779296875
      ],
      [
        -2537.368408203125,
        -4055.262451171875,
        1101.623779296875
      ],
      [
        -2537.368408203125,
        -4055.262451171875,
        1112.623779296875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1112.623779296875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1101.623779296875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1101.623779296875
      ],
      [
        -2536.868408203125,
        -4054.396484375,
        1112.623779296875
      ],
      [
        -2536.868408203125,
        -4054.396484375,
        1101.623779296875
      ],
      [
        -2530.80615234375,
        -4057.896484375,
        1101.623779296875
      ],
      [
        -2530.80615234375,
        -4057.896484375,
        1112.623779296875
      ]
    ],
    "dimensions": [
      6.562255859375,
      4.365966796875,
      11
    ],
    "dimensionsMeters": [
      0.33,
      0.22,
      0.55
    ],
    "maxDimensionMeters": 0.55,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/door_mainexit.glb"
  },
  {
    "id": "door_dbdorl",
    "sector": "nbbmov",
    "type": "door",
    "texture": "doorjam",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(doorjam)",
    "availableSwatches": [
      "doorjam",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: dbdorl",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3107.46953125,
      -4964,
      1108.40146484375
    ],
    "vertices": [
      [
        -3099.999755859375,
        -4965.2685546875,
        1117.623779296875
      ],
      [
        -3114.265625,
        -4965.2685546875,
        1106.5679931640625
      ],
      [
        -3108.816650390625,
        -4965.2685546875,
        1114.5679931640625
      ],
      [
        -3114.265625,
        -4965.2685546875,
        1101.623779296875
      ],
      [
        -3114.265625,
        -4962.7314453125,
        1101.623779296875
      ],
      [
        -3114.265625,
        -4962.7314453125,
        1106.5679931640625
      ],
      [
        -3108.816650390625,
        -4962.7314453125,
        1114.5679931640625
      ],
      [
        -3099.999755859375,
        -4962.7314453125,
        1117.623779296875
      ],
      [
        -3100,
        -4965.2685546875,
        1101.623779296875
      ],
      [
        -3100,
        -4962.7314453125,
        1101.623779296875
      ]
    ],
    "dimensions": [
      14.265869140625,
      2.537109375,
      16
    ],
    "dimensionsMeters": [
      0.71,
      0.15,
      0.8
    ],
    "maxDimensionMeters": 0.8,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_dbdorl.glb"
  },
  {
    "id": "unknown_nrt01",
    "sector": "nrt01",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: nrt01",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      539.2426452636719,
      803.8999938964844,
      27
    ],
    "vertices": [
      [
        546.313720703125,
        808,
        27
      ],
      [
        532.1715698242188,
        808,
        27
      ],
      [
        532.1715698242188,
        799.7999877929688,
        27
      ],
      [
        546.313720703125,
        799.7999877929688,
        27
      ]
    ],
    "dimensions": [
      14.14215087890625,
      8.20001220703125,
      0
    ],
    "dimensionsMeters": [
      0.71,
      0.41,
      0.15
    ],
    "maxDimensionMeters": 0.71,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/unknown_nrt01.glb"
  },
  {
    "id": "elevator_elevl",
    "sector": "nrt01",
    "type": "elevator",
    "texture": "spkelevfloor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevfloor1)",
    "availableSwatches": [
      "spkelevfloor1",
      "baseelev1",
      "cbaseelevdoor",
      "cbaseelevpaneldown",
      "cbaseelevpanelup",
      "elevatorlight1",
      "elevatorlight1out",
      "elevatorpanel2",
      "elevatorshaft",
      "elevatorshaftout",
      "emielevstripe_h",
      "gcelevtrak_h",
      "hangelevswitch",
      "hospelevdoor",
      "hotelevbut_h",
      "hotelevout_h",
      "hotelevpaneldown",
      "hotelevpanelup",
      "hotvaselev_h",
      "mineelevpanelup",
      "minepipelev",
      "reselevshaft",
      "spkelevdoor1"
    ],
    "tag": "CElevator piece: elevl",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      473,
      982.2999877929688,
      -19.25
    ],
    "vertices": [
      [
        465,
        974.5999755859375,
        -19
      ],
      [
        465,
        990,
        -19
      ],
      [
        481,
        974.5999755859375,
        -19
      ],
      [
        481,
        990,
        -19
      ],
      [
        465,
        974.5999755859375,
        -19.5
      ],
      [
        481,
        974.5999755859375,
        -19.5
      ],
      [
        481,
        990,
        -19.5
      ],
      [
        465,
        990,
        -19.5
      ]
    ],
    "dimensions": [
      16,
      15.4000244140625,
      0.5
    ],
    "dimensionsMeters": [
      0.8,
      0.77,
      0.15
    ],
    "maxDimensionMeters": 0.8,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/elevator_elevl.glb"
  },
  {
    "id": "elevator_elevr",
    "sector": "nrt01",
    "type": "elevator",
    "texture": "spkelevfloor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevfloor1)",
    "availableSwatches": [
      "spkelevfloor1",
      "baseelev1",
      "cbaseelevdoor",
      "cbaseelevpaneldown",
      "cbaseelevpanelup",
      "elevatorlight1",
      "elevatorlight1out",
      "elevatorpanel2",
      "elevatorshaft",
      "elevatorshaftout",
      "emielevstripe_h",
      "gcelevtrak_h",
      "hangelevswitch",
      "hospelevdoor",
      "hotelevbut_h",
      "hotelevout_h",
      "hotelevpaneldown",
      "hotelevpanelup",
      "hotvaselev_h",
      "mineelevpanelup",
      "minepipelev",
      "reselevshaft",
      "spkelevdoor1"
    ],
    "tag": "CElevator piece: elevr",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      605.9696044921875,
      983.8400512695313,
      -19.2
    ],
    "vertices": [
      [
        613.9696044921875,
        974.6000366210938,
        -19
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -19
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -19
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -19
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -19
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -19
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -19.5
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -19.5
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -19.5
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -19.5
      ]
    ],
    "dimensions": [
      16,
      15.4000244140625,
      0.5
    ],
    "dimensionsMeters": [
      0.8,
      0.77,
      0.15
    ],
    "maxDimensionMeters": 0.8,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/elevator_elevr.glb"
  },
  {
    "id": "door_dumwtr",
    "sector": "nrt01",
    "type": "door",
    "texture": "spkelevfloor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevfloor1)",
    "availableSwatches": [
      "spkelevfloor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: dumwtr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      555,
      1001.9517517089844,
      -57.5
    ],
    "vertices": [
      [
        552,
        1004.9035034179688,
        -57
      ],
      [
        558,
        1004.9035034179688,
        -57
      ],
      [
        552,
        999,
        -57
      ],
      [
        558,
        999,
        -57
      ],
      [
        552,
        1004.9035034179688,
        -58
      ],
      [
        552,
        999,
        -58
      ],
      [
        558,
        999,
        -58
      ],
      [
        558,
        1004.9035034179688,
        -58
      ]
    ],
    "dimensions": [
      6,
      5.90350341796875,
      1
    ],
    "dimensionsMeters": [
      0.3,
      0.3,
      0.15
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_dumwtr.glb"
  },
  {
    "id": "door_clbelev1",
    "sector": "nrt01",
    "type": "door",
    "texture": "spkelevfloor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevfloor1)",
    "availableSwatches": [
      "spkelevfloor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: clbelev1",
    "sourceVertexCount": 9,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      419.07540554470484,
      1221.5205213758682,
      -43.394445207383896
    ],
    "vertices": [
      [
        420.74871826171875,
        1230.6146240234375,
        -42.95000076293945
      ],
      [
        426.6859130859375,
        1218.70751953125,
        -42.95000076293945
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -42.95000076293945
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -42.95000076293945
      ],
      [
        411.799560546875,
        1226.15234375,
        -42.95000076293945
      ],
      [
        426.6859130859375,
        1218.70751953125,
        -43.95000076293945
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -43.95000076293945
      ],
      [
        411.799560546875,
        1226.15234375,
        -43.95000076293945
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -43.95000076293945
      ]
    ],
    "dimensions": [
      14.8863525390625,
      16.369384765625,
      1
    ],
    "dimensionsMeters": [
      0.74,
      0.82,
      0.15
    ],
    "maxDimensionMeters": 0.82,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0.8949,
      0.4462,
      0
    ],
    "file": "props/door_clbelev1.glb"
  },
  {
    "id": "door_clbelevr",
    "sector": "nrt01",
    "type": "door",
    "texture": "spkelevfloor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevfloor1)",
    "availableSwatches": [
      "spkelevfloor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: clbelevr",
    "sourceVertexCount": 11,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      578.5806107954545,
      1222.0915305397727,
      -43.31363712657582
    ],
    "vertices": [
      [
        580.7632446289062,
        1214.2452392578125,
        -42.95000076293945
      ],
      [
        580.7632446289062,
        1214.2452392578125,
        -42.95000076293945
      ],
      [
        586.700439453125,
        1226.15234375,
        -42.95000076293945
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -42.95000076293945
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -42.95000076293945
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -42.95000076293945
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -42.95000076293945
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -43.95000076293945
      ],
      [
        580.7632446289062,
        1214.2452392578125,
        -43.95000076293945
      ],
      [
        586.700439453125,
        1226.15234375,
        -43.95000076293945
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -43.95000076293945
      ]
    ],
    "dimensions": [
      14.8863525390625,
      16.369384765625,
      1
    ],
    "dimensionsMeters": [
      0.74,
      0.82,
      0.15
    ],
    "maxDimensionMeters": 0.82,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_clbelevr.glb"
  },
  {
    "id": "breakable_nrt01",
    "sector": "nrt01",
    "type": "breakable",
    "texture": "hospdeco2",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(hospdeco2)",
    "availableSwatches": [
      "hospdeco2",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      536.5,
      934.4959716796875,
      -14.75
    ],
    "vertices": [
      [
        534.75,
        934.4959716796875,
        -18
      ],
      [
        538.25,
        934.4959716796875,
        -11.5
      ],
      [
        534.75,
        934.4959716796875,
        -11.5
      ],
      [
        538.25,
        934.4959716796875,
        -18
      ]
    ],
    "dimensions": [
      3.5,
      0,
      6.5
    ],
    "dimensionsMeters": [
      0.18,
      0.15,
      0.33
    ],
    "maxDimensionMeters": 0.33,
    "pedestalFitScale": 1.818,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_nrt01.glb"
  },
  {
    "id": "breakable_2_nrt01",
    "sector": "nrt01",
    "type": "breakable",
    "texture": "chkcrate-s_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkcrate-s_h)",
    "availableSwatches": [
      "chkcrate-s_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 7,
    "exportedTriangleCount": 10,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      499.42857142857144,
      988.2857142857143,
      -44.57142857142857
    ],
    "vertices": [
      [
        496,
        990,
        -42
      ],
      [
        496,
        986,
        -42
      ],
      [
        496,
        990,
        -48
      ],
      [
        502,
        986,
        -48
      ],
      [
        502,
        990,
        -42
      ],
      [
        502,
        986,
        -42
      ],
      [
        502,
        990,
        -48
      ]
    ],
    "dimensions": [
      6,
      4,
      6
    ],
    "dimensionsMeters": [
      0.3,
      0.2,
      0.3
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/breakable_2_nrt01.glb"
  },
  {
    "id": "breakable_3_nrt01",
    "sector": "nrt01",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      555,
      999,
      -54.75
    ],
    "vertices": [
      [
        552,
        999,
        -57
      ],
      [
        552,
        999,
        -52.5
      ],
      [
        558,
        999,
        -52.5
      ],
      [
        558,
        999,
        -57
      ]
    ],
    "dimensions": [
      6,
      0,
      4.5
    ],
    "dimensionsMeters": [
      0.3,
      0.15,
      0.23
    ],
    "maxDimensionMeters": 0.3,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_3_nrt01.glb"
  },
  {
    "id": "unknown_nrx01",
    "sector": "nrx01",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "CGameArea piece: nrx01",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      554.9791717529297,
      766.4499969482422,
      56
    ],
    "vertices": [
      [
        546.313720703125,
        808,
        27
      ],
      [
        546.313720703125,
        799.7999877929688,
        27
      ],
      [
        532.1715698242188,
        799.7999877929688,
        27
      ],
      [
        532.1715698242188,
        808,
        27
      ],
      [
        565.7156982421875,
        724,
        90
      ],
      [
        565.7156982421875,
        724,
        80
      ],
      [
        575.7156982421875,
        734,
        80
      ],
      [
        575.7156982421875,
        734,
        90
      ]
    ],
    "dimensions": [
      43.54412841796875,
      84,
      63
    ],
    "dimensionsMeters": [
      2.18,
      4.2,
      3.15
    ],
    "maxDimensionMeters": 4.2,
    "pedestalFitScale": 0.381,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/unknown_nrx01.glb"
  },
  {
    "id": "door_melev1",
    "sector": "nrxmov",
    "type": "door",
    "texture": "metrobottom2",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(metrobottom2)",
    "availableSwatches": [
      "metrobottom2",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: melev1",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      539.2426452636719,
      804.7199951171875,
      64.39999847412109
    ],
    "vertices": [
      [
        532.1715698242188,
        799.7999877929688,
        64.5999984741211
      ],
      [
        532.1715698242188,
        808,
        64.5999984741211
      ],
      [
        532.1715698242188,
        808,
        64.5999984741211
      ],
      [
        546.313720703125,
        808,
        64.5999984741211
      ],
      [
        546.313720703125,
        808,
        64.5999984741211
      ],
      [
        546.313720703125,
        799.7999877929688,
        64.5999984741211
      ],
      [
        532.1715698242188,
        808,
        64.0999984741211
      ],
      [
        532.1715698242188,
        799.7999877929688,
        64.0999984741211
      ],
      [
        546.313720703125,
        799.7999877929688,
        64.0999984741211
      ],
      [
        546.313720703125,
        808,
        64.0999984741211
      ]
    ],
    "dimensions": [
      14.14215087890625,
      8.20001220703125,
      0.5
    ],
    "dimensionsMeters": [
      0.71,
      0.41,
      0.15
    ],
    "maxDimensionMeters": 0.71,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_melev1.glb"
  },
  {
    "id": "unknown_C:\\EDITOR\\ground.lwo",
    "sector": "p_in02",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "C:\\EDITOR\\ground.lwo",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      0,
      0,
      0
    ],
    "vertices": [
      [
        -1.5,
        -1.5,
        0
      ],
      [
        1.5,
        1.5,
        0
      ],
      [
        -1.5,
        1.5,
        0
      ],
      [
        1.5,
        -1.5,
        0
      ]
    ],
    "dimensions": [
      3,
      3,
      0
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/unknown_C:\\EDITOR\\ground.lwo.glb"
  },
  {
    "id": "unknown_C:\\EDITOR\\ground.lwo_2",
    "sector": "p_in02",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "C:\\EDITOR\\ground.lwo",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      0,
      0,
      0
    ],
    "vertices": [
      [
        -1.5,
        -1.5,
        0
      ],
      [
        1.5,
        1.5,
        0
      ],
      [
        -1.5,
        1.5,
        0
      ],
      [
        1.5,
        -1.5,
        0
      ]
    ],
    "dimensions": [
      3,
      3,
      0
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideVector": [
      0,
      0,
      -1
    ],
    "file": "props/unknown_C:\\EDITOR\\ground.lwo_2.glb"
  },
  {
    "id": "unknown_C:\\editor\\working\\n_q301.lwo",
    "sector": "q301",
    "type": "unknown",
    "texture": "airpwall1",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.4
    },
    "resolutionTier": 4,
    "resolutionRule": "global_safe_fallback",
    "availableSwatches": [
      "airpwall1"
    ],
    "tag": "C:\\editor\\working\\n_q301.lwo",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      480,
      808,
      466
    ],
    "vertices": [
      [
        420,
        670,
        -5
      ],
      [
        420,
        670,
        1045
      ],
      [
        420,
        400,
        1045
      ],
      [
        420,
        400,
        -5
      ],
      [
        410,
        1100,
        1045
      ],
      [
        630,
        880,
        1045
      ],
      [
        410,
        1100,
        245
      ],
      [
        630,
        880,
        245
      ],
      [
        410,
        1100,
        0
      ],
      [
        630,
        880,
        0
      ]
    ],
    "dimensions": [
      220,
      700,
      1050
    ],
    "dimensionsMeters": [
      11,
      35,
      52.5
    ],
    "maxDimensionMeters": 52.5,
    "pedestalFitScale": 0.03,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/unknown_C:\\editor\\working\\n_q301.lwo.glb"
  },
  {
    "id": "door_elev",
    "sector": "q303",
    "type": "door",
    "texture": "airmetrobottom1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(airmetrobottom1)",
    "availableSwatches": [
      "airmetrobottom1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: elev",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      490,
      294,
      80.5
    ],
    "vertices": [
      [
        495,
        299,
        80
      ],
      [
        485,
        299,
        80
      ],
      [
        495,
        289,
        80
      ],
      [
        485,
        289,
        80
      ],
      [
        485,
        299,
        81
      ],
      [
        495,
        299,
        81
      ],
      [
        495,
        289,
        81
      ],
      [
        485,
        289,
        81
      ]
    ],
    "dimensions": [
      10,
      10,
      1
    ],
    "dimensionsMeters": [
      0.5,
      0.5,
      0.15
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_elev.glb"
  },
  {
    "id": "door_panel1",
    "sector": "q303",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: panel1",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      571.8200073242188,
      373.725341796875,
      110.5
    ],
    "vertices": [
      [
        570.6611938476562,
        370.15887451171875,
        107
      ],
      [
        572.9788208007812,
        377.29180908203125,
        107
      ],
      [
        572.9788208007812,
        377.29180908203125,
        114
      ],
      [
        570.6611938476562,
        370.15887451171875,
        114
      ]
    ],
    "dimensions": [
      2.317626953125,
      7.1329345703125,
      7
    ],
    "dimensionsMeters": [
      0.15,
      0.36,
      0.35
    ],
    "maxDimensionMeters": 0.36,
    "pedestalFitScale": 1.667,
    "slideAxis": "z",
    "slideVector": [
      -0.9511,
      0.309,
      0
    ],
    "file": "props/door_panel1.glb"
  },
  {
    "id": "door_panel2",
    "sector": "q303",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: panel2",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      571.8200073242188,
      426.274658203125,
      110.5
    ],
    "vertices": [
      [
        570.6611938476562,
        429.84112548828125,
        107
      ],
      [
        572.9788208007812,
        422.70819091796875,
        107
      ],
      [
        572.9788208007812,
        422.70819091796875,
        114
      ],
      [
        570.6611938476562,
        429.84112548828125,
        114
      ]
    ],
    "dimensions": [
      2.317626953125,
      7.1329345703125,
      7
    ],
    "dimensionsMeters": [
      0.15,
      0.36,
      0.35
    ],
    "maxDimensionMeters": 0.36,
    "pedestalFitScale": 1.667,
    "slideAxis": "z",
    "slideVector": [
      -0.9511,
      -0.309,
      0
    ],
    "file": "props/door_panel2.glb"
  },
  {
    "id": "door_panel4",
    "sector": "q303",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: panel4",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      407.3574523925781,
      423.89703369140625,
      110.5
    ],
    "vertices": [
      [
        406.1986389160156,
        420.33056640625,
        107
      ],
      [
        408.5162658691406,
        427.4635009765625,
        107
      ],
      [
        408.5162658691406,
        427.4635009765625,
        114
      ],
      [
        406.1986389160156,
        420.33056640625,
        114
      ]
    ],
    "dimensions": [
      2.317626953125,
      7.1329345703125,
      7
    ],
    "dimensionsMeters": [
      0.15,
      0.36,
      0.35
    ],
    "maxDimensionMeters": 0.36,
    "pedestalFitScale": 1.667,
    "slideAxis": "z",
    "slideVector": [
      0.9511,
      -0.309,
      0
    ],
    "file": "props/door_panel4.glb"
  },
  {
    "id": "door_panel5",
    "sector": "q303",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: panel5",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      407.3574523925781,
      376.10296630859375,
      110.5
    ],
    "vertices": [
      [
        406.1986389160156,
        379.66943359375,
        107
      ],
      [
        408.5162658691406,
        372.5364990234375,
        107
      ],
      [
        408.5162658691406,
        372.5364990234375,
        114
      ],
      [
        406.1986389160156,
        379.66943359375,
        114
      ]
    ],
    "dimensions": [
      2.317626953125,
      7.1329345703125,
      7
    ],
    "dimensionsMeters": [
      0.15,
      0.36,
      0.35
    ],
    "maxDimensionMeters": 0.36,
    "pedestalFitScale": 1.667,
    "slideAxis": "z",
    "slideVector": [
      0.9511,
      0.309,
      0
    ],
    "file": "props/door_panel5.glb"
  },
  {
    "id": "door_panel3",
    "sector": "q303",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: panel3",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      488.75,
      499.8794860839844,
      110.5
    ],
    "vertices": [
      [
        485,
        499.8794860839844,
        107
      ],
      [
        492.5,
        499.8794860839844,
        107
      ],
      [
        492.5,
        499.8794860839844,
        114
      ],
      [
        485,
        499.8794860839844,
        114
      ]
    ],
    "dimensions": [
      7.5,
      0,
      7
    ],
    "dimensionsMeters": [
      0.38,
      0.15,
      0.35
    ],
    "maxDimensionMeters": 0.38,
    "pedestalFitScale": 1.579,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_panel3.glb"
  },
  {
    "id": "door_panel6",
    "sector": "q303",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: panel6",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      488.75,
      305.10052490234375,
      110.5
    ],
    "vertices": [
      [
        485,
        305.10052490234375,
        107
      ],
      [
        492.5,
        305.10052490234375,
        114
      ],
      [
        492.5,
        305.10052490234375,
        107
      ],
      [
        485,
        305.10052490234375,
        114
      ]
    ],
    "dimensions": [
      7.5,
      0,
      7
    ],
    "dimensionsMeters": [
      0.38,
      0.15,
      0.35
    ],
    "maxDimensionMeters": 0.38,
    "pedestalFitScale": 1.579,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_panel6.glb"
  },
  {
    "id": "door_drt2",
    "sector": "q304",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: drt2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1125,
      749.5,
      185
    ],
    "vertices": [
      [
        1120,
        750,
        180
      ],
      [
        1120,
        750,
        190
      ],
      [
        1120,
        749,
        190
      ],
      [
        1120,
        749,
        180
      ],
      [
        1130,
        750,
        180
      ],
      [
        1130,
        749,
        180
      ],
      [
        1130,
        749,
        190
      ],
      [
        1130,
        750,
        190
      ]
    ],
    "dimensions": [
      10,
      1,
      10
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_drt2.glb"
  },
  {
    "id": "door_lockerdr",
    "sector": "q304",
    "type": "door",
    "texture": "hotkitcab_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(hotkitcab_h)",
    "availableSwatches": [
      "hotkitcab_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: lockerdr",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      1280.2,
      757.5,
      189
    ],
    "vertices": [
      [
        1280,
        755,
        185
      ],
      [
        1280,
        760,
        185
      ],
      [
        1280,
        755,
        185
      ],
      [
        1280.5,
        755,
        185
      ],
      [
        1280.5,
        760,
        185
      ],
      [
        1280,
        760,
        185
      ],
      [
        1280,
        760,
        195
      ],
      [
        1280.5,
        760,
        195
      ],
      [
        1280.5,
        755,
        195
      ],
      [
        1280,
        755,
        195
      ]
    ],
    "dimensions": [
      0.5,
      5,
      10
    ],
    "dimensionsMeters": [
      0.15,
      0.25,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_lockerdr.glb"
  },
  {
    "id": "elevator_elev1",
    "sector": "q306",
    "type": "elevator",
    "texture": "cbaseelevpaneldown",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpaneldown)",
    "availableSwatches": [
      "cbaseelevpaneldown",
      "baseelev1",
      "cbaseelevdoor",
      "cbaseelevpanelup",
      "elevatorlight1",
      "elevatorlight1out",
      "elevatorpanel2",
      "elevatorshaft",
      "elevatorshaftout",
      "emielevstripe_h",
      "gcelevtrak_h",
      "hangelevswitch",
      "hospelevdoor",
      "hotelevbut_h",
      "hotelevout_h",
      "hotelevpaneldown",
      "hotelevpanelup",
      "hotvaselev_h",
      "mineelevpanelup",
      "minepipelev",
      "reselevshaft",
      "spkelevdoor1",
      "spkelevfloor1"
    ],
    "tag": "CElevator piece: elev1",
    "sourceVertexCount": 18,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      615,
      1320.9936930338542,
      81.55555555555556
    ],
    "vertices": [
      [
        620,
        1314.3714599609375,
        80
      ],
      [
        620,
        1314.3714599609375,
        80
      ],
      [
        610,
        1314.3714599609375,
        80
      ],
      [
        610,
        1314.3714599609375,
        80
      ],
      [
        620,
        1324.3714599609375,
        80
      ],
      [
        610,
        1324.3714599609375,
        80
      ],
      [
        620,
        1314.3714599609375,
        80.5
      ],
      [
        610,
        1314.3714599609375,
        80.5
      ],
      [
        610,
        1324.3714599609375,
        80.5
      ],
      [
        620,
        1324.3714599609375,
        80.5
      ],
      [
        613,
        1324.271484375,
        80.5
      ],
      [
        615,
        1324.271484375,
        80.5
      ],
      [
        617,
        1324.271484375,
        86
      ],
      [
        615,
        1324.271484375,
        86
      ],
      [
        617,
        1324.271484375,
        80.5
      ],
      [
        615,
        1324.271484375,
        80.5
      ],
      [
        613,
        1324.271484375,
        86
      ],
      [
        615,
        1324.271484375,
        86
      ]
    ],
    "dimensions": [
      10,
      10,
      6
    ],
    "dimensionsMeters": [
      0.5,
      0.5,
      0.3
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/elevator_elev1.glb"
  },
  {
    "id": "breakable_q306",
    "sector": "q306",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      615,
      1324.3714599609375,
      535
    ],
    "vertices": [
      [
        612,
        1324.3714599609375,
        530
      ],
      [
        612,
        1324.3714599609375,
        540
      ],
      [
        618,
        1324.3714599609375,
        540
      ],
      [
        618,
        1324.3714599609375,
        530
      ]
    ],
    "dimensions": [
      6,
      0,
      10
    ],
    "dimensionsMeters": [
      0.3,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/breakable_q306.glb"
  },
  {
    "id": "door_timerPOL",
    "sector": "q306",
    "type": "door",
    "texture": "airlobbyflrbrn1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(airlobbyflrbrn1)",
    "availableSwatches": [
      "airlobbyflrbrn1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: timerPOL",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      656,
      1227.5,
      520.0499877929688
    ],
    "vertices": [
      [
        653,
        1224,
        520.0499877929688
      ],
      [
        659,
        1231,
        520.0499877929688
      ],
      [
        653,
        1231,
        520.0499877929688
      ],
      [
        659,
        1224,
        520.0499877929688
      ]
    ],
    "dimensions": [
      6,
      7,
      0
    ],
    "dimensionsMeters": [
      0.3,
      0.35,
      0.15
    ],
    "maxDimensionMeters": 0.35,
    "pedestalFitScale": 1.714,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_timerPOL.glb"
  },
  {
    "id": "door_cabf",
    "sector": "q311",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: cabf",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      385,
      1495,
      87.5
    ],
    "vertices": [
      [
        380,
        1495,
        80
      ],
      [
        390,
        1495,
        80
      ],
      [
        390,
        1495,
        95
      ],
      [
        380,
        1495,
        95
      ]
    ],
    "dimensions": [
      10,
      0,
      15
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_cabf.glb"
  },
  {
    "id": "door_dr1-02",
    "sector": "q311",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: dr1-02",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      385,
      1470.5,
      145
    ],
    "vertices": [
      [
        380,
        1471,
        140
      ],
      [
        380,
        1471,
        150
      ],
      [
        380,
        1470,
        140
      ],
      [
        380,
        1470,
        150
      ],
      [
        390,
        1471,
        150
      ],
      [
        390,
        1471,
        140
      ],
      [
        390,
        1470,
        140
      ],
      [
        390,
        1470,
        150
      ]
    ],
    "dimensions": [
      10,
      1,
      10
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_dr1-02.glb"
  },
  {
    "id": "door_dr1-03",
    "sector": "q311",
    "type": "door",
    "texture": "spkelevdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkelevdoor1)",
    "availableSwatches": [
      "spkelevdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: dr1-03",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      385,
      1470.5,
      195
    ],
    "vertices": [
      [
        380,
        1471,
        190
      ],
      [
        380,
        1471,
        200
      ],
      [
        380,
        1470,
        190
      ],
      [
        380,
        1470,
        200
      ],
      [
        390,
        1471,
        200
      ],
      [
        390,
        1471,
        190
      ],
      [
        390,
        1470,
        190
      ],
      [
        390,
        1470,
        200
      ]
    ],
    "dimensions": [
      10,
      1,
      10
    ],
    "dimensionsMeters": [
      0.5,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_dr1-03.glb"
  },
  {
    "id": "door_rech_q311",
    "sector": "q311",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rech",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      419.8999938964844,
      1551.25,
      84
    ],
    "vertices": [
      [
        419.8999938964844,
        1550,
        83
      ],
      [
        419.8999938964844,
        1552.5,
        85
      ],
      [
        419.8999938964844,
        1550,
        85
      ],
      [
        419.8999938964844,
        1552.5,
        83
      ]
    ],
    "dimensions": [
      0,
      2.5,
      2
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "z",
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_rech_q311.glb"
  },
  {
    "id": "door_datapoly",
    "sector": "sub05",
    "type": "door",
    "texture": "chkcemt-d_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkcemt-d_h)",
    "availableSwatches": [
      "chkcemt-d_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: datapoly",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -203.0314483642578,
      -2403.5,
      577.5047607421875
    ],
    "vertices": [
      [
        -198.0314483642578,
        -2434,
        577.5047607421875
      ],
      [
        -208.0314483642578,
        -2434,
        577.5047607421875
      ],
      [
        -208.0314483642578,
        -2373,
        577.5047607421875
      ],
      [
        -198.0314483642578,
        -2373,
        577.5047607421875
      ]
    ],
    "dimensions": [
      10,
      61,
      0
    ],
    "dimensionsMeters": [
      0.5,
      3.05,
      0.15
    ],
    "maxDimensionMeters": 3.05,
    "pedestalFitScale": 0.525,
    "slideAxis": "z",
    "slideVector": [
      0,
      0,
      1
    ],
    "file": "props/door_datapoly.glb"
  },
  {
    "id": "door_lauch1",
    "sector": "training",
    "type": "door",
    "texture": "spkgums1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkgums1)",
    "availableSwatches": [
      "spkgums1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: lauch1",
    "sourceVertexCount": 7,
    "exportedTriangleCount": 10,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3488,
      -3150,
      1192.4285714285713
    ],
    "vertices": [
      [
        -3491,
        -3162.3408203125,
        1193
      ],
      [
        -3498,
        -3150,
        1193
      ],
      [
        -3491,
        -3137.6591796875,
        1193
      ],
      [
        -3484,
        -3137.6591796875,
        1193
      ],
      [
        -3484,
        -3162.3408203125,
        1193
      ],
      [
        -3484,
        -3162.3408203125,
        1191
      ],
      [
        -3484,
        -3137.6591796875,
        1191
      ]
    ],
    "dimensions": [
      14,
      24.681640625,
      2
    ],
    "dimensionsMeters": [
      0.7,
      1.23,
      0.15
    ],
    "maxDimensionMeters": 1.23,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_lauch1.glb"
  },
  {
    "id": "door_launch2",
    "sector": "training",
    "type": "door",
    "texture": "spkgums1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkgums1)",
    "availableSwatches": [
      "spkgums1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: launch2",
    "sourceVertexCount": 7,
    "exportedTriangleCount": 10,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3480,
      -3150,
      1192.4285714285713
    ],
    "vertices": [
      [
        -3470,
        -3150,
        1193
      ],
      [
        -3477,
        -3162.3408203125,
        1193
      ],
      [
        -3477,
        -3137.6591796875,
        1193
      ],
      [
        -3484,
        -3137.6591796875,
        1193
      ],
      [
        -3484,
        -3162.3408203125,
        1193
      ],
      [
        -3484,
        -3162.3408203125,
        1191
      ],
      [
        -3484,
        -3137.6591796875,
        1191
      ]
    ],
    "dimensions": [
      14,
      24.681640625,
      2
    ],
    "dimensionsMeters": [
      0.7,
      1.23,
      0.15
    ],
    "maxDimensionMeters": 1.23,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_launch2.glb"
  },
  {
    "id": "door_launchdr",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: launchdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3484,
      -3204,
      1202.5
    ],
    "vertices": [
      [
        -3491,
        -3203,
        1195
      ],
      [
        -3477,
        -3203,
        1210
      ],
      [
        -3491,
        -3203,
        1210
      ],
      [
        -3477,
        -3203,
        1195
      ],
      [
        -3491,
        -3205,
        1195
      ],
      [
        -3477,
        -3205,
        1210
      ],
      [
        -3491,
        -3205,
        1210
      ],
      [
        -3477,
        -3205,
        1195
      ]
    ],
    "dimensions": [
      14,
      2,
      15
    ],
    "dimensionsMeters": [
      0.7,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideDirection": -1,
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_launchdr.glb"
  },
  {
    "id": "door_swimdr",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: swimdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3484,
      -3330.699951171875,
      1202.5
    ],
    "vertices": [
      [
        -3491,
        -3329.699951171875,
        1195
      ],
      [
        -3477,
        -3329.699951171875,
        1210
      ],
      [
        -3491,
        -3329.699951171875,
        1210
      ],
      [
        -3477,
        -3329.699951171875,
        1195
      ],
      [
        -3491,
        -3331.699951171875,
        1195
      ],
      [
        -3477,
        -3331.699951171875,
        1210
      ],
      [
        -3491,
        -3331.699951171875,
        1210
      ],
      [
        -3477,
        -3331.699951171875,
        1195
      ]
    ],
    "dimensions": [
      14,
      2,
      15
    ],
    "dimensionsMeters": [
      0.7,
      0.15,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideDirection": -1,
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_swimdr.glb"
  },
  {
    "id": "door_targetdr",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: targetdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3525,
      -3312.5,
      1202.5
    ],
    "vertices": [
      [
        -3526,
        -3320,
        1195
      ],
      [
        -3526,
        -3305,
        1210
      ],
      [
        -3526,
        -3320,
        1210
      ],
      [
        -3526,
        -3305,
        1195
      ],
      [
        -3524,
        -3320,
        1195
      ],
      [
        -3524,
        -3305,
        1210
      ],
      [
        -3524,
        -3320,
        1210
      ],
      [
        -3524,
        -3305,
        1195
      ]
    ],
    "dimensions": [
      2,
      15,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.75,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_targetdr.glb"
  },
  {
    "id": "door_circutdr",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circutdr",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3443,
      -3312.5,
      1202.5
    ],
    "vertices": [
      [
        -3444,
        -3320,
        1195
      ],
      [
        -3444,
        -3305,
        1210
      ],
      [
        -3444,
        -3320,
        1210
      ],
      [
        -3444,
        -3305,
        1195
      ],
      [
        -3442,
        -3320,
        1195
      ],
      [
        -3442,
        -3305,
        1210
      ],
      [
        -3442,
        -3320,
        1210
      ],
      [
        -3442,
        -3305,
        1195
      ]
    ],
    "dimensions": [
      2,
      15,
      15
    ],
    "dimensionsMeters": [
      0.15,
      0.75,
      0.75
    ],
    "maxDimensionMeters": 0.75,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/door_circutdr.glb"
  },
  {
    "id": "door_win1_training",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: win1",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3585,
      -3282.5,
      1205
    ],
    "vertices": [
      [
        -3585,
        -3288,
        1198.5
      ],
      [
        -3585,
        -3288,
        1211.5
      ],
      [
        -3585,
        -3277,
        1211.5
      ],
      [
        -3585,
        -3277,
        1198.5
      ]
    ],
    "dimensions": [
      0,
      11,
      13
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_win1_training.glb"
  },
  {
    "id": "door_win2",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: win2",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3585,
      -3297.5,
      1205
    ],
    "vertices": [
      [
        -3585,
        -3303,
        1211.5
      ],
      [
        -3585,
        -3303,
        1198.5
      ],
      [
        -3585,
        -3292,
        1211.5
      ],
      [
        -3585,
        -3292,
        1198.5
      ]
    ],
    "dimensions": [
      0,
      11,
      13
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_win2.glb"
  },
  {
    "id": "door_win3",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: win3",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3585,
      -3312.5,
      1205
    ],
    "vertices": [
      [
        -3585,
        -3318,
        1211.5
      ],
      [
        -3585,
        -3318,
        1198.5
      ],
      [
        -3585,
        -3307,
        1211.5
      ],
      [
        -3585,
        -3307,
        1198.5
      ]
    ],
    "dimensions": [
      0,
      11,
      13
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_win3.glb"
  },
  {
    "id": "door_win4",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: win4",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3585,
      -3327.5,
      1205
    ],
    "vertices": [
      [
        -3585,
        -3333,
        1198.5
      ],
      [
        -3585,
        -3333,
        1211.5
      ],
      [
        -3585,
        -3322,
        1211.5
      ],
      [
        -3585,
        -3322,
        1198.5
      ]
    ],
    "dimensions": [
      0,
      11,
      13
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_win4.glb"
  },
  {
    "id": "breakable_training",
    "sector": "training",
    "type": "breakable",
    "texture": "chkcrate-s_h",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(chkcrate-s_h)",
    "availableSwatches": [
      "chkcrate-s_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-f_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3623.050048828125,
      -3344.39990234375,
      1208
    ],
    "vertices": [
      [
        -3625.300048828125,
        -3346.89990234375,
        1205.25
      ],
      [
        -3625.300048828125,
        -3341.89990234375,
        1210.75
      ],
      [
        -3625.300048828125,
        -3346.89990234375,
        1210.75
      ],
      [
        -3625.300048828125,
        -3341.89990234375,
        1205.25
      ],
      [
        -3620.800048828125,
        -3346.89990234375,
        1205.25
      ],
      [
        -3620.800048828125,
        -3341.89990234375,
        1210.75
      ],
      [
        -3620.800048828125,
        -3346.89990234375,
        1210.75
      ],
      [
        -3620.800048828125,
        -3341.89990234375,
        1205.25
      ]
    ],
    "dimensions": [
      4.5,
      5,
      5.5
    ],
    "dimensionsMeters": [
      0.23,
      0.25,
      0.28
    ],
    "maxDimensionMeters": 0.28,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -1,
      0,
      0
    ],
    "file": "props/breakable_training.glb"
  },
  {
    "id": "door_circdr1",
    "sector": "training",
    "type": "door",
    "texture": "spkdoor1",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1)",
    "availableSwatches": [
      "spkdoor1",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circdr1",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3404.00927734375,
      -3325.2705078125,
      1200
    ],
    "vertices": [
      [
        -3402.3154296875,
        -3322.44970703125,
        1205
      ],
      [
        -3405.241455078125,
        -3328.317138671875,
        1205
      ],
      [
        -3405.703125,
        -3328.09130859375,
        1205
      ],
      [
        -3402.777099609375,
        -3322.223876953125,
        1205
      ],
      [
        -3402.3154296875,
        -3322.44970703125,
        1195
      ],
      [
        -3402.777099609375,
        -3322.223876953125,
        1195
      ],
      [
        -3405.703125,
        -3328.09130859375,
        1195
      ],
      [
        -3405.241455078125,
        -3328.317138671875,
        1195
      ]
    ],
    "dimensions": [
      3.3876953125,
      6.09326171875,
      10
    ],
    "dimensionsMeters": [
      0.17,
      0.3,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      0.8949,
      -0.4463,
      0
    ],
    "file": "props/door_circdr1.glb"
  },
  {
    "id": "door_circdr2",
    "sector": "training",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circdr2",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3403.79443359375,
      -3339.07568359375,
      1200
    ],
    "vertices": [
      [
        -3404.9873046875,
        -3336.08740234375,
        1205
      ],
      [
        -3402.153076171875,
        -3341.843017578125,
        1205
      ],
      [
        -3402.6015625,
        -3342.06396484375,
        1205
      ],
      [
        -3405.435791015625,
        -3336.308349609375,
        1205
      ],
      [
        -3404.9873046875,
        -3336.08740234375,
        1195
      ],
      [
        -3405.435791015625,
        -3336.308349609375,
        1195
      ],
      [
        -3402.6015625,
        -3342.06396484375,
        1195
      ],
      [
        -3402.153076171875,
        -3341.843017578125,
        1195
      ]
    ],
    "dimensions": [
      3.28271484375,
      5.9765625,
      10
    ],
    "dimensionsMeters": [
      0.16,
      0.3,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      0.8971,
      0.4418,
      0
    ],
    "file": "props/door_circdr2.glb"
  },
  {
    "id": "door_circdr3",
    "sector": "training",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circdr3",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3394.644287109375,
      -3345.807373046875,
      1200
    ],
    "vertices": [
      [
        -3397.85302734375,
        -3345.552490234375,
        1205
      ],
      [
        -3391.4375,
        -3345.552490234375,
        1205
      ],
      [
        -3391.435546875,
        -3346.062255859375,
        1205
      ],
      [
        -3397.85107421875,
        -3346.062255859375,
        1205
      ],
      [
        -3397.85302734375,
        -3345.552490234375,
        1195
      ],
      [
        -3397.85107421875,
        -3346.062255859375,
        1195
      ],
      [
        -3391.435546875,
        -3346.062255859375,
        1195
      ],
      [
        -3391.4375,
        -3345.552490234375,
        1195
      ]
    ],
    "dimensions": [
      6.41748046875,
      0.509765625,
      10
    ],
    "dimensionsMeters": [
      0.32,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideDirection": -1,
    "slideVector": [
      0,
      1,
      0
    ],
    "file": "props/door_circdr3.glb"
  },
  {
    "id": "door_circdr5",
    "sector": "training",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circdr5",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3383.71044921875,
      -3324.88818359375,
      1197
    ],
    "vertices": [
      [
        -3381.84814453125,
        -3327.983154296875,
        1199
      ],
      [
        -3381.386962890625,
        -3327.659912109375,
        1199
      ],
      [
        -3385.57275390625,
        -3321.793212890625,
        1199
      ],
      [
        -3386.033935546875,
        -3322.116455078125,
        1199
      ],
      [
        -3381.84814453125,
        -3327.983154296875,
        1195
      ],
      [
        -3381.386962890625,
        -3327.659912109375,
        1195
      ],
      [
        -3385.57275390625,
        -3321.793212890625,
        1195
      ],
      [
        -3386.033935546875,
        -3322.116455078125,
        1195
      ]
    ],
    "dimensions": [
      4.64697265625,
      6.18994140625,
      4
    ],
    "dimensionsMeters": [
      0.23,
      0.31,
      0.2
    ],
    "maxDimensionMeters": 0.31,
    "pedestalFitScale": 1.935,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -0.814,
      -0.5808,
      0
    ],
    "file": "props/door_circdr5.glb"
  },
  {
    "id": "door_circdr6",
    "sector": "training",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circdr6",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3394.644287109375,
      -3318.192626953125,
      1200
    ],
    "vertices": [
      [
        -3397.85107421875,
        -3317.937744140625,
        1205
      ],
      [
        -3397.85302734375,
        -3318.447509765625,
        1205
      ],
      [
        -3391.4375,
        -3318.447509765625,
        1205
      ],
      [
        -3391.435546875,
        -3317.937744140625,
        1205
      ],
      [
        -3397.85302734375,
        -3318.447509765625,
        1195
      ],
      [
        -3391.4375,
        -3318.447509765625,
        1195
      ],
      [
        -3391.435546875,
        -3317.937744140625,
        1195
      ],
      [
        -3397.85107421875,
        -3317.937744140625,
        1195
      ]
    ],
    "dimensions": [
      6.41748046875,
      0.509765625,
      10
    ],
    "dimensionsMeters": [
      0.32,
      0.15,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "z",
    "slideDirection": 1,
    "slideVector": [
      0,
      -1,
      0
    ],
    "file": "props/door_circdr6.glb"
  },
  {
    "id": "door_circdr4",
    "sector": "training",
    "type": "door",
    "texture": "spkdoor1nkd",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(spkdoor1nkd)",
    "availableSwatches": [
      "spkdoor1nkd",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkdoorsec_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: circdr4",
    "sourceVertexCount": 8,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3383.71044921875,
      -3339.11181640625,
      1200
    ],
    "vertices": [
      [
        -3381.84814453125,
        -3336.016845703125,
        1205
      ],
      [
        -3381.386962890625,
        -3336.340087890625,
        1205
      ],
      [
        -3385.57275390625,
        -3342.206787109375,
        1205
      ],
      [
        -3386.033935546875,
        -3341.883544921875,
        1205
      ],
      [
        -3381.84814453125,
        -3336.016845703125,
        1195
      ],
      [
        -3386.033935546875,
        -3341.883544921875,
        1195
      ],
      [
        -3385.57275390625,
        -3342.206787109375,
        1195
      ],
      [
        -3381.386962890625,
        -3336.340087890625,
        1195
      ]
    ],
    "dimensions": [
      4.64697265625,
      6.18994140625,
      10
    ],
    "dimensionsMeters": [
      0.23,
      0.31,
      0.5
    ],
    "maxDimensionMeters": 0.5,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -0.814,
      0.5808,
      0
    ],
    "file": "props/door_circdr4.glb"
  },
  {
    "id": "breakable_2_training",
    "sector": "training",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3609,
      -3283.0977783203125,
      1204.25
    ],
    "vertices": [
      [
        -3609,
        -3286,
        1197
      ],
      [
        -3609,
        -3280.195556640625,
        1211.5
      ],
      [
        -3609,
        -3286,
        1211.5
      ],
      [
        -3609,
        -3280.195556640625,
        1197
      ]
    ],
    "dimensions": [
      0,
      5.804443359375,
      14.5
    ],
    "dimensionsMeters": [
      0.15,
      0.29,
      0.73
    ],
    "maxDimensionMeters": 0.73,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/breakable_2_training.glb"
  },
  {
    "id": "breakable_3_training",
    "sector": "training",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3640,
      -3298.0977783203125,
      1184.25
    ],
    "vertices": [
      [
        -3640,
        -3301,
        1177
      ],
      [
        -3640,
        -3295.195556640625,
        1191.5
      ],
      [
        -3640,
        -3301,
        1191.5
      ],
      [
        -3640,
        -3295.195556640625,
        1177
      ]
    ],
    "dimensions": [
      0,
      5.804443359375,
      14.5
    ],
    "dimensionsMeters": [
      0.15,
      0.29,
      0.73
    ],
    "maxDimensionMeters": 0.73,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/breakable_3_training.glb"
  },
  {
    "id": "breakable_4_training",
    "sector": "training",
    "type": "breakable",
    "texture": "chkcrate-f_h",
    "materialDescriptor": {
      "roughness": 0.5,
      "metalness": 0.3
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(breakable)",
    "availableSwatches": [
      "chkcrate-f_h",
      "ammocrate-f",
      "ammocrate-s",
      "ammocrate-t",
      "box_code1_on",
      "box_code2_on",
      "box_code3_on",
      "box_code4_on",
      "box_code5_on",
      "box_code9_on",
      "boxfloorgrn",
      "boxing3",
      "boxinggridnew2",
      "boxinglight1",
      "boxingwall",
      "boxingwallm",
      "boxingwallm-lit",
      "boxlite-f00",
      "chkcrate-s_h",
      "chkcratelab_h",
      "cratetop-l",
      "dockcrate1",
      "dockcrate2",
      "mineblock",
      "termineblockade"
    ],
    "tag": "CBreakableObject piece: ",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3648,
      -3312.5977783203125,
      1225.75
    ],
    "vertices": [
      [
        -3648,
        -3315.5,
        1233
      ],
      [
        -3648,
        -3309.695556640625,
        1218.5
      ],
      [
        -3648,
        -3315.5,
        1218.5
      ],
      [
        -3648,
        -3309.695556640625,
        1233
      ]
    ],
    "dimensions": [
      0,
      5.804443359375,
      14.5
    ],
    "dimensionsMeters": [
      0.15,
      0.29,
      0.73
    ],
    "maxDimensionMeters": 0.73,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/breakable_4_training.glb"
  },
  {
    "id": "door_mvtarget",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: mvtarget",
    "sourceVertexCount": 12,
    "exportedTriangleCount": 16,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3674.97607421875,
      -3332.062052408854,
      1195.537618001302
    ],
    "vertices": [
      [
        -3675.215087890625,
        -3332.630859375,
        1195
      ],
      [
        -3675.215087890625,
        -3331.48388671875,
        1195.2867431640625
      ],
      [
        -3675.215087890625,
        -3332.630859375,
        1195.2867431640625
      ],
      [
        -3675.215087890625,
        -3331.48388671875,
        1195
      ],
      [
        -3674.713134765625,
        -3332.630859375,
        1195
      ],
      [
        -3674.713134765625,
        -3331.48388671875,
        1195.2867431640625
      ],
      [
        -3674.713134765625,
        -3332.630859375,
        1195.2867431640625
      ],
      [
        -3674.713134765625,
        -3331.48388671875,
        1195
      ],
      [
        -3675,
        -3332.487548828125,
        1195.2867431640625
      ],
      [
        -3675,
        -3331.6552734375,
        1197.365478515625
      ],
      [
        -3675,
        -3332.487548828125,
        1197.365478515625
      ],
      [
        -3675,
        -3331.6552734375,
        1195.2867431640625
      ]
    ],
    "dimensions": [
      0.501953125,
      1.14697265625,
      2.365478515625
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_mvtarget.glb"
  },
  {
    "id": "door_win5",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: win5",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 12,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3585,
      -3342.5,
      1205
    ],
    "vertices": [
      [
        -3585,
        -3348,
        1198.5
      ],
      [
        -3585,
        -3348,
        1211.5
      ],
      [
        -3585,
        -3337,
        1211.5
      ],
      [
        -3585,
        -3337,
        1198.5
      ]
    ],
    "dimensions": [
      0,
      11,
      13
    ],
    "dimensionsMeters": [
      0.15,
      0.55,
      0.65
    ],
    "maxDimensionMeters": 0.65,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": -1,
    "slideVector": [
      1,
      0,
      0
    ],
    "file": "props/door_win5.glb"
  },
  {
    "id": "elevator",
    "sector": "training",
    "type": "elevator",
    "texture": "cbaseelevpaneldown",
    "materialDescriptor": {
      "roughness": 0.4,
      "metalness": 0.5
    },
    "resolutionTier": 0,
    "resolutionRule": "embedded_source_texture(cbaseelevpaneldown)",
    "availableSwatches": [
      "cbaseelevpaneldown",
      "baseelev1",
      "cbaseelevdoor",
      "cbaseelevpanelup",
      "elevatorlight1",
      "elevatorlight1out",
      "elevatorpanel2",
      "elevatorshaft",
      "elevatorshaftout",
      "emielevstripe_h",
      "gcelevtrak_h",
      "hangelevswitch",
      "hospelevdoor",
      "hotelevbut_h",
      "hotelevout_h",
      "hotelevpaneldown",
      "hotelevpanelup",
      "hotvaselev_h",
      "mineelevpanelup",
      "minepipelev",
      "reselevshaft",
      "spkelevdoor1",
      "spkelevfloor1"
    ],
    "tag": "CElevator piece: ",
    "sourceVertexCount": 10,
    "exportedTriangleCount": 10,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3364.956689453125,
      -3348.633544921875,
      1196.2
    ],
    "vertices": [
      [
        -3369.464111328125,
        -3340.669921875,
        1195
      ],
      [
        -3374.214111328125,
        -3348.897216796875,
        1195
      ],
      [
        -3364.229736328125,
        -3351.272705078125,
        1195
      ],
      [
        -3363.229736328125,
        -3349.54052734375,
        1199
      ],
      [
        -3363.229736328125,
        -3349.54052734375,
        1195
      ],
      [
        -3364.229736328125,
        -3351.272705078125,
        1199
      ],
      [
        -3362.229736328125,
        -3347.80859375,
        1195
      ],
      [
        -3362.229736328125,
        -3347.80859375,
        1199
      ],
      [
        -3365.630126953125,
        -3353.8759765625,
        1195
      ],
      [
        -3360.880126953125,
        -3345.648681640625,
        1195
      ]
    ],
    "dimensions": [
      13.333984375,
      13.2060546875,
      4
    ],
    "dimensionsMeters": [
      0.67,
      0.66,
      0.2
    ],
    "maxDimensionMeters": 0.67,
    "pedestalFitScale": 1,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -0.866,
      0.5,
      0
    ],
    "file": "props/elevator.glb"
  },
  {
    "id": "door_rech1",
    "sector": "training",
    "type": "door",
    "texture": "chkdoorsec_h",
    "materialDescriptor": {
      "roughness": 0.3,
      "metalness": 0.7
    },
    "resolutionTier": 3,
    "resolutionRule": "archetype_default(door)",
    "availableSwatches": [
      "chkdoorsec_h",
      "basegatedoor",
      "cbasedoor1",
      "cbasedoor1grn",
      "cbasedoor1nopad",
      "cbaseelevdoor",
      "chkdoorlab_h",
      "chkptdoor1",
      "chksecdoorshut_h",
      "doorjam",
      "hospdoor3",
      "hospdoorl1",
      "hospelevdoor",
      "hotdoor1201_h",
      "hotdoor1203_h",
      "hotdoor1205_h",
      "hotdoor1207_h",
      "hotdoor1209_h",
      "hotdoor1211_h",
      "hotdoor1501_h",
      "hotdoor1502_h",
      "hotdoor1503_h",
      "hotdoor1504_h",
      "hotdoor1505_h",
      "hotdoor1506_h",
      "hotdoor1507_h",
      "hotdoor1508_h",
      "hotdoor1509_h",
      "hotdoor1510_h",
      "hotdoor1511_h",
      "hotdoor1512_h",
      "hotdoor1513_h",
      "hotdoor1514_h",
      "hotdoor1515_h",
      "hotdoor1516_h",
      "hotdoor2201_h",
      "hotdoor2203_h",
      "hotdoor2205_h",
      "hotgoldoor_h",
      "hotgoldoorpan_h",
      "minedoor1",
      "piperoomdoor",
      "prigatewall2_h",
      "securitydoor0",
      "securitydoor1",
      "securitydoor2",
      "slidedoor1",
      "slidedoor3",
      "spkdoor1",
      "spkdoor1nkd",
      "spkelevdoor1",
      "tergatecenter_h",
      "tergatecol-d_h",
      "tergatesheet_h",
      "tergatewall-d_h",
      "tergatewall2_h",
      "tergatewall5_h",
      "warehousedoor1"
    ],
    "tag": "CSlidingDoor piece: rech1",
    "sourceVertexCount": 4,
    "exportedTriangleCount": 4,
    "hullFellBackToBoundingBox": false,
    "centroid": [
      -3363.3192138671875,
      -3314.400146484375,
      1199
    ],
    "vertices": [
      [
        -3362.568603515625,
        -3315.7001953125,
        1198
      ],
      [
        -3362.568603515625,
        -3315.7001953125,
        1200
      ],
      [
        -3364.06982421875,
        -3313.10009765625,
        1200
      ],
      [
        -3364.06982421875,
        -3313.10009765625,
        1198
      ]
    ],
    "dimensions": [
      1.501220703125,
      2.60009765625,
      2
    ],
    "dimensionsMeters": [
      0.15,
      0.15,
      0.15
    ],
    "maxDimensionMeters": 0.15,
    "pedestalFitScale": 2,
    "slideAxis": "x",
    "slideDirection": 1,
    "slideVector": [
      -0.866,
      -0.5,
      0
    ],
    "file": "props/door_rech1.glb"
  }
]